/* eslint-disable */
/* tslint:disable */
/**
 * This file was automatically generated by infrastructure/scripts/buildSchema.mjs.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema,
 * and run 'yarn build:schema' to regenerate this file.
 *
 * Author:
 * Samuel Batista (sbatista@salesforce.com)
 */
/**
 * Performs a deep merge of objects and returns new object. Does not modify
 * objects (immutable) and merges arrays via concatenation.
 * https://stackoverflow.com/a/48218209/15101549
 */
export function merge(...objects) {
    return objects.reduce((prev, obj) => {
        Object.keys(obj).forEach((key) => {
            const pVal = prev[key];
            const oVal = obj[key];
            const pType = Object.prototype.toString.call(pVal);
            const oType = Object.prototype.toString.call(oVal);
            if (pType === '[object Array]' && oType === '[object Array]') {
                prev[key] = pVal.concat(...oVal);
            }
            else if (pType === '[object Object]' && oType === '[object Object]') {
                prev[key] = merge(pVal, oVal);
            }
            else {
                prev[key] = oVal;
            }
        });
        return prev;
    }, Array.isArray(objects[0]) ? [] : {});
}
export const schemas = {
    oafv1: {
        get: () => ({
            $id: 'oafv1',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'OAFSchema',
            anyOf: [schemas['oaf-dto-v1'].get(), schemas['oaf-projection-v1'].get()],
        }),
        new: (override) => {
            const original = null;
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'oaf-dto-v1': {
        get: () => ({
            $id: 'oaf-dto-v1',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'OAFDto',
            anyOf: [
                schemas['dtos/ErrorCodes'].get(),
                schemas['dtos/FeatureFlags'].get(),
                schemas['dtos/EventModel'].get(),
                schemas['dtos/GetProjectionResult'].get(),
                schemas['dtos/GetSolutionsWithSecReview'].get(),
                schemas['dtos/GetSolutionsWithApprovalDate'].get(),
                schemas['dtos/GetSolutionsStreamWithSecReview'].get(),
                schemas['dtos/GetProjectionsResult'].get(),
                schemas['dtos/GetProjectionWithPermsResult'].get(),
                schemas['dtos/GetStreamResult'].get(),
                schemas['dtos/GlobalPermissions'].get(),
                schemas['dtos/PartnerOrgCredentials'].get(),
                schemas['dtos/PartnerOrgInformation'].get(),
                schemas['dtos/PermissionGroup'].get(),
                schemas['dtos/PermissionGroupByAccountId'].get(),
                schemas['dtos/PermissionGroupStream'].get(),
                schemas['dtos/PublishingGetListingResult'].get(),
                schemas['dtos/PublishingGetListingsResult'].get(),
                schemas['dtos/PublishingGetProductsResult'].get(),
                schemas['dtos/SecReviewWithFeedback'].get(),
                schemas['dtos/StreamPermissions'].get(),
                schemas['dtos/StreamsByOrg62AccountId'].get(),
                schemas['dtos/UserJWT'].get(),
                schemas['dtos/ValidationResult'].get(),
                schemas['dtos/PublishingGetSecurityReview'].get(),
                schemas['dtos/SecurityReviewMakePaymentResponse'].get(),
                schemas['dtos/ConnectedOrgResponse'].get(),
                schemas['dtos/SecurityReviewWithOpsMulesoft'].get(),
                schemas['dtos/HomepageNotification'].get(),
                schemas['dtos/NewAttributesRequestBody'].get(),
                schemas['dtos/NewProductClassificationRequestBody'].get(),
                schemas['dtos/NewProduct2RequestBody'].get(),
                schemas['pricing_configuration/BaseProduct'].get(),
                schemas['dtos/offer/Offer'].get(),
                schemas['dtos/offer/OfferContact'].get(),
                schemas['dtos/quote/Quote'].get(),
                schemas['dtos/quote/QuoteLineItem'].get(),
                schemas['dto/plan/Plan'].get(),
                schemas['dtos/product/Product'].get(),
                schemas['dtos/order/Order'].get(),
                schemas['dtos/orderItem/OrderItem'].get(),
                schemas['dtos/solution/TMSolution'].get(),
                schemas['dtos/solution/InstalledPackageVersion'].get(),
            ],
        }),
        new: (override) => {
            const original = null;
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/solution/InstalledPackageVersion': {
        get: () => ({
            $id: 'dtos/solution/InstalledPackageVersion',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'InstalledPackageVersion',
            type: 'object',
            required: [
                'id',
                'packageId',
                'packageName',
                'packageVersionId',
                'packageVersionName',
                'majorVersion',
                'minorVersion',
                'patchVersion',
            ],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Salesforce ID of the solution object',
                    sensitivityLevel: 'internal',
                },
                packageId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Salesforce Package ID related to the solution',
                    sensitivityLevel: 'internal',
                },
                packageName: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce Package Name related to the solution',
                    sensitivityLevel: 'internal',
                },
                packageVersionId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Salesforce Package Version ID related to the solution',
                    sensitivityLevel: 'internal',
                },
                packageVersionName: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce Package Version name related to the solution',
                    sensitivityLevel: 'internal',
                },
                majorVersion: {
                    description: 'Major version of the package version installed',
                    type: 'number',
                    minimum: 0,
                    sensitivityLevel: 'internal',
                },
                minorVersion: {
                    description: 'Minor version of the package version installed',
                    type: 'number',
                    minimum: 0,
                    sensitivityLevel: 'internal',
                },
                patchVersion: {
                    description: 'Patch version of the package version installed',
                    type: 'number',
                    minimum: 0,
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                id: '',
                packageId: '',
                packageName: '',
                packageVersionId: '',
                packageVersionName: '',
                majorVersion: 0,
                minorVersion: 0,
                patchVersion: 0,
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/order/Order': {
        get: () => ({
            $id: 'dtos/order/Order',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Order',
            type: 'object',
            required: [
                'id',
                'orderNumber',
                'status',
                'createdDate',
                'effectiveDate',
                'endDate',
                'totalAmount',
                'quoteId',
                'opportunityId',
                'paymentType',
            ],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Unique Salesforce ID of the Order',
                    sensitivityLevel: 'internal',
                },
                orderNumber: {
                    type: 'string',
                    description: 'Auto generated OrderNumber in 0000000 format',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: ['awaiting-activation', 'processing', 'active-order', 'expired-order'],
                    description: 'Status of the order',
                    sensitivityLevel: 'internal',
                },
                createdDate: {
                    type: 'string',
                    format: 'datetime',
                    description: 'Date the Order record was created, Salesforce system-generated created date',
                    sensitivityLevel: 'internal',
                },
                effectiveDate: {
                    type: 'string',
                    format: 'date',
                    description: 'Date in which the Order becomes effective/active',
                    sensitivityLevel: 'internal',
                },
                endDate: {
                    type: 'string',
                    format: 'date',
                    description: 'Date in which the Order expires/finishes',
                    sensitivityLevel: 'internal',
                },
                totalAmount: {
                    description: 'Total amount of the Order',
                    type: 'number',
                    minimum: 0,
                    sensitivityLevel: 'internal',
                },
                quoteId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Salesforce ID of the Quote from which this Order is based on',
                    sensitivityLevel: 'internal',
                },
                opportunityId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Salesforce ID of the related Opportunity',
                    sensitivityLevel: 'internal',
                },
                orderItems: {
                    type: 'array',
                    default: [],
                    description: 'The Order Items for this Order',
                    items: schemas['dtos/orderItem/OrderItem'].get(),
                },
                tmOrgId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    default: [],
                    description: 'TM Org Id',
                    sensitivityLevel: 'internal',
                },
                accountName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    default: [],
                    description: 'Account name',
                    sensitivityLevel: 'internal',
                },
                paymentType: {
                    type: 'string',
                    enum: ['Paid Private Offer'],
                    description: 'payment type',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                id: '',
                orderNumber: '',
                status: 'awaiting-activation',
                createdDate: '',
                effectiveDate: '',
                endDate: '',
                totalAmount: 0,
                quoteId: '',
                opportunityId: '',
                paymentType: 'Paid Private Offer',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/orderItem/OrderItem': {
        get: () => ({
            $id: 'dtos/orderItem/OrderItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'OrderItem',
            type: 'object',
            required: [
                'id',
                'orderItemNumber',
                'quantity',
                'listPrice',
                'unitPrice',
                'totalPrice',
                'serviceDate',
                'endDate',
            ],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Unique Salesforce ID of the OrderItem',
                    sensitivityLevel: 'internal',
                },
                orderItemNumber: {
                    type: 'string',
                    minLength: 10,
                    maxLength: 10,
                    description: 'Auto generated OrderItemNumber in 0000000000 format',
                    sensitivityLevel: 'internal',
                },
                quantity: {
                    type: 'number',
                    description: 'Amount of licenses purchased. If product has site-wide licenses this item should be 1, but its meaning will be irrelevant.',
                    sensitivityLevel: 'internal',
                    minimum: 0,
                },
                listPrice: {
                    type: 'number',
                    description: 'The list price of the Product associated to this Order Item',
                    minimum: 0,
                    sensitivityLevel: 'internal',
                },
                listingName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'Listing Name',
                    sensitivityLevel: 'internal',
                },
                publisherName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'Publisher Name',
                    sensitivityLevel: 'internal',
                },
                unitPrice: {
                    type: 'number',
                    description: 'The unit price at which each license is being sold',
                    minimum: 0,
                    sensitivityLevel: 'internal',
                },
                totalPrice: {
                    type: 'number',
                    description: 'Total price of the Order item. This is quantity * unitPrice',
                    minimum: 0,
                    sensitivityLevel: 'internal',
                },
                serviceDate: {
                    type: 'string',
                    format: 'date',
                    description: 'Date in which the OrderItem becomes active. This is the day in which the licenses should be provisioned.',
                    sensitivityLevel: 'internal',
                },
                endDate: {
                    type: 'string',
                    format: 'date',
                    description: 'Date in which the Order becomes inactive. This is the day in which the licenses should be deprovisioned.',
                    sensitivityLevel: 'internal',
                },
                discountPercentage: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100,
                    description: 'Discount percent applied to the Order Item',
                    sensitivityLevel: 'internal',
                },
                discountAmount: {
                    type: 'number',
                    minimum: 0,
                    description: 'Nominal discount applied to the Order Item',
                    sensitivityLevel: 'internal',
                },
                plan: schemas['dto/plan/Plan'].get(),
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                id: '',
                orderItemNumber: '',
                quantity: 0,
                listPrice: 0,
                unitPrice: 0,
                totalPrice: 0,
                serviceDate: '',
                endDate: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/offer/Offer': {
        get: () => ({
            $id: 'dtos/offer/Offer',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Offer',
            type: 'object',
            required: ['name', 'id', 'contact', 'orgId', 'offerNumber', 'status', 'listingId'],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Unique Salesforce ID for internal use.',
                    sensitivityLevel: 'internal',
                },
                name: {
                    type: 'string',
                    minLength: 4,
                    maxLength: 255,
                    description: 'Name of the offer.',
                    sensitivityLevel: 'internal',
                },
                description: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'Description of the offer.',
                    sensitivityLevel: 'internal',
                },
                contact: schemas['dtos/offer/OfferContact'].get(),
                orgId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Organization ID (Account.TMOrgId) associated with the offer.',
                    sensitivityLevel: 'internal',
                },
                offerNumber: {
                    type: 'string',
                    minLength: 5,
                    maxLength: 12,
                    description: 'Offer number in format (e.g., O-000001).',
                    sensitivityLevel: 'internal',
                },
                createdDate: {
                    type: 'string',
                    format: 'datetime',
                    description: 'Salesforce system-generated created date.',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: ['requested', 'in-review', 'accepted', 'rejected'],
                    description: 'Current stage of the offer in the process.',
                    sensitivityLevel: 'internal',
                },
                listingId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'The oAF Id of the Listing associated with the offer.',
                    sensitivityLevel: 'internal',
                },
                listingName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'Listing Name',
                    sensitivityLevel: 'internal',
                },
                listingPublisherName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: "Listing's publisher name",
                    sensitivityLevel: 'internal',
                },
                quotes: {
                    type: 'array',
                    default: [],
                    description: 'Quotes for this offer',
                    items: schemas['dtos/quote/Quote'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { id: '', name: '', orgId: '', offerNumber: '', status: 'requested', listingId: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/quote/Quote': {
        get: () => ({
            $id: 'dtos/quote/Quote',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quote',
            type: 'object',
            required: ['name'],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Id of the quote. Server generated. Will be ignored in POST requests.',
                },
                createdDate: {
                    type: 'string',
                    format: 'datetime',
                    description: "The UTC timestamp when the quote was created in ISO string format ex: '2022-05-11T17:57:40.110Z'. Read-only field. Will be ignored in POST/PUT requests.",
                },
                name: { type: 'string', description: 'Name of the quote.', minLength: 4, maxLength: 255 },
                offerId: { type: 'string', minLength: 18, maxLength: 18, description: 'Lookup to related offer.' },
                status: {
                    type: 'string',
                    enum: [
                        'draft',
                        'needs-review',
                        'in-review',
                        'approved',
                        'rejected',
                        'presented',
                        'accepted',
                        'denied',
                    ],
                    description: 'The status of the quote.',
                },
                partnerNotes: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'Partner notes. Not visible to customer.',
                },
                customerNotes: { type: 'string', maxLength: 32000, description: 'Customer notes.' },
                expirationDate: { type: 'string', format: 'date', description: 'Expiration date of the quote.' },
                quoteNumber: {
                    type: 'string',
                    minLength: 5,
                    maxLength: 12,
                    description: 'Quote number in format (e.g. 00001).',
                    sensitivityLevel: 'internal',
                },
                quoteLineItems: {
                    type: 'array',
                    default: [],
                    description: 'The line items for the quote.',
                    items: schemas['dtos/quote/QuoteLineItem'].get(),
                },
                totalPrice: { type: 'number', minimum: 0, description: 'Total price. Sum of all quotes line items' },
                proratedSubtotal: { type: 'number', minimum: 0, description: 'Prorated subtotal price.' },
                acceptedBy: { type: 'string', description: 'User who accepted the quote.', maxLength: 255 },
                acceptedDate: {
                    type: 'string',
                    format: 'datetime',
                    description: "The UTC timestamp when the quote was accepted in ISO string format ex: '2022-05-11T17:57:40.110Z'.",
                },
                externalId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'External ID associated with the quote.',
                },
                startDate: {
                    type: 'string',
                    format: 'date',
                    description: 'Required for order creation. StartDate on Quote will be used for Order StartDate.',
                },
                endDate: {
                    type: 'string',
                    format: 'date',
                    description: 'Required for order creation. EndDate on Quote will be used for Order EndDate.',
                },
                partnerName: { type: 'string', maxLength: 255, description: 'Name of the partner organization.' },
                partnerEmail: { type: 'string', format: 'email', description: 'Contact email of the partner.' },
                partnerPhoneNumber: { type: 'string', maxLength: 40, description: 'Phone number for the partner' },
                customerBillingAddressStreet: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Street billing address of the customer.',
                },
                customerBillingAddressCity: {
                    type: 'string',
                    maxLength: 100,
                    description: 'City billing address of the customer.',
                },
                customerBillingAddressState: {
                    type: 'string',
                    maxLength: 50,
                    description: 'State billing address of the customer.',
                },
                customerBillingAddressZip: {
                    type: 'string',
                    maxLength: 20,
                    description: 'Zip billing address of the customer.',
                },
                customerShippingAddressStreet: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Street shipping address of the customer.',
                },
                customerShippingAddressCity: {
                    type: 'string',
                    maxLength: 100,
                    description: 'City shipping address of the customer.',
                },
                customerShippingAddressState: {
                    type: 'string',
                    maxLength: 50,
                    description: 'State shipping address of the customer.',
                },
                customerShippingAddressZip: {
                    type: 'string',
                    maxLength: 20,
                    description: 'Zip shipping address of the customer.',
                },
                customerEmail: { type: 'string', format: 'email', description: 'Contact email of the customer.' },
                additionalCustomerContactEmail: {
                    type: 'string',
                    format: 'email',
                    description: 'Additional customer contact email.',
                },
                sentDate: { type: 'string', format: 'datetime', description: 'Date when the quote was sent.' },
                termsAndConditionsDoc: {
                    type: 'string',
                    maxLength: 255,
                    description: 'URL or reference to the terms and conditions document.',
                },
                supplementalDocs: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            fileName: { type: 'string', maxLength: 255 },
                            fileUrl: { type: 'string', maxLength: 255 },
                        },
                        required: ['fileName', 'fileUrl'],
                        additionalProperties: false,
                    },
                    maxItems: 5,
                    description: 'References to additional documents.',
                },
                quotePdf: { type: 'string', maxLength: 255, description: "URL or reference of the quote's PDF." },
                relatedAppXOrderId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Lookup or reference to the related AppX order.',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/quote/QuoteLineItem': {
        get: () => ({
            $id: 'dtos/quote/QuoteLineItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quote Line Item',
            type: 'object',
            required: ['planId', 'quantity', 'unitPrice', 'currencyCode'],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Id of the quote. Server generated. Will be ignored in POST requests.',
                },
                planId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Id of the plan linked to the quote.',
                },
                planName: {
                    type: 'string',
                    description: 'Plan Name.  Server generated.  Will be ignored in PUT/POST requests.',
                },
                planProductId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Product classifiation ID for the plan linked to the quote.',
                },
                planPrice: {
                    type: 'number',
                    multipleOf: 0.01,
                    description: 'The price of the Plan linked to the quote.',
                },
                planFrequency: {
                    type: 'string',
                    description: 'The frequency of the plan linked to the quote.',
                    enum: ['monthly', 'annual'],
                },
                quantity: { type: 'integer', description: 'The number of units for the line item.' },
                unitPrice: {
                    type: 'number',
                    multipleOf: 0.01,
                    description: 'The price per unit for the quote line item.',
                },
                currencyCode: {
                    description: 'The currency of the price.',
                    type: 'string',
                    enum: ['USD', 'GBP', 'CAD', 'AUD', 'EUR', 'JPY'],
                },
                discountPercent: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100,
                    description: 'Discount percent to apply to the quote line item.',
                },
                totalSalesPrice: {
                    type: 'number',
                    description: 'Total sales price of the quote line item. Server generated.  Will be ignored in PUT/POST requests.',
                },
                proratedSubtotal: { type: 'number', minimum: 0, description: 'Prorated subtotal price.' },
                listingId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Lookup to a listing record that is associated with the quote line item.',
                },
                listingName: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name of the listing associated with the quote line item.',
                },
                relatedPackageIds: {
                    type: 'array',
                    items: { type: 'string', minLength: 18, maxLength: 18 },
                    description: 'IDs of related packages for the quote line item.',
                },
                attributes: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: { name: { type: 'string' }, value: { type: 'string' } },
                        required: ['name'],
                    },
                    description: 'Attributes/features included in the plan. Name for checkbox type; text value for partner inputs.',
                },
                org62AppId: { type: 'string', minLength: 18, maxLength: 18, description: 'Org62 unique identifier.' },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { planId: '', quantity: 0, unitPrice: 0, currencyCode: 'USD' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/offer/OfferContact': {
        get: () => ({
            description: 'Reference to associated contact for the offer.',
            $id: 'dtos/offer/OfferContact',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Offer Contact',
            type: 'object',
            required: ['firstName', 'lastName', 'email'],
            properties: {
                firstName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'First name of the contact.',
                    sensitivityLevel: 'internal',
                },
                lastName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'Last name of the contact.',
                    sensitivityLevel: 'internal',
                },
                email: {
                    type: 'string',
                    format: 'email',
                    description: 'Email address of the contact.',
                    sensitivityLevel: 'internal',
                },
                companyName: {
                    type: 'string',
                    minLength: 4,
                    maxLength: 255,
                    description: 'Name of the company.',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { firstName: '', lastName: '', email: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_configuration/BaseProduct': {
        get: () => ({
            $id: 'pricing_configuration/BaseProduct',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'BaseProduct',
            type: 'object',
            required: ['title', 'description'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The identifier of the object in RLM',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'internal',
                },
                title: {
                    type: 'string',
                    description: 'The title of the product.',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                description: {
                    default: '',
                    type: 'string',
                    description: 'Description of the product',
                    minLength: 1,
                    maxLength: 3000,
                    sensitivityLevel: 'public',
                },
                attributes: {
                    type: 'array',
                    default: [],
                    description: 'The attributes created for the product.',
                    items: schemas['pricing_configuration/Attribute'].get(),
                },
                plans: {
                    type: 'array',
                    default: [],
                    description: 'The Plans created for the product.',
                    items: schemas['pricing_configuration/Plan'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { title: '', description: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_configuration/Plan': {
        get: () => ({
            $id: 'pricing_configuration/Plan',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Plan',
            type: 'object',
            required: ['title', 'description', 'quantityUnitOfMeasure'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The identifier of the object in RLM',
                    sensitivityLevel: 'internal',
                },
                title: {
                    type: 'string',
                    description: 'The title of the plan.',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                description: {
                    type: 'string',
                    description: 'The description of the plan.',
                    minLength: 1,
                    maxLength: 3000,
                    sensitivityLevel: 'public',
                },
                createdDate: {
                    type: 'string',
                    maxLength: 100,
                    description: 'Date this plan -product2- was created',
                    format: 'date-time',
                    sensitivityLevel: 'public',
                },
                solutions: {
                    type: 'array',
                    description: 'SolutionIds associated with the plan.',
                    uniqueItems: true,
                    items: {
                        type: 'object',
                        properties: {
                            solutionId: {
                                type: 'string',
                                description: 'The solutionId on oaf.',
                                sensitivityLevel: 'internal',
                            },
                            external_id: {
                                type: 'string',
                                description: 'The solution object in RLM.',
                                sensitivityLevel: 'internal',
                            },
                            packageVersionId: {
                                type: 'string',
                                description: 'The packageVersionId on oaf.',
                                sensitivityLevel: 'public',
                            },
                        },
                    },
                },
                attributeValues: {
                    type: 'array',
                    description: 'Attributes associated with the plan.',
                    uniqueItems: true,
                    items: schemas['pricing_configuration/AttributeValue'].get(),
                },
                pricingOptions: {
                    type: 'array',
                    default: [],
                    description: 'Pricing options available for the plan.',
                    items: schemas['pricing_configuration/PricingOption'].get(),
                },
                quantityUnitOfMeasure: {
                    type: 'string',
                    description: 'Type of the plan subscription',
                    enum: ['userBase', 'orgBase', 'Free'],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { title: '', description: '', quantityUnitOfMeasure: 'userBase' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_configuration/PricingOption': {
        get: () => ({
            $id: 'pricing_configuration/PricingOption',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PricingOption',
            type: 'object',
            required: ['title', 'description'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The identifier of the object in RLM',
                    sensitivityLevel: 'internal',
                },
                title: {
                    type: 'string',
                    description: 'The title of the pricing option.',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                frequency: { type: 'string', description: 'Type of the frequency', enum: ['monthly', 'annual'] },
                currency: { type: 'string', description: 'Type of the currency', enum: ['USD'] },
                price: { type: 'number', description: 'Price of the plan', minimum: 0.01, maximum: 999999999 },
                priceDetails: {
                    type: 'string',
                    description: 'This is the additional pricing details for the pricing options.',
                    maxLength: 255,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { title: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_configuration/AttributeValue': {
        get: () => ({
            $id: 'pricing_configuration/AttributeValue',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'AttributeValue',
            type: 'object',
            required: [],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The identifier of the object in RLM',
                    sensitivityLevel: 'internal',
                },
                attributeDefinitionId: {
                    default: '',
                    type: 'string',
                    description: 'Attribute Definition ID',
                    sensitivityLevel: 'internal',
                },
                productClassificationAttributeId: {
                    default: '',
                    type: 'string',
                    description: 'Product Classification Attribute Id',
                    sensitivityLevel: 'internal',
                },
                value: {
                    type: 'string',
                    maxLength: 15,
                    description: 'Value of the attribute',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_configuration/Attribute': {
        get: () => ({
            $id: 'pricing_configuration/Attribute',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Attribute',
            type: 'object',
            required: ['title', 'description', 'type'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The identifier of the object in RLM',
                    sensitivityLevel: 'internal',
                },
                title: {
                    type: 'string',
                    description: 'The title of the attribute.',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                description: {
                    default: '',
                    type: 'string',
                    description: 'Description of the attribute',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                type: { type: 'string', description: 'Type of the attribute', enum: ['text', 'checkbox'] },
                attributeDefinitionId: {
                    default: '',
                    type: 'string',
                    description: 'Attribute Definition ID',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { title: '', description: '', type: 'text' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/NewProduct2RequestBody': {
        get: () => ({
            $id: 'dtos/NewProduct2RequestBody',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'NewProduct2RequestBody',
            description: 'JSON object containing the body needed in order to create new Product2 (Plans).',
            type: 'object',
            properties: {
                id: { type: 'string' },
                name: { type: 'string' },
                description: { type: 'string' },
                productClassificationId: { type: 'string' },
                org62AccountId: { type: 'string' },
            },
            required: ['name', 'productClassificationId', 'description'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', description: '', productClassificationId: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/NewProductClassificationRequestBody': {
        get: () => ({
            $id: 'dtos/NewProductClassificationRequestBody',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ProductClassificationRequestBody',
            description: 'JSON object containing the body needed in order to create new Product Classifications.',
            type: 'object',
            properties: {
                id: { type: 'string' },
                name: { type: 'string' },
                code: { type: 'string' },
                status: { type: 'string', enum: ['Draft', 'Active', 'Inactive'] },
                org62AccountId: { type: 'string' },
            },
            required: ['name'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/NewAttributesRequestBody': {
        get: () => ({
            $id: 'dtos/NewAttributesRequestBody',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'NewAttributesRequestBody',
            description: 'JSON object containing the body needed in order to create new Attributes.',
            type: 'object',
            properties: {
                name: { type: 'string' },
                type: { type: 'string', enum: ['Checkbox', 'Picklist', 'Text'] },
                productClassificationId: { type: 'string' },
                picklistValues: {
                    type: 'object',
                    required: ['values'],
                    properties: {
                        values: {
                            type: 'array',
                            items: {
                                required: ['value'],
                                properties: { value: { type: 'string' }, default: { type: 'boolean', default: false } },
                            },
                        },
                    },
                },
            },
            required: ['type', 'name', 'productClassificationId'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', type: 'Checkbox', productClassificationId: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/HomepageNotification': {
        get: () => ({
            $id: 'dtos/HomepageNotification',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'HomepageNotification',
            description: 'JSON object containing the notification shown on Partner Console homepage.',
            type: 'object',
            properties: {
                itemName: { type: 'string' },
                itemType: { type: 'string' },
                message: {
                    type: 'object',
                    required: ['type', 'text', 'reason', 'action'],
                    properties: {
                        type: { type: 'string' },
                        text: { type: 'string' },
                        reason: { type: 'string' },
                        action: {
                            type: 'object',
                            required: ['href', 'name'],
                            properties: { href: { type: 'string' }, name: { type: 'string' } },
                        },
                    },
                },
            },
            required: ['itemName', 'itemType', 'message'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                itemName: '',
                itemType: '',
                message: { type: '', text: '', reason: '', action: { href: '', name: '' } },
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/SecurityReviewWithOpsMulesoft': {
        get: () => ({
            $id: 'dtos/SecurityReviewWithOpsMulesoft',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SecurityReviewWithOpsMulesoft',
            description: 'JSON object that recieves the SR and SROps from mulesoft securityReview endpoint',
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The identifier of the SecurityReview',
                    sensitivityLevel: 'public',
                },
                external_id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The identifier of the SecurityReview in an external ',
                    sensitivityLevel: 'public',
                },
                solution_external_id: {
                    type: 'string',
                    description: 'External id of the solution',
                    sensitivityLevel: 'public',
                },
                status: {
                    type: 'string',
                    enum: ['New', 'Submitted', 'Re-submitted', 'Revoked'],
                    description: 'The status of the security review of the solution that is represented by this record',
                    sensitivityLevel: 'public',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                user_created_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the Security Review was created in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'internal',
                },
                user_updated_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the Security Review was updated at in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'internal',
                },
                security_review_ops: {
                    description: 'JSON object ',
                    type: 'object',
                    properties: {
                        status: {
                            type: 'string',
                            enum: [
                                'New',
                                'Processing - Ops',
                                'Returned - Ops',
                                'In Review - ProdSec',
                                'Returned - ProdSec',
                                'Pass - ProdSec',
                                'Failed - ProdSec',
                            ],
                            description: 'The Review status of the security review made by Ops team',
                            sensitivityLevel: 'internal',
                        },
                        approvalDate: {
                            type: 'string',
                            format: 'iso-datetime',
                            description: 'Date when the SR was approved',
                            sensitivityLevel: 'internal',
                        },
                        external_id: {
                            type: 'string',
                            format: 'uuid',
                            description: 'The identifier of the SecurityReview in an external ',
                            sensitivityLevel: 'public',
                        },
                    },
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/ConnectedOrgResponse': {
        get: () => ({
            $id: 'dtos/ConnectedOrgResponse',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ConnectedOrgResponse',
            description: 'JSON object containing the merge of oAF and snowflake connected org information',
            type: 'object',
            required: ['orgId', 'name', 'connectedDate'],
            properties: {
                edition: { type: 'string' },
                name: { type: 'string' },
                packageVersionCount: { type: 'number' },
                lastReplicated: { type: 'string' },
                orgId: { type: 'string' },
                org62AccountId: { type: 'string' },
                connectedDate: { type: 'string' },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', orgId: '', connectedDate: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/SecurityReviewMakePaymentResponse': {
        get: () => ({
            $id: 'dtos/SecurityReviewMakePaymentResponse',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SecurityReviewMakePaymentResponse',
            description: 'JSON object containing the results of a making a security review payment.',
            type: 'object',
            properties: {
                redirectUrl: { type: ['string', 'null'], description: 'Url to redirect to make the payment' },
                paymentType: {
                    type: 'string',
                    enum: ['subscription_credit', 'payment_required', 'payment_not_required'],
                    description: 'The requirement for payment given this security review. If a prior subscription after GA is still active, they get two free submissions (subscription_credit). If a security review is paid for, and fails, we give them one do-over (previous_submission_credit). If a solution is paid or Salesforce Labs, payment is not required (payment_not_required). Otherwise, payment is required in full or can be discounted with a coupon (payment_required).',
                },
            },
            required: ['paymentType'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { paymentType: 'subscription_credit' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PublishingGetSecurityReview': {
        get: () => ({
            $id: 'dtos/PublishingGetSecurityReview',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublishingGetSecurityReview',
            description: 'JSON object containing the results of a getting a security review by id.',
            type: 'object',
            properties: {
                securityReview: schemas['securityReview/BaseSecurityReview'].get(),
                solution: schemas['solution/Solution'].get(),
                securityReviewOps: schemas['securityReviewOps/BaseSecurityReviewOps'].get(),
            },
            required: ['securityReview'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/ValidationResult': {
        get: () => ({
            $id: 'dtos/ValidationResult',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ValidationResult',
            description: 'JSON object containing the results of a validating a projection.',
            type: 'object',
            properties: {
                isValid: { type: 'boolean' },
                errors: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: ['name', 'stack'],
                        properties: {
                            name: { type: 'string' },
                            argument: { type: 'string' },
                            stack: { type: 'string' },
                            path: { type: 'array', items: { type: 'string' } },
                            message: { type: 'string' },
                        },
                        additionalProperties: false,
                    },
                    default: [],
                },
            },
            required: ['isValid', 'errors'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { isValid: false, errors: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/UserJWT': {
        get: () => ({
            $id: 'dtos/UserJWT',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'UserJWT',
            description: 'Json Web Token containing authenticated user data.',
            type: 'object',
            properties: {
                iat: { type: 'number' },
                exp: { type: 'number' },
                userId: { type: 'string' },
                realUsername: { type: 'string' },
                name: { type: 'string' },
                permGroups: { type: 'array', items: { type: 'string' } },
                org62AccountId: { type: 'string' },
                isServiceUser: { type: 'boolean' },
                profilePhotoUrl: { type: 'string' },
                account: { type: 'string' },
                orgId: { type: 'string' },
                isVaultUser: { type: 'boolean' },
            },
            required: ['iat', 'exp', 'userId', 'name', 'permGroups', 'org62AccountId', 'profilePhotoUrl'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                iat: 0,
                exp: 0,
                userId: '',
                name: '',
                permGroups: [],
                org62AccountId: '',
                profilePhotoUrl: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/StreamsByOrg62AccountId': {
        get: () => ({
            $id: 'dtos/StreamsByOrg62AccountId',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'StreamsByOrg62AccountId',
            description: 'The API data model when retrieving Streams by Org62AccountId',
            type: 'object',
            properties: {
                streams: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: { type: 'string', description: 'The oAF identifier of the streams' },
                            external_id: { type: 'string', description: 'The identifier of the stream' },
                            name: {
                                type: 'string',
                                description: 'The internal name of the Stream',
                                minLength: 1,
                                maxLength: 128,
                            },
                        },
                        required: ['id', 'external_id', 'name'],
                        additionalProperties: false,
                    },
                },
                totalItems: { type: 'integer', default: 0 },
            },
            required: ['streams', 'totalItems'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { streams: [], totalItems: 0 };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/SecReviewWithFeedback': {
        get: () => ({
            $id: 'dtos/SecReviewWithFeedback',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SecReviewWithFeedback',
            description: 'Mulesoft response for SecReviews',
            type: 'object',
            properties: {
                projection: schemas['securityReview/BaseSecurityReview'].get(),
                securityReviewFeedback: schemas['securityReviewOps/BaseSecurityReviewOps'].get(),
            },
            required: ['projection'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PublishingGetProductsResult': {
        get: () => ({
            $id: 'dtos/PublishingGetProductsResult',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublishingGetProductsResult',
            description: 'A paginated response of products.',
            type: 'object',
            properties: {
                results: { type: 'array', uniqueItems: true, items: schemas['dtos/product/Product'].get() },
                totalResults: { type: 'number', default: 0 },
                currentPage: { type: 'number', default: 0 },
                hasNextPage: { type: 'boolean', default: false },
            },
            required: ['results', 'totalResults', 'currentPage', 'hasNextPage'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { results: [], totalResults: 0, currentPage: 0, hasNextPage: false };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/product/Product': {
        get: () => ({
            $id: 'dtos/product/Product',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Product',
            type: 'object',
            required: ['id', 'name'],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Id of the Product. Server generated. Will be ignored in POST requests.',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Id of the Account in org62 for the partner.',
                    sensitivityLevel: 'internal',
                },
                name: {
                    type: 'string',
                    description: 'The title of the product.',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                description: {
                    type: 'string',
                    description: 'The description of the product.',
                    minLength: 1,
                    maxLength: 4000,
                    sensitivityLevel: 'public',
                },
                createdDate: {
                    type: 'string',
                    format: 'datetime',
                    description: "The UTC timestamp when the product was created in ISO string format ex: '2022-05-11T17:57:40.110Z'. Read-only field. Will be ignored in POST/PUT requests.",
                    sensitivityLevel: 'internal',
                },
                plans: {
                    type: 'array',
                    default: [],
                    description: 'The plans related to this product',
                    items: schemas['dto/plan/Plan'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { id: '', name: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dto/plan/Plan': {
        get: () => ({
            $id: 'dto/plan/Plan',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Product2Plan',
            type: 'object',
            required: ['title', 'description', 'quantityUnitOfMeasure'],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Id of the Plan. Server generated. Will be ignored in POST requests.',
                    sensitivityLevel: 'internal',
                },
                basedOnId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Id of the ProductClassification the plan is based ON',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Id of the Account in org62 for the partner.',
                    sensitivityLevel: 'internal',
                },
                title: {
                    type: 'string',
                    description: 'The title of the plan.',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                description: {
                    type: 'string',
                    description: 'The description of the plan.',
                    minLength: 1,
                    maxLength: 4000,
                    sensitivityLevel: 'public',
                },
                frequency: { type: 'string', description: 'Type of the frequency', enum: ['monthly', 'annual'] },
                price: { description: 'The price of the plan.', type: 'number', multipleOf: 0.01, minimum: 0 },
                currencyIsoCode: {
                    description: 'The currency code of the plan',
                    type: 'string',
                    minimum: 0,
                    enum: ['USD'],
                },
                createdDate: {
                    type: 'string',
                    format: 'datetime',
                    description: "The UTC timestamp when the quote was created in ISO string format ex: '2022-05-11T17:57:40.110Z'. Read-only field. Will be ignored in POST/PUT requests.",
                    sensitivityLevel: 'internal',
                },
                quantityUnitOfMeasure: {
                    type: 'string',
                    description: 'Type of the plan subscription',
                    enum: ['userBase', 'orgBase', 'free'],
                },
                isActive: { type: 'boolean', description: 'Determines if the plan is active or not.' },
                solutions: {
                    type: 'array',
                    default: [],
                    description: 'The solutions related to this plan',
                    items: schemas['dtos/solution/TMSolution'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { title: '', description: '', quantityUnitOfMeasure: 'userBase' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/solution/TMSolution': {
        get: () => ({
            $id: 'dtos/solution/TMSolution',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'TMSolution',
            type: 'object',
            required: ['id', 'packageId', 'packageName', 'packageVersionId', 'packageVersionName'],
            properties: {
                id: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Salesforce ID of the solution object',
                    sensitivityLevel: 'internal',
                },
                packageId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Salesforce Package ID related to the solution',
                    sensitivityLevel: 'internal',
                },
                packageName: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce Package Name related to the solution',
                    sensitivityLevel: 'internal',
                },
                packageVersionId: {
                    type: 'string',
                    minLength: 18,
                    maxLength: 18,
                    description: 'Salesforce Package Version ID related to the solution',
                    sensitivityLevel: 'internal',
                },
                packageVersionName: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce Package Version name related to the solution',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { id: '', packageId: '', packageName: '', packageVersionId: '', packageVersionName: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PublishingGetListingsResult': {
        get: () => ({
            $id: 'dtos/PublishingGetListingsResult',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublishingGetListingsResult',
            description: 'A paginated response of listings with solution and trial information.',
            type: 'object',
            properties: {
                results: { type: 'array', uniqueItems: true, items: schemas['dtos/PublishingGetListingResult'].get() },
                totalResults: { type: 'number', default: 0 },
                currentPage: { type: 'number', default: 0 },
                totalPages: { type: 'number', default: 0 },
                hasNextPage: { type: 'boolean', default: false },
            },
            required: ['results', 'totalResults', 'currentPage', 'totalPages', 'hasNextPage'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { results: [], totalResults: 0, currentPage: 0, totalPages: 0, hasNextPage: false };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PublishingGetListingResult': {
        get: () => ({
            $id: 'dtos/PublishingGetListingResult',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublishingGetListingResult',
            description: 'JSON object containing the results of a getting a projection by id.',
            type: 'object',
            properties: {
                listing: schemas['listing/BaseListing'].get(),
                solution: schemas['solution/Solution'].get(),
                trialTemplate: schemas['solution/TrialTemplate'].get(),
                approval: schemas['business_approval/BusinessApproval'].get(),
            },
            required: ['listing'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PermissionGroupStream': {
        get: () => ({
            $id: 'dtos/PermissionGroupStream',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PermissionGroupStream',
            description: 'The API data model for a permission group and stream junction object',
            type: 'object',
            properties: {
                perm_group_id: { type: 'string' },
                stream_id: { type: 'string' },
                stream_name: { type: 'string' },
                stream_type: { type: 'string', enum: ['listing'] },
            },
            required: [],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PermissionGroupByAccountId': {
        get: () => ({
            $id: 'dtos/PermissionGroupByAccountId',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PermissionGroupByAccountId',
            description: 'The data model for a permission group by account id',
            type: 'object',
            properties: {
                data: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            id: {
                                type: 'string',
                                pattern: '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89ABab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$',
                            },
                            perm_group_id: { type: 'string', maxLength: 18 },
                            stream_perms: {
                                type: 'object',
                                required: ['listing'],
                                properties: {
                                    listing: {
                                        type: 'array',
                                        uniqueItems: true,
                                        items: {
                                            type: 'string',
                                            enum: ['Edit', 'Publish', 'Associate_Solution', 'SetPricing'],
                                        },
                                    },
                                },
                                additionalProperties: false,
                            },
                            global_perms: {
                                type: 'object',
                                required: ['listing', 'publisher', 'solution', 'pricing_plan', 'security_review'],
                                properties: {
                                    listing: {
                                        type: 'array',
                                        uniqueItems: true,
                                        items: { type: 'string', enum: ['Create', 'Delete'] },
                                    },
                                    publisher: {
                                        type: 'array',
                                        uniqueItems: true,
                                        items: {
                                            type: 'string',
                                            enum: ['Create', 'Edit', 'Connect_Org', 'Create_Solution'],
                                        },
                                    },
                                    solution: {
                                        type: 'array',
                                        uniqueItems: true,
                                        items: { type: 'string', enum: ['Create', 'Edit', 'Delete'] },
                                    },
                                    pricing_plan: {
                                        type: 'array',
                                        uniqueItems: true,
                                        items: { type: 'string', enum: ['Create', 'Edit', 'Delete'] },
                                    },
                                    security_review: {
                                        type: 'array',
                                        uniqueItems: true,
                                        items: { type: 'string', enum: ['Create', 'Edit', 'Delete'] },
                                    },
                                },
                                additionalProperties: false,
                            },
                            streams: {
                                type: 'object',
                                properties: {
                                    listings: { type: 'array', items: schemas['listing/BaseListing'].get() },
                                },
                                additionalProperties: false,
                                required: ['listings'],
                            },
                        },
                        additionalProperties: false,
                        required: ['id', 'perm_group_id', 'global_perms', 'stream_perms', 'streams'],
                    },
                },
            },
            required: ['data'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { data: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PermissionGroup': {
        get: () => ({
            $id: 'dtos/PermissionGroup',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PermissionGroup',
            description: 'The data model for a permission group',
            type: 'object',
            properties: {
                perm_group_id: { type: 'string', maxLength: 18 },
                org62_account_id: { type: 'string', maxLength: 18 },
                stream_perms: schemas['dtos/StreamPermissions'].get(),
                global_perms: schemas['dtos/GlobalPermissions'].get(),
            },
            required: ['org62_account_id', 'perm_group_id', 'stream_perms', 'global_perms'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { perm_group_id: '', org62_account_id: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PartnerOrgInformation': {
        get: () => ({
            $id: 'dtos/PartnerOrgInformation',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PartnerOrgInformation',
            description: "JSON object containing the results of a getting a partner org's information.",
            type: 'object',
            properties: { Id: { type: 'string' }, Name: { type: 'string' }, OrganizationType: { type: 'string' } },
            required: ['Id', 'Name', 'OrganizationType'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { Id: '', Name: '', OrganizationType: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/PartnerOrgCredentials': {
        get: () => ({
            $id: 'dtos/PartnerOrgCredentials',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PartnerOrgCredentials',
            description: "JSON object containing the credentials required to access a partner's org.",
            type: 'object',
            properties: { access_token: { type: 'string' }, instance_url: { type: 'string' } },
            required: ['access_token', 'instance_url', 'stream_id', 'delta_id', 'version', 'projection'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { access_token: '', instance_url: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/GetStreamResult': {
        get: () => ({
            $id: 'dtos/GetStreamResult',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'GetStreamResult',
            description: 'JSON object containing the results of a getting a stream.',
            type: 'object',
            properties: {
                id: { type: 'string' },
                type: { type: 'string' },
                external_id: { type: 'string' },
                head_delta_id: { type: 'string' },
            },
            required: ['id', 'type'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { id: '', type: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/GetProjectionWithPermsResult': {
        get: () => ({
            $id: 'dtos/GetProjectionWithPermsResult',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'GetProjectionWithPermsResult',
            description: 'JSON object containing the results of a getting a projection by type.',
            type: 'object',
            properties: {
                id: { type: 'string' },
                external_id: { type: 'string' },
                type: { type: 'string' },
                owner_id: { type: 'string' },
                stream_perms: schemas['dtos/StreamPermissions'].get(),
                global_perms: schemas['dtos/GlobalPermissions'].get(),
                projection: schemas['oaf-projection-v1'].get(),
            },
            required: ['id', 'external_id', 'type', 'owner_id', 'stream_perms', 'global_perms', 'projection'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { id: '', external_id: '', type: '', owner_id: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/GlobalPermissions': {
        get: () => ({
            $id: 'dtos/GlobalPermissions',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'GlobalPermissions',
            description: 'Global permissions',
            type: 'object',
            properties: {
                listing: { type: 'array', uniqueItems: true, items: { type: 'string', enum: ['Create', 'Delete'] } },
                publisher: {
                    type: 'array',
                    uniqueItems: true,
                    items: { type: 'string', enum: ['Create', 'Edit', 'Connect_Org', 'Create_Solution'] },
                },
                solution: {
                    type: 'array',
                    uniqueItems: true,
                    items: { type: 'string', enum: ['Create', 'Edit', 'Delete'] },
                },
                pricing_plan: {
                    type: 'array',
                    uniqueItems: true,
                    items: { type: 'string', enum: ['Create', 'Edit', 'Delete'] },
                },
                security_review: {
                    type: 'array',
                    uniqueItems: true,
                    items: { type: 'string', enum: ['Create', 'Edit', 'Delete'] },
                },
            },
            required: ['listing', 'publisher', 'solution', 'pricing_plan', 'security_review'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { listing: [], publisher: [], solution: [], pricing_plan: [], security_review: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/StreamPermissions': {
        get: () => ({
            $id: 'dtos/StreamPermissions',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'StreamPermissions',
            description: 'Permissions per stream',
            type: 'object',
            properties: {
                listing: {
                    type: 'array',
                    uniqueItems: true,
                    items: { type: 'string', enum: ['Edit', 'Publish', 'Associate_Solution', 'SetPricing'] },
                },
            },
            required: ['listing'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { listing: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/GetProjectionsResult': {
        get: () => ({
            $id: 'dtos/GetProjectionsResult',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'GetProjectionsResult',
            description: 'A paginated response of projections.',
            type: 'object',
            properties: {
                results: { type: 'array', uniqueItems: true, items: schemas['dtos/GetProjectionResult'].get() },
                totalResults: { type: 'number', default: 0 },
                currentPage: { type: 'number', default: 0 },
                totalPages: { type: 'number', default: 0 },
                hasNextPage: { type: 'boolean', default: false },
            },
            required: ['results', 'totalResults', 'currentPage', 'totalPages', 'hasNextPage'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { results: [], totalResults: 0, currentPage: 0, totalPages: 0, hasNextPage: false };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/GetSolutionsStreamWithSecReview': {
        get: () => ({
            $id: 'dtos/GetSolutionsStreamWithSecReview',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'GetSolutionsStreamWithSecReview',
            description: 'JSON object containing the results of a getting a projection by id.',
            type: 'object',
            properties: {
                id: { type: 'string' },
                external_id: { type: 'string' },
                stream_id: { type: 'string' },
                delta_id: { type: 'string' },
                version: { type: 'string' },
                projection: schemas['oaf-projection-v1'].get(),
                securityReview: schemas['securityReview/BaseSecurityReview'].get(),
                securityReviewFeedback: schemas['securityReviewOps/BaseSecurityReviewOps'].get(),
            },
            required: ['id', 'external_id', 'stream_id', 'delta_id', 'version', 'projection'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { id: '', external_id: '', stream_id: '', delta_id: '', version: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/GetSolutionsWithApprovalDate': {
        get: () => ({
            $id: 'dtos/GetSolutionsWithApprovalDate',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'GetSolutionsWithApprovalDate',
            description: 'JSON object containing the results of a solution with the SR Approval Date.',
            type: 'object',
            properties: {
                projection: schemas['oaf-projection-v1'].get(),
                approvalDate: { type: 'string', format: 'iso-datetime' },
                lastApprovedVersion: { type: 'string' },
            },
            required: ['projection'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/GetSolutionsWithSecReview': {
        get: () => ({
            $id: 'dtos/GetSolutionsWithSecReview',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'GetSolutionsWithSecReview',
            description: 'JSON object containing the results of a getting a projection by id.',
            type: 'object',
            properties: {
                projection: schemas['oaf-projection-v1'].get(),
                securityReview: schemas['securityReview/BaseSecurityReview'].get(),
                securityReviewFeedback: schemas['securityReviewOps/BaseSecurityReviewOps'].get(),
            },
            required: ['projection'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/GetProjectionResult': {
        get: () => ({
            $id: 'dtos/GetProjectionResult',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'GetProjectionResult',
            description: 'JSON object containing the results of a getting a projection by id.',
            type: 'object',
            properties: {
                id: { type: 'string' },
                external_id: { type: 'string' },
                stream_id: { type: 'string' },
                delta_id: { type: 'string' },
                version: { type: 'string' },
                projection: schemas['oaf-projection-v1'].get(),
            },
            required: ['id', 'external_id', 'stream_id', 'delta_id', 'version', 'projection'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { id: '', external_id: '', stream_id: '', delta_id: '', version: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'oaf-projection-v1': {
        get: () => ({
            $id: 'oaf-projection-v1',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'OAFProjection',
            anyOf: [
                schemas['chat/BaseChat'].get(),
                schemas['listing/BaseListing'].get(),
                schemas['publisher/BasePublisher'].get(),
                schemas['publisher_force/PublisherForce'].get(),
                schemas['solution/Solution'].get(),
                schemas['pricing_plan/Pricing'].get(),
                schemas['reviews_summary/ReviewsSummary'].get(),
                schemas['business_approval/BusinessApproval'].get(),
                schemas['securityReview/BaseSecurityReview'].get(),
                schemas['securityReviewOps/BaseSecurityReviewOps'].get(),
                schemas['securityReviewPayment/SecurityReviewPayment'].get(),
                schemas['search_details/SearchDetails'].get(),
                schemas['consultant_expertise/ConsultantExpertise'].get(),
            ],
        }),
        new: (override) => {
            const original = null;
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'consultant_expertise/ConsultantExpertise': {
        get: () => ({
            $id: 'consultant_expertise/ConsultantExpertise',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ConsultantExpertise',
            type: 'object',
            required: ['external_id', 'listing'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the Consultant Expertise (uuid)',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the consultant expertise, formed using listing + _expertise',
                    sensitivityLevel: 'internal',
                },
                listing: {
                    type: 'string',
                    description: 'UUID reference or External Id to the listing stream associated to this consultant expertise',
                    sensitivityLevel: 'internal',
                },
                specialtyAreas: {
                    type: 'array',
                    description: 'Partner Specialty Areas, these are gathered by a sync between OneAppexchange and Org62 daily',
                    items: schemas['consultant_expertise/SpecialtyArea'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { external_id: '', listing: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'consultant_expertise/SpecialtyArea': {
        get: () => ({
            $id: 'consultant_expertise/SpecialtyArea',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ConsultantExpertise_SpecialtyArea',
            type: 'object',
            required: ['type', 'name'],
            properties: {
                type: {
                    type: 'string',
                    enum: ['Salesforce Expertise', 'Industry Expertise'],
                    description: 'type of Product Specialty Area',
                    sensitivityLevel: 'internal',
                },
                name: { type: 'string', description: 'Product Specialty Area name', sensitivityLevel: 'internal' },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { type: 'Salesforce Expertise', name: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'search_details/SearchDetails': {
        get: () => ({
            $id: 'search_details/SearchDetails',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SearchDetails',
            type: 'object',
            required: ['external_id', 'listing', 'popularity'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the Search Details (uuid)',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the search details, formed using listing + _search',
                    sensitivityLevel: 'internal',
                },
                listing: {
                    type: 'string',
                    description: 'UUID reference or External Id to the listing stream associated to this search detail',
                    sensitivityLevel: 'internal',
                },
                popularity: {
                    type: 'number',
                    description: 'The popularity score associated to the listing',
                    default: 0,
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { external_id: '', listing: '', popularity: 0 };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReviewPayment/SecurityReviewPayment': {
        get: () => ({
            $id: 'securityReviewPayment/SecurityReviewPayment',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SecurityReviewPayment',
            type: 'object',
            required: ['securityReview', 'paymentRequirement', 'status'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The identifier of the SecurityReviewPayment',
                    sensitivityLevel: 'public',
                },
                external_id: {
                    type: 'string',
                    description: 'The external_id identifier of the SecurityReviewPayment',
                    format: 'uuid',
                    sensitivityLevel: 'public',
                },
                securityReview: {
                    type: 'string',
                    description: 'Stream Id of the Security Review this payment relates to',
                    sensitivityLevel: 'internal',
                },
                paymentRequirement: {
                    type: 'string',
                    enum: ['subscription_credit', 'payment_required', 'payment_not_required'],
                    sensitivityLevel: 'internal',
                    description: 'The requirement for payment given this security review. If a prior subscription after GA is still active, they get two free submissions (subscription_credit). If a security review is paid for, and fails, we give them one do-over (previous_submission_credit). If a solution is paid or Salesforce Labs, payment is not required (payment_not_required). Otherwise, payment is required in full or can be discounted with a coupon (payment_required).',
                },
                status: {
                    type: 'string',
                    enum: ['new', 'completed', 'successful', 'failed', 'cancelled'],
                    sensitivityLevel: 'internal',
                    description: 'The status of the payment. New: recently created checkout_session waiting to be confirmed. Completed: Initial payment is completed, pending secondary approval. Successful: Payment has succeeded asyncronously, or is in a state of not needing to be completed asyncronously. Failed: Payment was originally completed, but failed asyncronously via webhook. Cancelled: Checkout session expired after timeout or was cancelled.',
                },
                checkoutSession: {
                    type: 'object',
                    description: 'The checkout session provided by Stripe and its current status',
                    required: [],
                    properties: {
                        id: {
                            type: 'string',
                            description: 'Unique identifier for the object. Used to pass to redirectToCheckout in Stripe.js.',
                        },
                        client_reference_id: {
                            type: ['string', 'null'],
                            description: 'A unique string to reference the Checkout Session. This can be a customer ID, a cart ID, or similar, and can be used to reconcile the Session with your internal systems.',
                        },
                        customer_email: {
                            type: 'string',
                            description: 'If provided, this value will be used when the Customer object is created. If not provided, customers will be asked to enter their email address. Use this parameter to prefill customer data if you already have an email on file.',
                        },
                        object: {
                            type: 'string',
                            description: "String representing the object's type. Objects of the same type share the same value.",
                        },
                        metadata: {
                            type: 'object',
                            description: 'Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.',
                        },
                        amount_subtotal: {
                            type: 'number',
                            description: 'Total of all items before discounts or taxes are applied.',
                        },
                        amount_total: {
                            type: 'number',
                            description: 'Total of all items after discounts or taxes are applied.',
                        },
                        created: {
                            type: 'number',
                            description: 'Time at which the object was created. Measured in seconds since the Unix epoch.',
                        },
                        status: {
                            type: 'string',
                            enum: ['open', 'complete', 'expired'],
                            description: 'The status of the Checkout Session, one of open, complete, or expired. Open: The checkout session is still in progress. Payment processing has not started. Complete: The checkout session is complete. Payment processing may still be in progress. Expired: The checkout session has expired. No further processing will occur.',
                        },
                        mode: {
                            type: 'string',
                            enum: ['payment', 'setup', 'subscription'],
                            description: 'The mode of the Checkout Session.',
                        },
                        payment_status: {
                            type: 'string',
                            enum: ['paid', 'unpaid', 'no_payment_required'],
                            description: 'The payment status of the Checkout Session, one of paid, unpaid, or no_payment_required. You can use this value to decide when to fulfill your customer’s order.',
                        },
                        allow_promotion_code: {
                            type: 'boolean',
                            description: 'Enables user redeemable promotion codes.',
                        },
                        payment_intent: {
                            type: ['string', 'null'],
                            description: 'The ID of the PaymentIntent for Checkout Sessions in payment mode.',
                        },
                        expires_at: {
                            type: 'number',
                            description: 'The timestamp at which the Checkout Session will expire.',
                        },
                        live_mode: {
                            type: 'boolean',
                            description: 'Has the value true if the object exists in live mode or the value false if the object exists in test mode.',
                        },
                        recovered_from: {
                            type: ['string', 'null'],
                            description: 'The ID of the original expired Checkout Session that triggered the recovery flow.',
                        },
                        url: {
                            type: 'string',
                            format: 'oaf-url',
                            description: 'The URL to the Checkout Session. Redirect customers to this URL to take them to Checkout.',
                        },
                        success_url: {
                            type: 'string',
                            format: 'oaf-url',
                            description: 'The URL the customer will be directed to after the payment or subscription creation is successful.',
                        },
                    },
                    additionalItems: true,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { securityReview: '', paymentRequirement: 'subscription_credit', status: 'new' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReviewOps/BaseSecurityReviewOps': {
        get: () => ({
            $id: 'securityReviewOps/BaseSecurityReviewOps',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SecurityReviewOps',
            type: 'object',
            required: ['securityReview', 'status'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The identifier of the SecurityReviewOps',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The identifier of the SecurityReview in an external system',
                    sensitivityLevel: 'internal',
                },
                securityReview: {
                    type: 'string',
                    description: 'Stream Id of the Security Review this feedback relates to',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: [
                        'New',
                        'Processing - Ops',
                        'Returned - Ops',
                        'In Review - ProdSec',
                        'Returned - ProdSec',
                        'Pass - ProdSec',
                        'Failed - ProdSec',
                        'Expired - Ops',
                    ],
                    description: 'The Review status of the security review made by Ops team',
                    sensitivityLevel: 'internal',
                },
                approvalDate: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: 'Date when the SR was approved',
                    sensitivityLevel: 'internal',
                },
                plugins: {
                    type: 'array',
                    default: [],
                    description: 'The generic plugins added to this Security Review Ops',
                    items: schemas['securityReviewOps/plugin'].get(),
                },
                user_created_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the Security Review was created in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'internal',
                },
                user_updated_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the Security Review was updated at in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'internal',
                },
                org62SecurityReviewId: {
                    type: 'string',
                    description: 'Id of the Security Review from Org62',
                    sensitivityLevel: 'internal',
                },
                org62SecurityReviewName: {
                    type: 'string',
                    maxLength: 80,
                    description: '(Name) - Name field of the Security Review record in Org62',
                    sensitivityLevel: 'internal',
                },
                org62SecurityReviewApp: {
                    type: 'string',
                    maxLength: 80,
                    description: 'Id of the Security Review Application from Org62',
                    sensitivityLevel: 'internal',
                },
                isvAE: {
                    type: 'string',
                    maxLength: 80,
                    description: '(ISV_AE__c) - which is a formula field in Org62 to Application__r.Account__r.ISV_AE__r.LastName',
                    sensitivityLevel: 'internal',
                },
                weeksInReview: {
                    type: 'number',
                    description: '(Length_of_Review_in_weeks__c) - which is a formula field in Org62 (Review_Date__c - DATEVALUE(Date_Ready_for_ProdSec__c))/7',
                    sensitivityLevel: 'internal',
                },
                timesReviewed: {
                    type: 'number',
                    maxLength: 15,
                    description: '(of_Times_Reviewed__c)',
                    sensitivityLevel: 'internal',
                },
                weeksInQueue: {
                    type: 'number',
                    description: '(Weeks_in_Queue__c) - which is a formula field in Org62 (TODAY()-DATEVALUE(Date_Ready_for_ProdSec__c))/7',
                    sensitivityLevel: 'internal',
                },
                partnerWaitingReason: {
                    type: 'string',
                    description: '(External_Waiting_on_Partner_Reason__c) - Explanation of what we are waiting for from the partner',
                    sensitivityLevel: 'internal',
                },
                reviewDate: { type: 'string', description: '(Review_Date__c)', sensitivityLevel: 'internal' },
                primaryReviewer: {
                    type: 'string',
                    description: '(Primary_Reviewer__c) - Picklist values with names',
                    sensitivityLevel: 'internal',
                },
                secondaryReviewer: {
                    type: 'string',
                    description: '(Secondary_Reviewer__c) - Picklist values with names',
                    sensitivityLevel: 'internal',
                },
                reviewResults: {
                    type: 'string',
                    description: '(Review_Results__c) - Picklist with values:Pass/Provisional Pass/Fail',
                    sensitivityLevel: 'internal',
                },
                provisionalExpiryDate: {
                    type: 'string',
                    description: '(Provisional_Expiry_Date__c) - Provisional Expiry Date',
                    sensitivityLevel: 'internal',
                },
                isHighPriority: {
                    type: 'boolean',
                    description: 'If true so it gets picked up sooner by the product security team. (Priority__c)',
                    default: false,
                    sensitivityLevel: 'internal',
                },
                attemptsCount: {
                    type: 'number',
                    description: 'This is the number of current attempts in the current review cycle. This value can be inherited from previous failed or not submitted reviews. It will be incremented only when a security reaches a finalized State meaning when it reaches Pass/Fail. When inherited if previous was a failure it will be incremented otherwise it will reset to 1',
                    default: 0,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { securityReview: '', status: 'New' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReviewOps/plugin': {
        get: () => ({
            $id: 'securityReviewOps/plugin',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SecurityReviewOpsPlugin',
            type: 'object',
            required: ['pluginType', 'data'],
            properties: {
                pluginType: { type: 'string', enum: ['securityReviewOps/plugins/SRFeedback'] },
                data: { anyOf: [schemas['securityReviewOps/plugins/SRFeedback'].get()] },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { pluginType: 'securityReviewOps/plugins/SRFeedback' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReviewOps/plugins/SRFeedback': {
        get: () => ({
            $id: 'securityReviewOps/plugins/SRFeedback',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SRFeedback',
            type: 'object',
            required: ['items'],
            properties: {
                items: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: {
                        type: 'object',
                        required: ['date', 'feedback', 'submissionDate'],
                        properties: {
                            date: {
                                type: 'string',
                                format: 'date',
                                description: 'Date of the feedback',
                                sensitivityLevel: 'internal',
                            },
                            feedback: {
                                title: 'Feedback Categories',
                                description: 'SR Feedback, this will be shown to the Partner',
                                type: 'object',
                                required: [],
                                properties: {
                                    invalidCredentialsMissingEnvironment: {
                                        title: 'InvalidCredentialsMissingEnvironmentActionItem',
                                        type: 'object',
                                        required: [],
                                        properties: {
                                            invalidExpiredOrgCredentials: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            invalidExpiredOrgCredentialsDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                            missingAuthenticationWebApp: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            missingAuthenticationWebAppDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                            missingCredentialsApiOnly: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            missingCredentialsPackage: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            missingMobileAppLinks: { type: 'boolean', sensitivityLevel: 'internal' },
                                            credentialsIsSandbox: { type: 'boolean', sensitivityLevel: 'internal' },
                                            rdpCredentialsRequired: { type: 'boolean', sensitivityLevel: 'internal' },
                                            missingMarketingCloudEnvironment: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                        },
                                        additionalProperties: false,
                                    },
                                    missingIncompleteDocumentation: {
                                        title: 'MissingIncompleteDocumentationActionItem',
                                        type: 'object',
                                        required: [],
                                        properties: {
                                            missingCheckmarxScanReport: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            missingCheckmarxFalsePositiveDoc: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            missingWebAppScans: { type: 'boolean', sensitivityLevel: 'internal' },
                                            missingWebAppScansDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                            missingWebAppScanFalsePositiveDoc: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            missingApiDocumentation: { type: 'boolean', sensitivityLevel: 'internal' },
                                            missingApiDocumentationDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                            missingUsageDocumentation: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            missingMcEnvironmentInstructions: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                        },
                                        additionalProperties: false,
                                    },
                                    issueOrgPackage: {
                                        title: 'IssueOrgPackageActionItem',
                                        type: 'object',
                                        required: [],
                                        properties: {
                                            identityChallengeEnabled: { type: 'boolean', sensitivityLevel: 'internal' },
                                            packagingOrg: { type: 'boolean', sensitivityLevel: 'internal' },
                                            managedPackageNotInstalled: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            incorrectVersionInstalled: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            incorrectVersionInstalledDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                            unmanagedExpiredBeta: { type: 'boolean', sensitivityLevel: 'internal' },
                                            extraPackagesInstalled: { type: 'boolean', sensitivityLevel: 'internal' },
                                            extraPackagesInstalledDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                            myDomainRequired: { type: 'boolean', sensitivityLevel: 'internal' },
                                            packageInstalledInFreeDevOrg: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            packageInstalledInFreeDevOrgDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                            packageInstalledInTrialOrg: {
                                                type: 'boolean',
                                                sensitivityLevel: 'internal',
                                            },
                                            packageInstalledInTrialOrgDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                        },
                                        additionalProperties: false,
                                    },
                                    other: {
                                        title: 'OtherActionItem',
                                        type: 'object',
                                        required: [],
                                        properties: {
                                            otherDetail: {
                                                type: 'string',
                                                minLength: 1,
                                                maxLength: 32000,
                                                sensitivityLevel: 'internal',
                                            },
                                        },
                                        additionalProperties: false,
                                    },
                                },
                                additionalProperties: false,
                            },
                            submissionDate: {
                                type: 'string',
                                description: 'Date when the submission was made',
                                format: 'date',
                                sensitivityLevel: 'internal',
                            },
                        },
                        additionalProperties: false,
                    },
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { items: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/BaseSecurityReview': {
        get: () => ({
            $id: 'securityReview/BaseSecurityReview',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SecurityReview',
            type: 'object',
            required: ['solution', 'org62AccountId', 'status', 'plugins'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The identifier of the SecurityReview',
                    sensitivityLevel: 'public',
                },
                external_id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The identifier of the SecurityReview in an external ',
                    sensitivityLevel: 'public',
                },
                solution: {
                    type: 'string',
                    description: 'Stream Id of the solution being reviewed',
                    sensitivityLevel: 'public',
                },
                isSubmitted: { type: 'boolean', description: 'Has the SR been submitted?', sensitivityLevel: 'public' },
                isLegacy: {
                    type: 'boolean',
                    description: 'If the SR was created on mercury or was created on tz',
                    sensitivityLevel: 'internal',
                },
                isReReview: {
                    type: 'boolean',
                    description: 'Indicates if the SR is a Re-Review or a brand new one',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: ['New', 'Submitted', 'Re-submitted', 'Revoked'],
                    description: 'The status of the security review of the solution that is represented by this record',
                    sensitivityLevel: 'public',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                plugins: {
                    type: 'array',
                    default: [],
                    description: 'The generic plugins added to this Security Review',
                    items: schemas['securityReview/plugin'].get(),
                },
                user_created_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the Security Review was created in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'internal',
                },
                user_updated_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the Security Review was updated at in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'internal',
                },
                attemptsCount: {
                    type: 'number',
                    description: 'This is the number of current attempts in the current review cycle. This value can be inherited from previous failed or not submitted reviews. (deprecated)',
                    default: 0,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { solution: '', status: 'New', org62AccountId: '', plugins: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugin': {
        get: () => ({
            $id: 'securityReview/plugin',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SecurityReviewPlugin',
            type: 'object',
            required: ['pluginType', 'data'],
            properties: {
                pluginType: {
                    type: 'string',
                    enum: [
                        'securityReview/plugins/ContactInformation',
                        'securityReview/plugins/Reports',
                        'securityReview/plugins/TestEnvironments',
                        'securityReview/plugins/TechnologyDetails',
                        'securityReview/plugins/RaiseAChallenge',
                        'securityReview/plugins/FalsePositive',
                    ],
                },
                data: {
                    anyOf: [
                        schemas['securityReview/plugins/ContactInformation'].get(),
                        schemas['securityReview/plugins/Reports'].get(),
                        schemas['securityReview/plugins/TestEnvironments'].get(),
                        schemas['securityReview/plugins/TechnologyDetails'].get(),
                        schemas['securityReview/plugins/RaiseAChallenge'].get(),
                        schemas['securityReview/plugins/FalsePositive'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { pluginType: 'securityReview/plugins/ContactInformation' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/FalsePositive': {
        get: () => ({
            $id: 'securityReview/plugins/FalsePositive',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'FalsePositive',
            type: 'object',
            required: [],
            properties: {
                fileName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'File name',
                    sensitivityLevel: 'internal',
                },
                mediaId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 50,
                    description: 'UUID of a file hosted by the image upload service.',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/RaiseAChallenge': {
        get: () => ({
            $id: 'securityReview/plugins/RaiseAChallenge',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'RaiseAChallenge',
            type: 'object',
            required: [],
            properties: {
                challenges: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/RaiseAChallenge/Challenge'].get(),
                    sensitivityLevel: 'internal',
                },
                challengeRaised: {
                    type: 'boolean',
                    description: 'Flag to determine if the challege was just raised.',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/RaiseAChallenge/Challenge': {
        get: () => ({
            $id: 'securityReview/plugins/RaiseAChallenge/Challenge',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Challenge',
            type: 'object',
            required: ['challenge', 'challengeDate'],
            properties: {
                challengeDate: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: 'Date the challenge was raised',
                    sensitivityLevel: 'internal',
                },
                challenge: {
                    type: 'string',
                    description: 'Challenge that the partner sent to Ops',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { challengeDate: '', challenge: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/TechnologyDetails': {
        get: () => ({
            $id: 'securityReview/plugins/TechnologyDetails',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'TechnologyDetails',
            type: 'object',
            required: [],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the Technology Details',
                    sensitivityLevel: 'internal',
                },
                technicalDescription: {
                    type: 'string',
                    description: "Solution's technical description",
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                includesRequiresWebSvc: {
                    type: 'boolean',
                    description: 'Does the solution require or includes a Web Application or Web Service?',
                    sensitivityLevel: 'internal',
                },
                includesRequiresWebSvcDetails: {
                    type: 'string',
                    description: 'Framework and Languages that the solution uses',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                useOtherPlatform: {
                    type: 'boolean',
                    description: 'Does the solution uses any other platform than Lightning Platform?',
                    sensitivityLevel: 'internal',
                },
                useOtherPlatformDetails: {
                    type: 'string',
                    description: 'Other platforms used and how they are used',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                integratesWithExternalTech: {
                    type: 'boolean',
                    description: 'Does the solution integrates with technology external to the SF platform?',
                    sensitivityLevel: 'internal',
                },
                integratesWithExternalTechDetails: {
                    type: 'string',
                    description: 'Details about external technologies',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                isApiOnly: {
                    type: 'boolean',
                    description: 'Is the solution an API-only app?',
                    sensitivityLevel: 'internal',
                },
                isJapaneseSolution: {
                    type: 'boolean',
                    default: false,
                    description: 'Does Your Solution Use Japanese Text?',
                    sensitivityLevel: 'internal',
                },
                containsSFTech: {
                    type: 'boolean',
                    description: 'Does the solution contains SF technology(Apex,Lightning components)?',
                    sensitivityLevel: 'internal',
                },
                containsSFTechDetails: {
                    type: 'string',
                    description: 'Details about SF technologies used',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                storesAuthToken: {
                    type: 'boolean',
                    description: 'Does the solution stores auth tokens?',
                    sensitivityLevel: 'internal',
                },
                storesAuthTokenDetails: {
                    type: 'string',
                    description: 'Details about how auth tokens are stored',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                storesOutsideSF: {
                    type: 'boolean',
                    description: 'Does the solution stores SF data outside Lightning Platform?',
                    sensitivityLevel: 'internal',
                },
                storesOutsideSFDetails: {
                    type: 'string',
                    description: 'Details about how SF data is stored outside Lightning Platform',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                isMobileAppAvailable: {
                    type: 'boolean',
                    description: 'Is the solution available as a mobile app?',
                    sensitivityLevel: 'internal',
                },
                devicesTarget: {
                    type: 'boolean',
                    description: 'Mobile devices or operating systems the app targets',
                    sensitivityLevel: 'internal',
                },
                devicesTargetDetails: {
                    type: 'string',
                    description: 'List of mobile devices or operating systems the app targets',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                includesBrowserExtension: {
                    type: 'boolean',
                    description: 'Does the solution includes a browser extension?',
                    sensitivityLevel: 'internal',
                },
                browserExtensionDetails: {
                    type: 'string',
                    description: 'Browser extension details',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
                includesClientApp: {
                    type: 'boolean',
                    description: 'Does the solution includes a desktop or client app?',
                    sensitivityLevel: 'internal',
                },
                clientAppDetails: {
                    type: 'string',
                    description: 'desktop or client app details',
                    maxLength: 32000,
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/TestEnvironments': {
        get: () => ({
            $id: 'securityReview/plugins/TestEnvironments',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'TestEnvironments',
            type: 'object',
            required: [],
            properties: {
                salesforceOrgs: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/TestEnvironments/SFOrgItem'].get(),
                },
                webAppAndServices: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/TestEnvironments/WebAppItem'].get(),
                },
                clientApps: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/TestEnvironments/ClientAppItem'].get(),
                },
                mobileApps: {
                    type: 'object',
                    properties: {
                        applications: {
                            type: 'array',
                            default: [],
                            minItems: 0,
                            items: schemas['securityReview/plugins/TestEnvironments/MobileAppItem'].get(),
                        },
                        installationLinks: {
                            type: 'array',
                            default: [],
                            minItems: 0,
                            items: schemas['securityReview/plugins/TestEnvironments/MobileAppLinkItem'].get(),
                        },
                    },
                },
                otherInfo: {
                    type: 'string',
                    description: 'Other information that will help test the solution',
                    maxLength: 1000,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/TestEnvironments/MobileAppLinkItem': {
        get: () => ({
            $id: 'securityReview/plugins/TestEnvironments/MobileAppLinkItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MobileAppLinkItem',
            type: 'object',
            required: ['installationLink', 'description'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the MobileAppLinkItem',
                    sensitivityLevel: 'internal',
                },
                installationLink: {
                    default: '',
                    type: 'string',
                    maxLength: 255,
                    description: 'Installation Link',
                    sensitivityLevel: 'internal',
                },
                description: {
                    default: '',
                    type: 'string',
                    maxLength: 1000,
                    description: 'Instructions on how to install',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { installationLink: '', description: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/TestEnvironments/MobileAppItem': {
        get: () => ({
            $id: 'securityReview/plugins/TestEnvironments/MobileAppItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MobileAppItem',
            type: 'object',
            required: ['mediaId', 'platform'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the MobileAppItem',
                    sensitivityLevel: 'internal',
                },
                platform: {
                    type: 'string',
                    enum: ['iOS', 'Android', 'Other'],
                    description: 'Mobile Platform (ios,android)',
                    sensitivityLevel: 'internal',
                },
                fileName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'File name',
                    sensitivityLevel: 'internal',
                },
                description: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 1000,
                    description: 'description of hte file',
                    sensitivityLevel: 'internal',
                },
                mediaId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 50,
                    description: 'UUID of a file hosted by the image upload service.',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { platform: 'iOS', mediaId: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/TestEnvironments/ClientAppItem': {
        get: () => ({
            $id: 'securityReview/plugins/TestEnvironments/ClientAppItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ClientAppItem',
            type: 'object',
            required: ['installationLink', 'description'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the ClientAppItem',
                    sensitivityLevel: 'internal',
                },
                installationLink: {
                    type: 'string',
                    description: 'Installation link',
                    sensitivityLevel: 'internal',
                    default: '',
                    maxLength: 255,
                },
                description: {
                    type: 'string',
                    description: 'Client App description',
                    sensitivityLevel: 'internal',
                    default: '',
                    maxLength: 1000,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { installationLink: '', description: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/TestEnvironments/WebAppItem': {
        get: () => ({
            $id: 'securityReview/plugins/TestEnvironments/WebAppItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'WebAppItem',
            type: 'object',
            required: ['authType', 'loginUrl'],
            properties: {
                authType: {
                    type: 'string',
                    enum: ['API', 'OAuth', 'SAML'],
                    description: 'Indicates the auth type',
                    sensitivityLevel: 'internal',
                },
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the item',
                    sensitivityLevel: 'internal',
                },
                loginUrl: { type: 'string', description: 'Login url', maxLength: 255, sensitivityLevel: 'internal' },
                description: {
                    type: 'string',
                    description: 'Web app description',
                    sensitivityLevel: 'internal',
                    maxLength: 1000,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { authType: 'API', loginUrl: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/TestEnvironments/SFOrgItem': {
        get: () => ({
            $id: 'securityReview/plugins/TestEnvironments/SFOrgItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SFOrgItem',
            type: 'object',
            required: ['authType', 'loginUrl'],
            properties: {
                authType: {
                    type: 'string',
                    enum: ['Salesforce', 'Other'],
                    description: 'Indicates the auth type',
                    sensitivityLevel: 'internal',
                },
                loginUrl: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'Indicates the login url',
                    sensitivityLevel: 'internal',
                },
                username: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 100,
                    description: 'Indicates the Username',
                    sensitivityLevel: 'internal',
                },
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the item',
                    sensitivityLevel: 'internal',
                },
                description: {
                    type: 'string',
                    description: 'Org description',
                    sensitivityLevel: 'internal',
                    maxLength: 1000,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { authType: 'Salesforce', loginUrl: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/Reports': {
        get: () => ({
            $id: 'securityReview/plugins/Reports',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Reports',
            type: 'object',
            required: [],
            properties: {
                architectureAndUsage: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/Reports/ReportsItem'].get(),
                    sensitivityLevel: 'internal',
                },
                sampleAPICallouts: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/Reports/ReportsItem'].get(),
                    sensitivityLevel: 'internal',
                },
                securityScanner: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/Reports/ReportsItem'].get(),
                    sensitivityLevel: 'internal',
                },
                falsePositives: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/Reports/ReportsItem'].get(),
                    sensitivityLevel: 'internal',
                },
                noFalsePositivesConfirmation: {
                    type: 'boolean',
                    description: 'Confirmation that there are no false positives',
                    sensitivityLevel: 'internal',
                },
                sfCodeAnalyzer: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/Reports/ReportsItem'].get(),
                    sensitivityLevel: 'internal',
                },
                noSFCodeAnalyzerConfirmation: {
                    type: 'boolean',
                    description: 'Confirmation that there is no SF code analyzer',
                    sensitivityLevel: 'internal',
                },
                noSFCodeAnalyzerReasons: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'Reasons why they did not use SF code analyzer',
                    sensitivityLevel: 'internal',
                },
                otherDocs: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['securityReview/plugins/Reports/ReportsItem'].get(),
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/Reports/ReportsItem': {
        get: () => ({
            $id: 'securityReview/plugins/Reports/ReportsItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ReportsItem',
            type: 'object',
            required: ['mediaId', 'fileTitle', 'fileName'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the ReportItem',
                    sensitivityLevel: 'internal',
                },
                fileTitle: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 100,
                    description: 'File Title',
                    sensitivityLevel: 'internal',
                },
                fileName: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'File name',
                    sensitivityLevel: 'internal',
                },
                mediaId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 50,
                    description: 'UUID of a file hosted by the image upload service.',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { fileTitle: '', fileName: '', mediaId: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'securityReview/plugins/ContactInformation': {
        get: () => ({
            $id: 'securityReview/plugins/ContactInformation',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ContactInformation',
            type: 'object',
            required: ['name', 'primaryEmail', 'secondaryEmail'],
            properties: {
                name: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 100,
                    description: 'Name of this contact',
                    sensitivityLevel: 'internal',
                },
                primaryEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 1,
                    maxLength: 100,
                    description: 'Email of the primary contact',
                    sensitivityLevel: 'internal',
                },
                secondaryEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 1,
                    maxLength: 80,
                    description: 'Email of the secondary contact',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', primaryEmail: '', secondaryEmail: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'business_approval/BusinessApproval': {
        get: () => ({
            $id: 'business_approval/BusinessApproval',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'BusinessApproval',
            type: 'object',
            required: ['external_id', 'listing', 'status', 'sent'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the approval (uuid)',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the approval',
                    sensitivityLevel: 'internal',
                },
                listing: {
                    type: 'string',
                    description: 'UUID reference or External Id to the listing stream associated to this approval',
                    sensitivityLevel: 'internal',
                },
                org62_id: {
                    type: 'string',
                    description: 'The Application__c record id from org62 referred to this approval',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    default: '',
                    description: 'The status of this approval.  "New" is deprecated, please do not use.',
                    enum: ['New', 'Draft', 'Submitted', 'In Review', 'Returned', 'Approved'],
                    sensitivityLevel: 'internal',
                },
                message: {
                    type: 'string',
                    description: 'The message associated to this approval',
                    default: '',
                    sensitivityLevel: 'internal',
                },
                sent: {
                    type: 'boolean',
                    description: 'Indicates if this approval was sent or not',
                    default: false,
                    sensitivityLevel: 'internal',
                },
                unsent_change_case: {
                    type: 'boolean',
                    description: 'Indicates if this approval has an unsent change that will trigger re-review',
                    default: false,
                    sensitivityLevel: 'internal',
                },
                needs_update_from_org: {
                    type: 'boolean',
                    description: 'Indicates if this approval needs updates from org62',
                    default: false,
                    sensitivityLevel: 'internal',
                },
                number_of_retries_to_org62: {
                    type: 'number',
                    description: 'Indicates how many times this business approval has been tried to be sent to org62',
                    sensitivityLevel: 'internal',
                },
                last_sent_status_message: {
                    type: 'string',
                    description: 'Save last result message from the callout to org62',
                    default: '',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { external_id: '', listing: '', status: 'New', sent: false };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'reviews_summary/ReviewsSummary': {
        get: () => ({
            $id: 'reviews_summary/ReviewsSummary',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ReviewsSummary',
            type: 'object',
            required: ['external_id', 'listing'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the reviews summary (uuid)',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the reviews summary',
                    sensitivityLevel: 'internal',
                },
                listing: {
                    type: 'string',
                    description: 'UUID reference or External Id to the listing stream associated to this reviews summary',
                    sensitivityLevel: 'internal',
                },
                averageRating: {
                    type: 'number',
                    description: 'The average rating of the associated listing',
                    default: 0,
                    sensitivityLevel: 'public',
                },
                reviewCount: {
                    type: 'integer',
                    description: 'The number of reviews for the associated listing',
                    default: 0,
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { external_id: '', listing: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_plan/Pricing': {
        get: () => ({
            $schema: 'http://json-schema.org/draft-07/schema#',
            $id: 'pricing_plan/Pricing',
            title: 'Pricing',
            version: '1.0.0',
            description: 'Pricing plan schema for the pricing service',
            type: 'object',
            required: ['price_model_type', 'listing_id', 'source_id', 'org62AccountId'],
            additionalProperties: false,
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'UUID of this pricing_plan stream.',
                    sensitivityLevel: 'internal',
                },
                external_id: { type: 'string', description: '${source_id}_pricing', sensitivityLevel: 'internal' },
                source_id: {
                    type: 'string',
                    description: 'Either Tz ID of the listing or the UUID external_id of the OAF listing stream',
                    minLength: 15,
                    sensitivityLevel: 'internal',
                },
                listing_id: {
                    type: 'string',
                    description: 'The UUID of the OAF listing stream. Same as owner ID.',
                    minLength: 36,
                    sensitivityLevel: 'internal',
                },
                price_model_type: {
                    type: 'string',
                    enum: ['free', 'freemium', 'paid', 'free_to_install'],
                    description: 'Price type of the plan',
                    sensitivityLevel: 'internal',
                },
                model: schemas['pricing_plan/pricing/PricingModel'].get(),
                checkout_enabled_date: {
                    description: 'Checkout enabled date',
                    type: 'string',
                    format: 'date',
                    sensitivityLevel: 'internal',
                },
                legacy_forced_pricing: {
                    description: 'Legacy Forced Pricing',
                    type: 'string',
                    enum: ['free', 'paid_w/_checkout', 'paid'],
                    sensitivityLevel: 'internal',
                },
                managed_package: {
                    description: 'Indicates if the listing is a managed package',
                    type: 'boolean',
                    sensitivityLevel: 'internal',
                },
                public: {
                    description: 'Indicates if the listing is public or not',
                    type: 'boolean',
                    sensitivityLevel: 'internal',
                },
                source_record_type: {
                    description: 'Listing record type in source',
                    type: 'string',
                    enum: [
                        'app',
                        'bolt_template',
                        'bot',
                        'component',
                        'content',
                        'data',
                        'flow',
                        'job',
                        'service',
                        'template',
                    ],
                    sensitivityLevel: 'internal',
                },
                status: {
                    description: 'Listing status in source',
                    type: 'string',
                    enum: [
                        'new',
                        'in_review',
                        'approved',
                        'inactive',
                        'in_active_rev_place_holder',
                        'delisted',
                        'open',
                        'filled',
                        'completed',
                        'canceled',
                    ],
                    sensitivityLevel: 'internal',
                },
                metadata: {
                    description: 'Pricing Metadata',
                    type: 'array',
                    items: { key: 'string', value: 'string' },
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    minLength: 15,
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                commerce_external_id: {
                    type: 'string',
                    description: 'External Id to the BT Commerce Service that will be the parent of plan records',
                    sensitivityLevel: 'internal',
                },
            },
        }),
        new: (override) => {
            const original = { source_id: '', listing_id: '', price_model_type: 'free', org62AccountId: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_plan/pricing/PricingModel': {
        get: () => ({
            sensitivityLevel: 'internal',
            $schema: 'http://json-schema.org/draft-07/schema#',
            $id: 'pricing_plan/pricing/PricingModel',
            title: 'Pricing Model',
            type: 'object',
            anyOf: [
                schemas['pricing_plan/pricing/pricing_model/Free'].get(),
                schemas['pricing_plan/pricing/pricing_model/Freemium'].get(),
                schemas['pricing_plan/pricing/pricing_model/FreeToInstall'].get(),
                schemas['pricing_plan/pricing/pricing_model/Paid'].get(),
                schemas['pricing_plan/pricing/pricing_model/PaidWithoutCheckout'].get(),
            ],
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_plan/pricing/pricing_model/PaidWithoutCheckout': {
        get: () => ({
            $schema: 'http://json-schema.org/draft-07/schema#',
            $id: 'pricing_plan/pricing/pricing_model/PaidWithoutCheckout',
            title: 'Paid Without Checkout',
            description: 'Paid Without Checkout Model Schema',
            type: 'object',
            required: ['payment_type', 'plans'],
            additionalProperties: false,
            properties: {
                additional_details: {
                    type: 'string',
                    description: 'Additional pricing details',
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                plans: {
                    type: 'array',
                    items: schemas['pricing_plan/pricing/PricePlan'].get(),
                    sensitivityLevel: 'public',
                },
                payment_type: {
                    type: 'string',
                    enum: ['publisher_provided'],
                    description: 'Payment type of the plan',
                    sensitivityLevel: 'public',
                },
                display_plan_names: {
                    description: 'Whether the pricing plan names are displayed or shown as enumerated plans',
                    type: 'boolean',
                    default: false,
                    sensitivityLevel: 'internal',
                },
                discounts_offered: {
                    description: 'Are discounts offered for non-profits and NGOs',
                    type: 'boolean',
                    sensitivityLevel: 'public',
                },
            },
        }),
        new: (override) => {
            const original = { plans: [], payment_type: 'publisher_provided' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_plan/pricing/pricing_model/Paid': {
        get: () => ({
            $schema: 'http://json-schema.org/draft-07/schema#',
            $id: 'pricing_plan/pricing/pricing_model/Paid',
            title: 'Paid',
            description: 'Paid Model Schema',
            type: 'object',
            required: ['payment_collection', 'plans', 'payment_type', 'payment_method'],
            additionalProperties: false,
            properties: {
                plans: {
                    type: 'array',
                    items: schemas['pricing_plan/pricing/PricePlan'].get(),
                    minItems: 1,
                    sensitivityLevel: 'public',
                },
                additional_details: {
                    type: 'string',
                    description: 'Additional pricing details',
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                payment_collection: {
                    description: 'When do we want to collect payment details',
                    type: 'string',
                    enum: ['before', 'after'],
                    sensitivityLevel: 'public',
                },
                payment_type: {
                    type: 'string',
                    enum: ['salesforce_provided'],
                    description: 'Payment type of the plan',
                    sensitivityLevel: 'public',
                },
                payment_method: {
                    type: 'array',
                    uniqueItems: true,
                    minItems: 1,
                    description: 'Valid payment methods for this listing',
                    items: { type: 'string', enum: ['SEPA', 'ACH', 'credit_card'] },
                    sensitivityLevel: 'public',
                },
                display_plan_names: {
                    description: 'Whether the pricing plan names are displayed or shown as enumerated plans',
                    type: 'boolean',
                    default: false,
                    sensitivityLevel: 'internal',
                },
                discounts_offered: {
                    description: 'Are discounts offered for non-profits and NGOs',
                    type: 'boolean',
                    sensitivityLevel: 'public',
                },
            },
        }),
        new: (override) => {
            const original = {
                plans: [],
                payment_collection: 'before',
                payment_type: 'salesforce_provided',
                payment_method: ['SEPA'],
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_plan/pricing/pricing_model/FreeToInstall': {
        get: () => ({
            $schema: 'http://json-schema.org/draft-07/schema#',
            $id: 'pricing_plan/pricing/pricing_model/FreeToInstall',
            title: 'FreeToInstall',
            description: 'Free to install Model Schema',
            required: ['additional_services', 'plans'],
            type: 'object',
            additionalProperties: false,
            properties: {
                additional_details: {
                    type: 'string',
                    description: 'Additional pricing details',
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                plans: {
                    type: 'array',
                    items: schemas['pricing_plan/pricing/PricePlan'].get(),
                    sensitivityLevel: 'public',
                },
                additional_services: {
                    description: 'What paid products or services do customers need to use this product',
                    type: 'string',
                    maxLength: 255,
                    minLength: 1,
                    sensitivityLevel: 'public',
                },
                display_plan_names: {
                    description: 'Whether the pricing plan names are displayed or shown as enumerated plans',
                    type: 'boolean',
                    default: false,
                    sensitivityLevel: 'internal',
                },
                discounts_offered: {
                    description: 'Are discounts offered for non-profits and NGOs',
                    type: 'boolean',
                    sensitivityLevel: 'public',
                },
            },
        }),
        new: (override) => {
            const original = { plans: [], additional_services: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_plan/pricing/pricing_model/Freemium': {
        get: () => ({
            $schema: 'http://json-schema.org/draft-07/schema#',
            $id: 'pricing_plan/pricing/pricing_model/Freemium',
            title: 'Freemium',
            description: 'Freemium Model Schema',
            required: ['user_limitations', 'plans'],
            type: 'object',
            additionalProperties: false,
            properties: {
                additional_details: {
                    type: 'string',
                    description: 'Additional pricing details',
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                plans: {
                    type: 'array',
                    items: schemas['pricing_plan/pricing/PricePlan'].get(),
                    sensitivityLevel: 'public',
                },
                user_limitations: {
                    description: 'What are the user limitations for this product',
                    type: 'string',
                    maxLength: 255,
                    minLength: 1,
                    sensitivityLevel: 'public',
                },
                display_plan_names: {
                    description: 'Whether the pricing plan names are displayed or shown as enumerated plans',
                    type: 'boolean',
                    default: false,
                    sensitivityLevel: 'internal',
                },
                discounts_offered: {
                    description: 'Are discounts offered for non-profits and NGOs',
                    type: 'boolean',
                    sensitivityLevel: 'public',
                },
            },
        }),
        new: (override) => {
            const original = { plans: [], user_limitations: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_plan/pricing/PricePlan': {
        get: () => ({
            $schema: 'http://json-schema.org/draft-07/schema#',
            $id: 'pricing_plan/pricing/PricePlan',
            title: 'Subscription Price Plan',
            description: 'Subscription Price Plan Schema',
            type: 'object',
            required: ['plan_name', 'frequency', 'price', 'currency_code', 'units', 'index'],
            if: { required: ['units'], properties: { units: { const: 'custom' } } },
            then: {
                required: ['custom_unit'],
                properties: {
                    custom_unit: { description: 'Custom unit', type: 'string', maxLength: 40, minLength: 1 },
                },
            },
            additionalProperties: false,
            properties: {
                id: { description: 'Id of the plan', type: 'string', sensitivityLevel: 'internal' },
                frequency: {
                    description: 'Frequency of the plan',
                    type: 'string',
                    enum: ['one-time', 'monthly', 'yearly'],
                    sensitivityLevel: 'public',
                },
                trial_days: {
                    description: 'Number of trial days',
                    type: 'number',
                    minimum: 0,
                    maximum: 730,
                    sensitivityLevel: 'public',
                },
                plan_name: {
                    description: 'Plan name',
                    type: 'string',
                    minLength: 1,
                    maxLength: 80,
                    sensitivityLevel: 'public',
                },
                price: {
                    description: 'Price for this price object',
                    type: 'number',
                    minimum: 0,
                    sensitivityLevel: 'public',
                },
                currency_code: {
                    description: 'Currency code',
                    type: 'string',
                    enum: [
                        'USD',
                        'GBP',
                        'CAD',
                        'AUD',
                        'EUR',
                        'JPY',
                        'AED',
                        'ALL',
                        'BOB',
                        'CHF',
                        'CVE',
                        'INR',
                        'NOK',
                        'NZD',
                        'SGD',
                    ],
                    sensitivityLevel: 'public',
                },
                units: {
                    description: 'Type of units',
                    type: 'string',
                    enum: ['user', 'company', 'custom'],
                    sensitivityLevel: 'public',
                },
                custom_unit: { description: 'Custom unit', type: 'string', maxLength: 40, sensitivityLevel: 'public' },
                lowest_starting_price: {
                    description: 'Is this the lowest starting price?',
                    type: 'boolean',
                    sensitivityLevel: 'public',
                },
                index: { description: 'Ordering index', type: 'integer', sensitivityLevel: 'internal' },
                active: {
                    description: 'Regardless whether the stripe id is filled or not, this field defines if the plan can be shown on the AppExchange Site. This is mapped to SubscriptionPlan__c.Active__c in Tz org.',
                    type: 'boolean',
                    sensitivityLevel: 'internal',
                },
                source_record_type: {
                    description: 'Record type from source',
                    type: 'string',
                    enum: ['external', 'self_checkout'],
                    sensitivityLevel: 'internal',
                },
                stripe_id: { description: 'Stripe Id', type: 'string', maxLength: 255, sensitivityLevel: 'internal' },
                interval_length: {
                    description: 'Interval Length',
                    type: 'integer',
                    minimum: 0,
                    sensitivityLevel: 'public',
                },
                require_custom_to_contact_me: {
                    description: 'Requires custom to contact me',
                    type: 'boolean',
                    sensitivityLevel: 'public',
                },
            },
        }),
        new: (override) => {
            const original = {
                frequency: 'one-time',
                plan_name: '',
                price: 0,
                currency_code: 'USD',
                units: 'user',
                index: 0,
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'pricing_plan/pricing/pricing_model/Free': {
        get: () => ({
            $schema: 'http://json-schema.org/draft-07/schema#',
            $id: 'pricing_plan/pricing/pricing_model/Free',
            title: 'Free',
            description: 'Free Model Schema',
            required: ['plans'],
            type: 'object',
            additionalProperties: false,
            properties: { plans: { type: 'array', maxItems: 0, const: [], sensitivityLevel: 'public' } },
        }),
        new: (override) => {
            const original = { plans: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/Solution': {
        get: () => ({
            $id: 'solution/Solution',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Solution',
            type: 'object',
            required: ['external_id', 'publisher', 'solution', 'org62AccountId', 'technology'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the solution (uuid)',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the solution',
                    sensitivityLevel: 'internal',
                },
                publisher: {
                    type: 'string',
                    description: 'UUID reference or External Id to the publisher stream associated to this solution',
                    sensitivityLevel: 'internal',
                },
                name: {
                    type: 'string',
                    description: 'The internal name of the solution',
                    minLength: 1,
                    maxLength: 128,
                    sensitivityLevel: 'public',
                },
                technology: {
                    type: 'string',
                    enum: [
                        'force/Api',
                        'force/Package',
                        'quip/Api',
                        'quip/Package',
                        'marketing-cloud/Api',
                        'marketing-cloud/Package',
                        'b2c/Api',
                        'b2c/Package',
                        'TrialTemplate',
                        'tableau/Accelerator',
                    ],
                    sensitivityLevel: 'public',
                },
                solution: {
                    type: 'object',
                    description: 'The technology specific data for this solution',
                    anyOf: [
                        schemas['solution/force/Api'].get(),
                        schemas['solution/force/Package'].get(),
                        schemas['solution/quip/Api'].get(),
                        schemas['solution/quip/Package'].get(),
                        schemas['solution/marketing-cloud/Api'].get(),
                        schemas['solution/marketing-cloud/Package'].get(),
                        schemas['solution/b2c/Api'].get(),
                        schemas['solution/b2c/Package'].get(),
                        schemas['solution/TrialTemplate'].get(),
                        schemas['solution/tableau/Accelerator'].get(),
                    ],
                    sensitivityLevel: 'internal',
                },
                user_created_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the solution was created in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'public',
                },
                user_updated_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the solution was updated in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'public',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                external_id: '',
                publisher: '',
                technology: 'force/Api',
                solution: {},
                org62AccountId: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/tableau/Accelerator': {
        get: () => ({
            $id: 'solution/tableau/Accelerator',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Tableau_Solution_Accelerator',
            type: 'object',
            required: ['name', 'url'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 128,
                    description: 'Name/Alias of the Tableau Accelerator',
                    sensitivityLevel: 'public',
                },
                url: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Link of the Tableau Accelerator',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', url: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/TrialTemplate': {
        get: () => ({
            $id: 'solution/TrialTemplate',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Solution_TrialTemplate',
            type: 'object',
            required: ['trialTemplateId'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name/Alias of the TrialTemplate',
                    sensitivityLevel: 'public',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier for the TrialTemplate object(on Tz is the OAF_Id__c)',
                    sensitivityLevel: 'internal',
                },
                trialTemplateId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Id of the TrialTemplate from the TrialTemplate table. (TrialTemplateId__c)',
                    sensitivityLevel: 'internal',
                },
                orgId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Organization where the TrialTemplate associated with this app was created in. (OrgID__c)',
                    sensitivityLevel: 'internal',
                },
                templateCreatedDate: {
                    type: 'string',
                    description: 'Date when the TrialTemplate was created. (TemplateCreatedDate__c)',
                    sensitivityLevel: 'public',
                },
                templateLastModifiedDate: {
                    type: 'string',
                    description: 'Date when the TrialTemplate was last modified. (TemplateLastModifiedDate__c)',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { trialTemplateId: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/b2c/Package': {
        get: () => ({
            $id: 'solution/b2c/Package',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_Solution_Package',
            type: 'object',
            required: ['name', 'url'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 128,
                    description: 'Name/Alias of the cartridge',
                    sensitivityLevel: 'public',
                },
                url: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Github URL for this cartridge',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', url: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/b2c/Api': {
        get: () => ({
            $id: 'solution/b2c/Api',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_Solution_Api',
            type: 'object',
            required: ['name'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 128,
                    description: 'Name/Alias of the Api',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/marketing-cloud/Package': {
        get: () => ({
            $id: 'solution/marketing-cloud/Package',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_Solution_Package',
            type: 'object',
            required: ['name', 'version', 'packageId'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name/Alias of the package (PackageName__c)',
                    sensitivityLevel: 'public',
                },
                createdDate: {
                    type: 'string',
                    maxLength: 100,
                    description: 'Date this package was created',
                    sensitivityLevel: 'public',
                },
                lastModifiedDate: {
                    type: 'string',
                    description: 'Date this package was last modified',
                    sensitivityLevel: 'public',
                },
                packageId: {
                    type: 'string',
                    description: 'Id of the package (PackageId__c)',
                    sensitivityLevel: 'public',
                },
                namespacePrefix: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Namespace prefix for packages. (NamespacePrefix__c)',
                    sensitivityLevel: 'public',
                },
                packageCategory: {
                    type: 'string',
                    enum: ['Unmanaged', 'Managed', 'Managed (2GP)', 'Unlocked'],
                    description: 'Indicates Package Type (PackageType__c)',
                    sensitivityLevel: 'public',
                },
                orgId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Organization where the package associated with this app was created in. (OrgID__c)',
                    sensitivityLevel: 'internal',
                },
                version: {
                    type: 'object',
                    properties: {
                        packageVersionId: {
                            type: 'string',
                            description: 'The package version ID for the private app package that is associated with the AppListing. (PackageVersionID__c)',
                            sensitivityLevel: 'confidential',
                        },
                        versionName: { type: 'string', sensitivityLevel: 'public' },
                        majorVersion: {
                            type: 'integer',
                            maxLength: 13,
                            minimum: 0,
                            description: 'The major version of the package version associated with this app record. Major versions are always greater than or equal to 1. The higher the major version, the later the package version was released. (MajorVersion__c)',
                            sensitivityLevel: 'public',
                        },
                        minorVersion: {
                            type: 'integer',
                            maxLength: 3,
                            minimum: 0,
                            description: 'The minor version of the package version associated with this app record. Minor versions are always greater than or equal to 0. When combined with the major version, this identifies the order in which the package versions were released. (MinorVersion__c)',
                            sensitivityLevel: 'public',
                        },
                        patchVersion: {
                            type: 'integer',
                            maxLength: 3,
                            minimum: 0,
                            description: 'The patch version of the package version associated with this app record. Patch versions are always greater than or equal to 0. When combined with the major version and minor version, this identifies the order in which the package versions were released. (PatchVersion__c)',
                            sensitivityLevel: 'public',
                        },
                        versionOptionsSecurityReviewed: {
                            type: 'boolean',
                            description: 'Value from core table about security review status (this field name is the one on snowflake org, not Tz: VersionOptionsSecurityReviewed__c)',
                            sensitivityLevel: 'public',
                        },
                        isManaged: {
                            type: 'boolean',
                            description: 'Is the package version managed',
                            sensitivityLevel: 'public',
                        },
                        isReleased: {
                            type: 'boolean',
                            description: 'Is the package version released',
                            sensitivityLevel: 'public',
                        },
                    },
                    sensitivityLevel: 'public',
                },
                manifest: {
                    type: 'object',
                    properties: {
                        cmtyBuilderComponentsCount: {
                            type: 'integer',
                            description: 'The number of lightning components with global access and community builder interface in this package. (CommunityBuilderComponents__c)',
                            sensitivityLevel: 'public',
                        },
                        appBuilderComponentsCount: {
                            type: 'integer',
                            description: 'The number of lightning components with global access and app builder interface in this package. (AppBuilderComponents__c)',
                            sensitivityLevel: 'public',
                        },
                        globalComponentsCount: {
                            type: 'integer',
                            description: 'The number of lightning components with global access in this package. (LightningComponentCount__c)',
                            sensitivityLevel: 'public',
                        },
                        applicationsCount: {
                            type: 'integer',
                            description: 'The number of custom apps in this package. (CustomAppCount__c)',
                            sensitivityLevel: 'public',
                        },
                        hasLWC: { type: 'boolean', description: '(hasLWC)', sensitivityLevel: 'public' },
                        objectsCount: {
                            type: 'integer',
                            description: 'The number of custom objects in this package. (CustomObjectCount__c)',
                            sensitivityLevel: 'public',
                        },
                        tabsCount: {
                            type: 'integer',
                            description: 'The number of custom tabs in this package. (CustomTabCount__c)',
                            sensitivityLevel: 'public',
                        },
                        isLightningAppBuilder: {
                            type: 'boolean',
                            default: false,
                            description: '(isLightningAppBuilder__c)',
                            sensitivityLevel: 'public',
                        },
                        isManaged: {
                            type: 'boolean',
                            default: false,
                            description: '(isManaged)',
                            sensitivityLevel: 'public',
                        },
                        isExtension: {
                            type: 'boolean',
                            default: false,
                            description: '(isExtension)',
                            sensitivityLevel: 'public',
                        },
                        isCommunityBuilder: {
                            type: 'boolean',
                            default: false,
                            description: '(isCommunityBuilder__c)',
                            sensitivityLevel: 'public',
                        },
                    },
                    sensitivityLevel: 'public',
                    additionalProperties: false,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', packageId: '', version: {} };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/marketing-cloud/Api': {
        get: () => ({
            $id: 'solution/marketing-cloud/Api',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_Solution_Api',
            type: 'object',
            required: ['name'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 128,
                    description: 'Name/Alias of the Api',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/quip/Package': {
        get: () => ({
            $id: 'solution/quip/Package',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_Solution_Package',
            type: 'object',
            required: ['name', 'url'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 128,
                    description: 'Name/Alias of the App',
                    sensitivityLevel: 'public',
                },
                url: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Link of the App',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', url: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/quip/Api': {
        get: () => ({
            $id: 'solution/quip/Api',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_Solution_Api',
            type: 'object',
            required: ['name'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 128,
                    description: 'Name/Alias of the Api',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/force/Package': {
        get: () => ({
            $id: 'solution/force/Package',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_Solution_Package',
            type: 'object',
            required: ['name', 'version', 'packageId'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name/Alias of the package (PackageName__c)',
                    sensitivityLevel: 'public',
                },
                createdDate: {
                    type: 'string',
                    maxLength: 100,
                    description: 'Date this package was created',
                    sensitivityLevel: 'public',
                },
                lastModifiedDate: {
                    type: 'string',
                    description: 'Date this package was last modified',
                    sensitivityLevel: 'public',
                },
                latestVersionDate: {
                    type: 'string',
                    description: 'Date of creation of the last version for this package',
                    sensitivityLevel: 'public',
                },
                packageId: {
                    type: 'string',
                    description: 'Id of the package (PackageId__c)',
                    sensitivityLevel: 'public',
                },
                namespacePrefix: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Namespace prefix for packages. (NamespacePrefix__c)',
                    sensitivityLevel: 'public',
                },
                packageCategory: {
                    type: 'string',
                    enum: ['Unmanaged', 'Managed', 'Managed (2GP)', 'Unlocked'],
                    description: 'Indicates Package Type (PackageType__c)',
                    sensitivityLevel: 'public',
                },
                orgId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Organization where the package associated with this app was created in. (OrgID__c)',
                    sensitivityLevel: 'internal',
                },
                version: {
                    type: 'object',
                    properties: {
                        packageVersionId: {
                            type: 'string',
                            description: 'The package version ID for the private app package that is associated with the AppListing. (PackageVersionID__c)',
                            sensitivityLevel: 'confidential',
                        },
                        versionName: { type: 'string', sensitivityLevel: 'public' },
                        majorVersion: {
                            type: 'integer',
                            maxLength: 13,
                            minimum: 0,
                            description: 'The major version of the package version associated with this app record. Major versions are always greater than or equal to 1. The higher the major version, the later the package version was released. (MajorVersion__c)',
                            sensitivityLevel: 'public',
                        },
                        minorVersion: {
                            type: 'integer',
                            maxLength: 3,
                            minimum: 0,
                            description: 'The minor version of the package version associated with this app record. Minor versions are always greater than or equal to 0. When combined with the major version, this identifies the order in which the package versions were released. (MinorVersion__c)',
                            sensitivityLevel: 'public',
                        },
                        patchVersion: {
                            type: 'integer',
                            maxLength: 3,
                            minimum: 0,
                            description: 'The patch version of the package version associated with this app record. Patch versions are always greater than or equal to 0. When combined with the major version and minor version, this identifies the order in which the package versions were released. (PatchVersion__c)',
                            sensitivityLevel: 'public',
                        },
                        versionOptionsSecurityReviewed: {
                            type: 'boolean',
                            description: 'Value from core table about security review status (this field name is the one on snowflake org, not Tz: VersionOptionsSecurityReviewed__c)',
                            sensitivityLevel: 'public',
                        },
                        isManaged: {
                            type: 'boolean',
                            description: 'Is the package version managed',
                            sensitivityLevel: 'public',
                        },
                        isReleased: {
                            type: 'boolean',
                            description: 'Is the package version released',
                            sensitivityLevel: 'public',
                        },
                        lmaOrganizationId: {
                            type: 'string',
                            description: 'Registered License Management Organization Id for this package version',
                            sensitivityLevel: 'internal',
                        },
                        defaultTrialLength: {
                            type: 'integer',
                            description: 'Value from core table for the default trial days set to the package version',
                            sensitivityLevel: 'public',
                        },
                        defaultLicenseStatus: {
                            type: 'string',
                            description: 'Value from core table for the default number of licenses set to the package version',
                            sensitivityLevel: 'public',
                        },
                        defaultLicenseSeats: {
                            type: 'integer',
                            description: 'Default value for License Seats, -1 indicates it is Site-Wide',
                            sensitivityLevel: 'public',
                        },
                        VersionOptionsPackage2DeveloperControlled: {
                            type: 'boolean',
                            description: 'When false, it is a managed 2GP.',
                            sensitivityLevel: 'public',
                        },
                        VersionOptionsPackage2SubscriberEditable: {
                            type: 'boolean',
                            description: 'When VersionOptionsPackage2DeveloperControlled and this are both true, it is an unlocked 2GP.',
                            sensitivityLevel: 'public',
                        },
                    },
                    sensitivityLevel: 'public',
                },
                manifest: {
                    type: 'object',
                    properties: {
                        cmtyBuilderComponentsCount: {
                            type: 'integer',
                            description: 'The number of lightning components with global access and community builder interface in this package. (CommunityBuilderComponents__c)',
                            sensitivityLevel: 'public',
                        },
                        appBuilderComponentsCount: {
                            type: 'integer',
                            description: 'The number of lightning components with global access and app builder interface in this package. (AppBuilderComponents__c)',
                            sensitivityLevel: 'public',
                        },
                        globalComponentsCount: {
                            type: 'integer',
                            description: 'The number of lightning components with global access in this package. (LightningComponentCount__c)',
                            sensitivityLevel: 'public',
                        },
                        applicationsCount: {
                            type: 'integer',
                            description: 'The number of custom apps in this package. (CustomAppCount__c)',
                            sensitivityLevel: 'public',
                        },
                        hasLWC: { type: 'boolean', description: '(hasLWC)', sensitivityLevel: 'public' },
                        objectsCount: {
                            type: 'integer',
                            description: 'The number of custom objects in this package. (CustomObjectCount__c)',
                            sensitivityLevel: 'public',
                        },
                        tabsCount: {
                            type: 'integer',
                            description: 'The number of custom tabs in this package. (CustomTabCount__c)',
                            sensitivityLevel: 'public',
                        },
                        isLightningAppBuilder: {
                            type: 'boolean',
                            default: false,
                            description: '(isLightningAppBuilder__c)',
                            sensitivityLevel: 'public',
                        },
                        isManaged: {
                            type: 'boolean',
                            default: false,
                            description: '(isManaged)',
                            sensitivityLevel: 'public',
                        },
                        isExtension: {
                            type: 'boolean',
                            default: false,
                            description: '(isExtension)',
                            sensitivityLevel: 'public',
                        },
                        isCommunityBuilder: {
                            type: 'boolean',
                            default: false,
                            description: '(isCommunityBuilder__c)',
                            sensitivityLevel: 'public',
                        },
                    },
                    additionalProperties: false,
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '', packageId: '', version: {} };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'solution/force/Api': {
        get: () => ({
            $id: 'solution/force/Api',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_Solution_Api',
            type: 'object',
            required: ['name'],
            properties: {
                name: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name/Alias of the Api',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { name: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher_force/PublisherForce': {
        get: () => ({
            $id: 'publisher_force/PublisherForce',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublisherForce',
            type: 'object',
            required: ['org62AccountId', 'extensions'],
            properties: {
                id: {
                    type: 'string',
                    description: 'The identifier of the publisher_force record',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The identifier of the publisher',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                publisher: {
                    type: 'string',
                    description: 'UUID reference or external id reference to the publisher stream associated to this force publisher',
                    sensitivityLevel: 'internal',
                },
                extensions: {
                    type: 'array',
                    default: [],
                    description: 'Publisher ForceExtensions',
                    items: schemas['publisher_force/extension'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { org62AccountId: '', extensions: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher_force/extension': {
        get: () => ({
            $id: 'publisher_force/extension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublisherForceExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: { type: 'string', enum: ['publisher_force/extensions/ConnectedOrgs'] },
                data: { anyOf: [schemas['publisher_force/extensions/ConnectedOrgs'].get()] },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { extensionType: 'publisher_force/extensions/ConnectedOrgs' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher_force/extensions/ConnectedOrgs': {
        get: () => ({
            $id: 'publisher_force/extensions/ConnectedOrgs',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_ConnectedOrgs',
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        maxLength: 18,
                        description: 'The org id for the connected org',
                        sensitivityLevel: 'confidential',
                    },
                    name: {
                        type: 'string',
                        description: 'The org name queried from the org upon connection',
                        sensitivityLevel: 'confidential',
                    },
                    edition: {
                        type: 'string',
                        maxLength: 255,
                        description: 'The org edition',
                        sensitivityLevel: 'confidential',
                    },
                    external_id: {
                        type: 'string',
                        description: 'The external identifier for the connected org (on Tz is the ConnectedOrg__c)',
                        sensitivityLevel: 'internal',
                    },
                    connected_date: {
                        type: 'string',
                        format: 'iso-datetime',
                        description: "The UTC timestamp the org was connected in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                        sensitivityLevel: 'confidential',
                    },
                },
                required: ['id', 'edition', 'connected_date'],
                additionalProperties: false,
            },
        }),
        new: (override) => {
            const original = [];
            return (override != null ? merge(original, override) : original || []);
        },
    },
    'publisher/BasePublisher': {
        get: () => ({
            $id: 'publisher/BasePublisher',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'BasePublisher',
            type: 'object',
            required: [
                'name',
                'org62AccountId',
                'plugins',
                'extensions',
                'businessEmail',
                'securityReviewEmail',
                'marketingEmail',
                'technicalEmail',
            ],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The identifier of the publisher',
                    sensitivityLevel: 'public',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier of the publisher',
                    sensitivityLevel: 'internal',
                },
                name: {
                    type: 'string',
                    description: 'The name of the publisher',
                    minLength: 1,
                    maxLength: 80,
                    sensitivityLevel: 'public',
                },
                active: {
                    type: 'boolean',
                    default: true,
                    description: 'Boolean to check if Publisher is Active',
                    sensitivityLevel: 'internal',
                },
                deleted: {
                    type: 'boolean',
                    default: false,
                    description: 'Soft delete flag for the publisher',
                    sensitivityLevel: 'internal',
                },
                country: { type: 'string', description: "Publisher's Country", sensitivityLevel: 'public' },
                email: {
                    type: 'string',
                    format: 'oaf-email',
                    maxLength: 80,
                    description: "The publisher's contact email address. (Email__c)",
                    sensitivityLevel: 'public',
                },
                businessEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 1,
                    maxLength: 255,
                    description: "The publisher's business contact email address.",
                    sensitivityLevel: 'confidential',
                },
                securityReviewEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 1,
                    maxLength: 255,
                    description: "The publisher's security reviews contact email address.",
                    sensitivityLevel: 'confidential',
                },
                marketingEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 1,
                    maxLength: 255,
                    description: "The publisher's marketing contact email address.",
                    sensitivityLevel: 'confidential',
                },
                technicalEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 1,
                    maxLength: 255,
                    description: "The publisher's technical contact email address.",
                    sensitivityLevel: 'confidential',
                },
                hQLocation: {
                    type: 'string',
                    description: "Publisher's Head Quarters location",
                    maxLength: 50,
                    sensitivityLevel: 'public',
                },
                website: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: "The publisher's website.",
                    sensitivityLevel: 'public',
                },
                employees: {
                    type: 'integer',
                    maxLength: 5,
                    description: 'Total number of employees at the company.',
                    sensitivityLevel: 'public',
                },
                yearFounded: {
                    type: 'integer',
                    minimum: 1700,
                    maximum: 2100,
                    maxLength: 4,
                    description: 'Year the company was founded (YearFounded__c)',
                    sensitivityLevel: 'public',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                phoneNumber: {
                    type: 'string',
                    maxLength: 40,
                    description: "The publisher's contact phone number. (Phone__c)",
                    sensitivityLevel: 'public',
                },
                description: {
                    type: 'string',
                    maxLength: 1200,
                    description: 'A long description for the publisher. (Description__c)',
                    sensitivityLevel: 'public',
                },
                plugins: {
                    type: 'array',
                    default: [],
                    description: 'The generic plugins added to this publisher',
                    items: schemas['publisher/plugin'].get(),
                },
                extensions: {
                    type: 'array',
                    default: [],
                    description: 'Publisher Extensions',
                    items: schemas['publisher/extension'].get(),
                },
                user_created_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the publisher was created in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'confidential',
                },
                user_updated_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the publisher was updated at in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'confidential',
                },
                marketplaceLocalization: {
                    type: 'object',
                    description: 'Stores localized variations of publisher attributes for different locales. Analog to same-account publishers records for each marketplace on TZ.',
                    sensitivityLevel: 'public',
                    properties: { jp: schemas['publisher/localizations/jp'].get() },
                    additionalProperties: false,
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                name: '',
                businessEmail: '',
                securityReviewEmail: '',
                marketingEmail: '',
                technicalEmail: '',
                org62AccountId: '',
                plugins: [],
                extensions: [],
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher/localizations/jp': {
        get: () => ({
            $id: 'publisher/localizations/jp',
            $schema: 'http://json-schema.org/draft-07/schema#',
            type: 'object',
            title: 'Japanese publisher localization',
            required: ['external_id', 'name', 'plugins'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier of JP the publisher',
                    sensitivityLevel: 'internal',
                },
                name: {
                    type: 'string',
                    description: 'The name of the publisher',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                description: {
                    type: 'string',
                    maxLength: 1200,
                    description: 'A long description for the publisher. (Description__c)',
                    sensitivityLevel: 'public',
                },
                email: {
                    type: 'string',
                    format: 'oaf-email',
                    maxLength: 255,
                    description: "The publisher's contact email address. (Email__c)",
                    sensitivityLevel: 'public',
                },
                website: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: "The publisher's website.",
                    sensitivityLevel: 'public',
                },
                phoneNumber: {
                    type: 'string',
                    maxLength: 40,
                    description: "The publisher's contact phone number. (Phone__c)",
                    sensitivityLevel: 'public',
                },
                hQLocation: {
                    type: 'string',
                    maxLength: 50,
                    description: "Publisher's Head Quarters location",
                    sensitivityLevel: 'public',
                },
                plugins: {
                    type: 'array',
                    default: [],
                    description: 'The generic plugins added to this publisher',
                    items: schemas['publisher/plugin'].get(),
                },
                status: {
                    type: 'string',
                    default: 'Active',
                    enum: ['Active', 'Inactive'],
                    description: 'Indicates if Japanese Publisher Localization is active',
                    sensitivityLevel: 'internal',
                },
                user_created_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the publisher was created in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: true,
        }),
        new: (override) => {
            const original = { external_id: '', name: '', plugins: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher/extension': {
        get: () => ({
            $id: 'publisher/extension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublisherExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: { type: 'string', enum: ['publisher/extensions/force/Publisher'] },
                data: { anyOf: [schemas['publisher/extensions/force/Publisher'].get()] },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { extensionType: 'publisher/extensions/force/Publisher' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher/extensions/force/Publisher': {
        get: () => ({
            $id: 'publisher/extensions/force/Publisher',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_Publisher',
            type: 'object',
            required: [],
            properties: {
                publisherTaxes: {
                    type: 'array',
                    default: [],
                    description: 'The taxes tied to a publisher',
                    items: schemas['publisher/extensions/force/Publisher/PublisherTax'].get(),
                },
                allowBrandedTerms: {
                    type: 'boolean',
                    default: false,
                    description: '(AllowBrandedTerms__c)',
                    sensitivityLevel: 'internal',
                },
                billingAccountId: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Stripe User ID retrieved from signup. (BillingAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                businessApprovalWhitelist: {
                    type: 'boolean',
                    default: false,
                    description: "If true, any listings created under this publisher will automatically have their 'Business Approval' field set to 'Approved' and will not be required to go through the Onboarding questionnaire/process. (Business_Approval_Whitelist__c)",
                    sensitivityLevel: 'internal',
                },
                checkoutSignUpStatus: {
                    type: 'string',
                    enum: ['None', 'SignedUp', 'Live', 'Unauthorized', 'Error'],
                    description: '(CheckoutSignUpStatus__c)',
                    sensitivityLevel: 'internal',
                },
                checkoutStatusChangeDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The Date when the checkout status changed. (CheckoutStatusChangeDate__c)',
                    sensitivityLevel: 'internal',
                },
                complianceQuestionnaireCompletedDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The date a compliance questionnaire was first completed for this publisher. If this field (and the Compliance Questionnaire Completed User field) are complete, then the Compliance Questionnaire will no longer be visible for any listings on this publisher. (Compliance_Questionnaire_Completed_Date__c)',
                    sensitivityLevel: 'internal',
                },
                fullforceCertification: {
                    type: 'string',
                    enum: ['None', 'Fullforce Master', 'Fullforce Solution', 'Fullforce Master & Solution'],
                    description: '(Fullforce_Certification__c)',
                    sensitivityLevel: 'public',
                },
                fullforceMasters: {
                    type: 'string',
                    maxLength: 500,
                    description: 'This field will be used to display the list of the Fullforce Masters that a partner has obtained on the services listings (Fullforce_Masters__c)',
                    sensitivityLevel: 'public',
                },
                logoUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Publisher Logo URL (LogoAttachmentWrapper__r.AttachmentId__c)',
                    sensitivityLevel: 'public',
                },
                orgId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The record ID for the organization to which the user who created this Publisher belongs. This is added to make the query for the Publishing pages simpler. (OrgID__c)',
                    sensitivityLevel: 'confidential',
                },
                siProgramEmergingProductsCount: {
                    type: 'integer',
                    minimum: 0,
                    maximum: 9999,
                    description: 'Specialization Count, as of PY21 it excludes Fullforce and Lightning Bolt (SI_Program_Emerging_Products_Count__c)',
                    sensitivityLevel: 'public',
                },
                siProgramFullforceCount: {
                    type: 'integer',
                    minimum: 0,
                    maximum: 9999,
                    description: 'Masters Count, as of PY21 it excludes Fullforce and Lightning Bolt (SI_Program_Fullforce_Count__c)',
                    sensitivityLevel: 'public',
                },
                stripeAccount: {
                    type: 'string',
                    maxLength: 200,
                    description: 'Stripe account associated with the publisher (Stripe_Account__c)',
                    sensitivityLevel: 'confidential',
                },
                stripeCheckoutSignupStatus: {
                    type: 'string',
                    enum: ['None', 'SignedUp', 'Live', 'Unauthorized', 'Error'],
                    description: 'null (StripeCheckoutSignupStatus__c)',
                    sensitivityLevel: 'confidential',
                },
                vatNumber: {
                    type: 'string',
                    maxLength: 255,
                    description: "Publisher's VAT Number. (VATNumber__c)",
                    sensitivityLevel: 'confidential',
                },
                vatPercentage: {
                    type: 'number',
                    minimum: 0,
                    description: 'Percentage to charge for VAT. (VATPercentage__c)',
                    sensitivityLevel: 'confidential',
                },
                ISVClickthroughUserId: {
                    type: 'string',
                    maxLength: 255,
                    description: 'TZ userId of who signed the click-through. (Publisher__c.Compliance_Questionnaire_Completed_User)',
                    sensitivityLevel: 'internal',
                },
                ISVClickthroughName: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name of user (at the time) who signed ISV click-through agreement',
                    sensitivityLevel: 'internal',
                },
                ISVClickthroughDateTime: {
                    type: 'string',
                    format: 'date-time',
                    maxLength: 255,
                    description: 'ISV click-through date',
                    sensitivityLevel: 'internal',
                },
                agreedTermsId: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The Org62 Id of the Partner Terms that were agreed to',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher/extensions/force/Publisher/PublisherTax': {
        get: () => ({
            $id: 'publisher/extensions/force/Publisher/PublisherTax',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_PublisherTax',
            type: 'object',
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier for the publisher tax on Tz (OAF_Id__c)',
                    sensitivityLevel: 'internal',
                },
                active: { type: 'boolean', default: true, description: '(Active__c)', sensitivityLevel: 'internal' },
                location: { type: 'string', maxLength: 2, description: '(Location__c)', sensitivityLevel: 'internal' },
                type: {
                    type: 'string',
                    enum: ['Vat'],
                    description: 'Type of tax (Type__c)',
                    sensitivityLevel: 'confidential',
                },
                vatNumber: {
                    type: 'string',
                    maxLength: 255,
                    description: '(VAT_Number__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher/plugin': {
        get: () => ({
            $id: 'publisher/plugin',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublisherPlugin',
            type: 'object',
            required: ['pluginType', 'data'],
            properties: {
                pluginType: { type: 'string', enum: ['publisher/plugins/PublisherLogo'] },
                data: { anyOf: [schemas['publisher/plugins/PublisherLogo'].get()] },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { pluginType: 'publisher/plugins/PublisherLogo' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher/plugins/PublisherLogo': {
        get: () => ({
            $id: 'publisher/plugins/PublisherLogo',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublisherLogo',
            type: 'object',
            required: ['items'],
            properties: {
                items: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['publisher/plugins/PublisherLogo/PublisherLogoItem'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { items: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'publisher/plugins/PublisherLogo/PublisherLogoItem': {
        get: () => ({
            $id: 'publisher/plugins/PublisherLogo/PublisherLogoItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PublisherLogoItem',
            type: 'object',
            required: ['logoType', 'mediaId', 'external_id'],
            properties: {
                logoType: {
                    type: 'string',
                    enum: ['Logo', 'Medium Logo', 'Big Logo', 'High Res Logo', 'High Res Svg', 'Small Svg Icon'],
                    description: 'The type of logo',
                    sensitivityLevel: 'internal',
                },
                mediaId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'This field is used to hold information required to display the image. It can be a URL to a partner community file or a UUID of a file hosted by the image upload service.',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier for the image logo (on Tz is the AttachmentWrapper__c)',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { logoType: 'Logo', mediaId: '', external_id: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/BaseListing': {
        get: () => ({
            $id: 'listing/BaseListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'BaseListing',
            type: 'object',
            required: [
                'name',
                'seoTitle',
                'description',
                'fullDescription',
                'technology',
                'public',
                'plugins',
                'extensions',
                'org62AccountId',
                'external_id',
            ],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the listing',
                    sensitivityLevel: 'public',
                },
                external_id: {
                    type: 'string',
                    description: 'The identifier of the listing stream',
                    sensitivityLevel: 'internal',
                },
                publisher: {
                    type: 'string',
                    description: 'UUID reference or External Id to the publisher stream associated to this listing',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'internal',
                },
                name: {
                    type: 'string',
                    description: 'The external name/ title of the listing',
                    minLength: 1,
                    maxLength: 80,
                    sensitivityLevel: 'internal',
                },
                title: {
                    type: 'string',
                    description: 'The title / external name of the listing (deprecated)',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                seoTitle: {
                    default: '',
                    type: 'string',
                    description: 'The search-engine version of the title of the listing',
                    maxLength: 255,
                    sensitivityLevel: 'internal',
                },
                description: {
                    default: '',
                    type: 'string',
                    description: 'Description of the listing',
                    minLength: 1,
                    maxLength: 255,
                    sensitivityLevel: 'public',
                },
                fullDescription: {
                    default: '',
                    type: 'string',
                    description: 'The long description of the AppListing show on the App Detail page.',
                    minLength: 1,
                    maxLength: 1200,
                    sensitivityLevel: 'public',
                },
                technology: {
                    type: 'string',
                    enum: [
                        'force/package',
                        'force/bolt',
                        'force/flow',
                        'force/lightning',
                        'quip/package',
                        'b2c-commerce/package',
                        'salesforce-platform/api',
                        'b2c-commerce/api',
                        'marketing-cloud/api',
                        'tableau/accelerator',
                        'consultant',
                        'force/copilot',
                    ],
                    description: 'The technology type of this listing (force, slack, heroku, etc)',
                    sensitivityLevel: 'internal',
                },
                businessNeeds: schemas['listing/ListingCategories'].get(),
                enableMarketingUse: {
                    type: 'boolean',
                    default: false,
                    description: 'Concent given to use the logo and tile images on Salesforce Marketing.',
                    sensitivityLevel: 'confidential',
                },
                public: {
                    type: 'boolean',
                    default: false,
                    description: 'The availability of this listing on the AppExchange site',
                    sensitivityLevel: 'internal',
                },
                deleted: {
                    type: 'boolean',
                    default: false,
                    description: 'Soft delete flag for the listing',
                    sensitivityLevel: 'internal',
                },
                plugins: {
                    type: 'array',
                    default: [],
                    description: 'The generic plugins added to this listing',
                    items: schemas['listing/plugin'].get(),
                },
                extensions: {
                    type: 'array',
                    default: [],
                    description: 'The technology specific extensions added to this listing',
                    items: schemas['listing/extension'].get(),
                },
                user_created_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the listing was created in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'confidential',
                },
                user_updated_at: {
                    type: 'string',
                    format: 'iso-datetime',
                    description: "The UTC timestamp the listing was updated in ISO string format ex: '2022-05-11T17:57:40.110Z'",
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                external_id: '',
                org62AccountId: '',
                name: '',
                seoTitle: '',
                description: '',
                fullDescription: '',
                technology: 'force/package',
                public: false,
                plugins: [],
                extensions: [],
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extension': {
        get: () => ({
            $id: 'listing/extension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ListingExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: [
                        'listing/extensions/force/listings/Listing',
                        'listing/extensions/b2c/listings/Listing',
                        'listing/extensions/quip/listings/Listing',
                        'listing/extensions/marketing-cloud/listings/Listing',
                        'listing/extensions/consultant/listings/Listing',
                        'listing/extensions/tableau/listings/Listing',
                        'listing/extensions/force/listings/CopilotListing',
                    ],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/force/listings/Listing'].get(),
                        schemas['listing/extensions/b2c/listings/Listing'].get(),
                        schemas['listing/extensions/quip/listings/Listing'].get(),
                        schemas['listing/extensions/marketing-cloud/listings/Listing'].get(),
                        schemas['listing/extensions/consultant/listings/Listing'].get(),
                        schemas['listing/extensions/tableau/listings/Listing'].get(),
                        schemas['listing/extensions/force/listings/CopilotListing'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { extensionType: 'listing/extensions/force/listings/Listing' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/CopilotListing': {
        get: () => ({
            $id: 'listing/extensions/force/listings/CopilotListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_Copilot_Listing',
            type: 'object',
            required: [
                'status',
                'extensions',
                'systemRequirements',
                'productsRequired',
                'productsSupported',
                'languages',
                'highlights',
                'licenseAgreement',
                'searchBlurb',
                'listingCategories',
            ],
            properties: {
                extensions: {
                    type: 'array',
                    description: 'The extensions that force listings can have, including what subtypes the listing can be.',
                    items: schemas['listing/extensions/force/listings/Listing/extension'].get(),
                },
                account: schemas['listing/extensions/force/Account'].get(),
                appType: {
                    type: 'string',
                    default: '',
                    description: 'The App Type of a listing',
                    enum: [
                        'Package/Platform/App',
                        'API/Salesforce Platform API',
                        'API/Marketing Cloud API',
                        'Package/Quip',
                        'Package/B2C Commerce Cloud',
                        'API/B2C Commerce API',
                        'Package/Platform/Bolt',
                        'Package/Platform/Flow',
                        'Package/Platform/Component',
                        'Package/Platform/Data',
                    ],
                    sensitivityLevel: 'internal',
                },
                supportedIndustries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: {
                        type: 'string',
                        enum: [
                            'Horizontal Product',
                            'Agriculture & Mining',
                            'Automotive',
                            'Communications',
                            'Consumer Goods',
                            'Education',
                            'Energy',
                            'Engineering, Construction, & Real Estate',
                            'Financial Services',
                            'Healthcare & Life Sciences',
                            'High Tech',
                            'Manufacturing',
                            'Media & Entertainment',
                            'Professional Services',
                            'Public Sector',
                            'Retail',
                            'Travel, Transportation, and Hospitality',
                            'Nonprofit',
                        ],
                    },
                    uniqueItems: true,
                    description: 'The Supported Induestries that the app is built for.',
                    sensitivityLevel: 'internal',
                },
                targetUserPersona: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: schemas['listing/TargetUserPersona'].get(),
                    description: 'The target user persona that the app is built for.',
                    uniqueItems: true,
                    sensitivityLevel: 'internal',
                },
                acceptedCheckoutAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the checkout agreement terms (AcceptedCheckoutAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the free agreement terms (AcceptedFreeAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAppsAgreement: {
                    type: 'boolean',
                    description: 'Salesforce agreement that the publisher has to accept when a listing is free (AcceptedFreeAppsAgreement__c)',
                    sensitivityLevel: 'confidential',
                },
                acceptedPaidAppsAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the paid agreement terms (AcceptedPaidAppsAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                achApplicationFee: {
                    type: 'string',
                    description: 'Indicates the % to charge on listings purchased with an ACH payment type (AchApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                allowACHPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts ACH as Payment Method during the checkout flow. (AllowACHPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowCCPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts Credit Cards as Payment Method during the checkout flow. (AllowCCPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowSEPAPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts SEPA as Payment Method during the checkout flow. (AllowSEPAPayment__c)',
                    sensitivityLevel: 'public',
                },
                approvedDate: {
                    type: 'string',
                    description: 'This field has the date that the contract was approved. Populated via a callout from the TE org. (Approved_Date__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                businessApproval: {
                    type: 'string',
                    default: 'In Progress',
                    enum: ['Approved', 'Rejected', 'Submitted', 'In Progress', 'Approved Pending Compliance'],
                    description: '(Business_Approval__c)',
                    sensitivityLevel: 'confidential',
                },
                businessRejectionComment: {
                    type: 'string',
                    maxLength: 2000,
                    description: "The reason this listing's Business Questionnaire was rejected. This is used in the email sent to the partner, combined with the Compliance Rejection Comment, informing them that their submission was rejected. (Business_Rejection_Comment__c)",
                    sensitivityLevel: 'confidential',
                },
                businessQuestionnaireSubmittedOn: {
                    type: 'string',
                    description: '(Business_Questionnaire_Submitted_on__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                categories: {
                    type: 'string',
                    enum: ['Cloud Apps', 'Customization', 'Desktop Apps', 'Integration', 'Mobile Apps', 'Websites'],
                    description: '(Categories__c)',
                    sensitivityLevel: 'public',
                },
                listingCategories: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255 },
                    uniqueItems: true,
                    minItems: 0,
                    description: 'New field to hold the categories.',
                    sensitivityLevel: 'public',
                },
                categoriesToFeeds: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'Categories to feed Feeds. (CategoriestoFeeds__c)',
                    sensitivityLevel: 'public',
                },
                checkoutEnabledDate: {
                    type: 'string',
                    description: 'The date when the listing was associated with a Recurly plan or when it was changed form a External to a Recurly plan. (CheckoutEnabledDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                collectPaymentBeforeInstall: {
                    type: 'boolean',
                    description: '(CollectPaymentBeforeInstall__c)',
                    sensitivityLevel: 'internal',
                },
                contractStatus: {
                    type: 'string',
                    enum: ['Incomplete', 'In Progress', 'Approved'],
                    description: 'Contract status set via a callout from the TE org. (Contract_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                contractType: {
                    type: 'string',
                    enum: ['Connector', 'Freemium', 'ISVforce clickthrough', 'ISVforce non-standard', 'OEM', 'VAR'],
                    description: 'Contract type set via a callout from the TE org. (Contract_Type__c)',
                    sensitivityLevel: 'confidential',
                },
                createdByOrgID: {
                    type: 'string',
                    description: 'The Org ID of the user who created the listing (CreatedByOrgID__C)',
                    sensitivityLevel: 'confidential',
                },
                creditorIdentifier: {
                    type: 'string',
                    maxLength: 255,
                    description: 'A Single Euro Payments Area Creditor Identifier or SEPA Creditor Id is a standardized and unchanging identification number that serves to unequivocally identify a creditor across Europe. (CreditorIdentifier__c)',
                    sensitivityLevel: 'confidential',
                },
                curatedListing1: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_1__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing2: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_2__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing3: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_3__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing4: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_4__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing5: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_5__c)",
                    sensitivityLevel: 'public',
                },
                deleteReason: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The reason the publisher specified when deleting this Listing. (DeleteReason__c)',
                    sensitivityLevel: 'confidential',
                },
                delistedDate: {
                    type: 'string',
                    description: 'The date when the listing was delisted (DelistedDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                delistedReason: {
                    type: 'string',
                    enum: [
                        'Partner went out of business',
                        'Partner bought out',
                        'Application had technical issues',
                        'Product failed to gain traction',
                        'Unhappy with partnership',
                        'Temp delisting',
                        'App had not been updated',
                        'No owner to maintain App',
                        'App had low installs',
                        'Not Lightning Ready',
                        'Security non-compliance',
                    ],
                    description: 'Reason for delisting. (DelistedReason__c)',
                    sensitivityLevel: 'confidential',
                },
                devices: {
                    type: 'array',
                    items: { type: 'string', enum: ['Phone', 'Tablet', 'Desktop'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(Devices__c)',
                    sensitivityLevel: 'public',
                },
                directoryEntryID: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The ID of the legacy directory entry record from which this object was migrated. (DirectoryEntryID__c)',
                    sensitivityLevel: 'confidential',
                },
                displayHover: {
                    type: 'boolean',
                    default: true,
                    description: 'Indicates if the tile should display the hover or not (DisplayHover__c)',
                    sensitivityLevel: 'internal',
                },
                editions: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', enum: ['EE', 'UE', 'DE', 'PP', 'FE'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: "Select one or more Salesforce editions with which your app is compatible (Note: 'PP','FE','ES' are deprecated). If your app uses Salesforce APIs, it cannot run on Group or Professional editions. If your app uses any standard Salesforce objects, it cannot run on Force.com edition. (Editions__c)",
                    sensitivityLevel: 'public',
                },
                productsRequired: {
                    type: 'array',
                    items: schemas['listing/CopilotListingSalesforceRequiredProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 4,
                    description: '(Required_Cloud__c)',
                    sensitivityLevel: 'public',
                },
                productsSupported: {
                    type: 'array',
                    items: schemas['listing/CopilotListingSalesforceSupportedProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 0,
                    maxItems: 3,
                    description: '(New field) This is supplimentary information that may add more context to the relevant input.',
                    sensitivityLevel: 'public',
                },
                highlights: {
                    type: 'array',
                    maxItems: 9,
                    default: [],
                    items: { type: 'string', maxLength: 255, minLength: 1 },
                    uniqueItems: false,
                    minItems: 1,
                    description: 'New field to hold the highlights.',
                    sensitivityLevel: 'public',
                },
                featured: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if this listing is returned when users filter for featured apps in the search results. (Featured__c)',
                    sensitivityLevel: 'public',
                },
                filledDateTime: { type: 'string', format: 'date-time', sensitivityLevel: 'confidential' },
                industries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    description: "Indicates which industries categories this Listing belongs to. (CategorizedListing__r.ListingCategory__r.CategoryType__r.Name == 'Industries')",
                    items: { type: 'string' },
                    sensitivityLevel: 'public',
                },
                isFreemium: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is initially free but payment is required for additional users, features, or usage. (Freemium__c)',
                    sensitivityLevel: 'public',
                },
                isLightningComponent: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningComponent__c)',
                    sensitivityLevel: 'public',
                },
                isEinsteinAgent: {
                    type: 'boolean',
                    default: false,
                    description: 'Einstein Copilot',
                    sensitivityLevel: 'public',
                },
                isSalesProgram: {
                    type: 'boolean',
                    default: false,
                    description: 'Sales Program',
                    sensitivityLevel: 'public',
                },
                isLightningReady: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningReady__c)',
                    sensitivityLevel: 'public',
                },
                isMarketingCloud: {
                    type: 'boolean',
                    default: false,
                    description: '(isMarketingCloud__c)',
                    sensitivityLevel: 'public',
                },
                isMultiCurrency: {
                    type: 'boolean',
                    default: false,
                    description: '(isMulti_currency__c)',
                    sensitivityLevel: 'public',
                },
                isPersonAccounts: {
                    type: 'boolean',
                    default: false,
                    description: '(isPersonAccounts__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforce1Mobile: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforce1Mobile__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforceShield: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforceShield__c)',
                    sensitivityLevel: 'public',
                },
                isPledge1Percent: {
                    type: 'boolean',
                    default: false,
                    description: '(isPledge1Percent__c)',
                    sensitivityLevel: 'public',
                },
                isLightningAppBuilder: {
                    type: 'boolean',
                    default: false,
                    description: 'Lightning App Builder',
                    sensitivityLevel: 'public',
                },
                isFedrampCertified: {
                    type: 'boolean',
                    default: false,
                    description: 'FedRAMP Certified',
                    sensitivityLevel: 'public',
                },
                isHIPAACompliant: {
                    type: 'boolean',
                    default: false,
                    description: 'HIPAA Compliant',
                    sensitivityLevel: 'public',
                },
                isMinorityOwned: {
                    type: 'boolean',
                    default: false,
                    description: 'Minority Owned',
                    sensitivityLevel: 'public',
                },
                isDiverseOwnedBusiness: {
                    type: 'boolean',
                    default: false,
                    description: 'Diverse-owned Business',
                    sensitivityLevel: 'public',
                },
                diverseOwnedBusinessURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Diverse-owned Business URL or Cert',
                    sensitivityLevel: 'public',
                },
                isAccessibleSolution: {
                    type: 'boolean',
                    default: false,
                    description: 'Accessible Solution',
                    sensitivityLevel: 'public',
                },
                accessibleSolutionURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Accessible Solution URL or Cert',
                    sensitivityLevel: 'public',
                },
                languages: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', enum: ['en'] },
                    uniqueItems: true,
                    minItems: 1,
                    description: 'Describes the set of languages that this App supports. (Languages__c)',
                    sensitivityLevel: 'public',
                },
                lastStatusChangeDateTime: {
                    type: 'string',
                    format: 'date-time',
                    description: 'The date when the status of the job last changed. (LastStatusChangeDateTime__c)',
                    sensitivityLevel: 'confidential',
                },
                learnMoreURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Specify the URL where the customer can contact the publisher to learn more about installing/buying the app. (LearnMoreURL__c)',
                    sensitivityLevel: 'public',
                },
                longDescription: {
                    type: 'string',
                    maxLength: 1200,
                    description: 'The long description of the AppListing show on the App Detail page. (LongDescription__c)',
                    sensitivityLevel: 'public',
                },
                marketplace: {
                    type: 'string',
                    maxLength: 22,
                    enum: ['English', 'AppExchange_Japanese'],
                    description: 'The Marketplace on which this Listing can be publicly viewed. These values correspond to the Marketplace name, not SFID - they are converted to (Marketplace__c) IDs during Mulesoft sync.',
                    sensitivityLevel: 'internal',
                },
                orderInSetup: {
                    type: 'number',
                    maximum: 99,
                    description: "The place this App has in the Featured Apps Carousel in Org's Setup. i.e : 1 for first, 2 for second, etc.",
                    sensitivityLevel: 'internal',
                },
                org62ApplicationId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Application Record ID on ORG62 (Org62ApplicationId__c)',
                    sensitivityLevel: 'confidential',
                },
                priceDetails: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The detailed pricing information for this App. (PriceDetails__c)',
                    sensitivityLevel: 'public',
                },
                isFree: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if the App on this Listing is free for everyone. (PriceFree__c)',
                    sensitivityLevel: 'public',
                },
                priceNonProfitDiscount: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the app is available to nonprofits for a discount or free. (PriceNonProfitDiscount__c)',
                    sensitivityLevel: 'public',
                },
                pricingRestrictions: {
                    type: 'string',
                    maxLength: 255,
                    description: 'provide by CX (PricingRestrictions__c)',
                    sensitivityLevel: 'internal',
                },
                programmingLanguages: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: [
                            'AandV',
                            'Csharp',
                            'HTMLCSSJavaScript',
                            'Java',
                            'NodeJs',
                            'ObjectiveC',
                            'Perl',
                            'PHP',
                            'Python',
                            'Ruby',
                            'SQLPostgres',
                        ],
                    },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(programmingLanguages__c)',
                    sensitivityLevel: 'public',
                },
                public: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether this Listing is publicly viewable on the Marketplace. (Public__c)',
                    sensitivityLevel: 'internal',
                },
                publishedDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The date when this Listing was publicly published on the Marketplace. (PublishedDate__c)',
                    sensitivityLevel: 'internal',
                },
                publishLocation: {
                    type: 'string',
                    enum: [
                        'AppExchange',
                        'French Partner Finder',
                        'German Partner Finder',
                        'Italian Partner Finder',
                        'Japanese Partner Finder',
                        'Korean Partner Finder',
                        'Portuguese Partner Finder',
                        'Dutch Partner Finder',
                        'Spanish Partner Finder',
                        'Swedish Partner Finder',
                        'Chinese Partner Finder',
                        'Traditional Chinese Partner Finder',
                    ],
                    description: 'Partner finder feed. (PublishLocation__c)',
                    sensitivityLevel: 'internal',
                },
                recordType: {
                    type: 'string',
                    enum: ['App', 'BoltTemplate', 'Bot', 'Component', 'Content', 'Data', 'Flow', 'Service', 'Template'],
                    description: 'The type of listing (RecordTypeId)',
                    sensitivityLevel: 'internal',
                },
                requiresPaidService: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is free but requires a paid subscription to an external service. (RequiresPaidService__c)',
                    sensitivityLevel: 'public',
                },
                searchBlurb: {
                    type: 'string',
                    default: '',
                    maxLength: 75,
                    description: 'Search Blurb to display on the search results page. (SearchBlurb__c)',
                    sensitivityLevel: 'public',
                },
                sepaApplicationFee: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100,
                    description: 'Indicates the % to charge on listings purchased with a SEPA payment type. (SepaApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: [
                        'New',
                        'In Review',
                        'Approved',
                        'Inactive',
                        'InActiveRevPlaceHolder',
                        'Delisted',
                        'Open',
                        'Filled',
                        'Completed',
                        'Canceled',
                    ],
                    default: 'New',
                    description: 'Indicates what stage in the review process the Listing is in for the Marketplace. (Status__c)',
                    sensitivityLevel: 'confidential',
                },
                submissionStatus: {
                    type: 'string',
                    enum: [
                        'Not Ready for Submission / Incomplete',
                        'Ready for Submission',
                        'Submitted - Pending Review',
                        'Approved',
                        'Rejected',
                    ],
                    description: 'Indicates the submission status from the TE org. (Submission_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                systemRequirements: {
                    type: 'string',
                    default: '',
                    maxLength: 255,
                    description: "Specify any additional system requirements that your app may have. For example, supported browsers, operating systems, or hardware. If your app does not have any additional system requirements, select 'No Additional System Requirements'. (SystemRequirements__c)",
                    sensitivityLevel: 'public',
                },
                securityReviewStatus: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Status of the Security Review associated with this Listing. SecReview id in(SecurityReview__c)',
                    sensitivityLevel: 'internal',
                },
                salesEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    maxLength: 255,
                    description: 'The email address for contacting the Publisher sales team. (SalesEmail__c)',
                    sensitivityLevel: 'internal',
                },
                salesPhone: {
                    type: 'string',
                    maxLength: 40,
                    description: 'The phone number for contacting the Publisher sales team. (SalesPhone__c)',
                    sensitivityLevel: 'internal',
                },
                salesWebsite: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The website URL for learning more about buying this App from the Publisher. (SalesWebsite__c)',
                    sensitivityLevel: 'internal',
                },
                licenseAgreement: {
                    type: 'string',
                    default: '',
                    maxLength: 32000,
                    description: 'T&C, The license agreement for the app.(LicenseAgreement__c)',
                    sensitivityLevel: 'public',
                },
                installationAgreement: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'T&C, installation agreement for the app.(Marketplace__r.InstallationAgreement__c)',
                    sensitivityLevel: 'public',
                },
                listingUrl: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Listing site url',
                    sensitivityLevel: 'public',
                },
                selfAttestation: {
                    type: 'boolean',
                    description: 'Indicates if self attestation has been accepted',
                    default: false,
                    sensitivityLevel: 'confidential',
                },
                selfAttestationDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the self attestation',
                    format: 'date-time',
                    sensitivityLevel: 'confidential',
                },
                description: {
                    type: 'string',
                    description: 'Short description of the copilot listing',
                    default: '',
                    maxLength: 500,
                    sensitivityLevel: 'public',
                },
                numAgents: { type: 'number', description: 'Number of agents', default: 0, sensitivityLevel: 'public' },
                numTopics: { type: 'number', description: 'Number of topics', default: 0, sensitivityLevel: 'public' },
                numActions: {
                    type: 'number',
                    description: 'Number of actions',
                    default: 0,
                    sensitivityLevel: 'public',
                },
                listingsRequired: {
                    type: 'array',
                    description: 'Allows to select required listings',
                    default: [],
                    items: { type: 'string', minLength: 36 },
                    uniqueItems: true,
                    minItems: 0,
                    maxItems: 1,
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensions: [],
                listingCategories: [],
                productsRequired: [],
                productsSupported: [],
                highlights: [],
                languages: [],
                searchBlurb: '',
                status: 'New',
                systemRequirements: '',
                licenseAgreement: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/CopilotListingSalesforceSupportedProducts': {
        get: () => ({
            $id: 'listing/CopilotListingSalesforceSupportedProducts',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Copilot_Listing_Salesforce_Supported_Products',
            type: 'string',
            $comment: 'In new schema version, we should change CDP to Data Cloud and Tableau CRM to CRMA. This implies doing a migration file for existing listings. See W-13536440',
            enum: [
                'None',
                'Sales Cloud',
                'Service Cloud',
                'Marketing Cloud',
                'Pardot',
                'Marketing Cloud Growth',
                'Marketing Cloud Advanced',
                'B2B Commerce Cloud',
                'B2C Commerce Cloud',
                'Commerce Cloud Order Management',
                'Revenue Cloud',
                'CDP',
                'Work.com',
                'Platform Cloud',
                'Experience Cloud',
                'Financial Services Cloud',
                'Health Cloud',
                'Net Zero Cloud',
                'Tableau CRM',
                'Datorama',
                'Quip',
                'Customer Data Platform',
                'Revenue Cloud Subscription Management',
                'Revenue Cloud CPQ',
                'Revenue Cloud Billing',
                'Salesforce Web3',
                'Tableau',
                'Tableau Server',
                'Tableau Cloud',
                'Data Cloud for Tableau',
                'Manufacturing Cloud',
                'Nonprofit Cloud',
                'D2C Commerce',
                'Hyperforce',
                'Education Cloud',
            ],
        }),
        new: (override) => {
            const original = 'None';
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/CopilotListingSalesforceRequiredProducts': {
        get: () => ({
            $id: 'listing/CopilotListingSalesforceRequiredProducts',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Copilot_Listing_Salesforce_Required_Products',
            type: 'string',
            $comment: 'In new schema version, we should change CDP to Data Cloud and Tableau CRM to CRMA. This implies doing a migration file for existing listings. See W-13536440',
            enum: [
                'None',
                'Einstein 1',
                'Sales Cloud',
                'Service Cloud',
                'Marketing Cloud',
                'Pardot',
                'Marketing Cloud Growth',
                'Marketing Cloud Advanced',
                'B2B Commerce Cloud',
                'B2C Commerce Cloud',
                'Commerce Cloud Order Management',
                'Revenue Cloud',
                'CDP',
                'Work.com',
                'Platform Cloud',
                'Experience Cloud',
                'Financial Services Cloud',
                'Health Cloud',
                'Net Zero Cloud',
                'Tableau CRM',
                'Datorama',
                'Quip',
                'Customer Data Platform',
                'Revenue Cloud Subscription Management',
                'Revenue Cloud CPQ',
                'Revenue Cloud Billing',
                'Salesforce Web3',
                'Tableau',
                'Manufacturing Cloud',
                'Nonprofit Cloud',
                'D2C Commerce',
            ],
        }),
        new: (override) => {
            const original = 'None';
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/tableau/listings/Listing': {
        get: () => ({
            $id: 'listing/extensions/tableau/listings/Listing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Tableau_Listing',
            type: 'object',
            required: [
                'status',
                'extensions',
                'systemRequirements',
                'productsRequired',
                'productsSupported',
                'languages',
                'highlights',
                'licenseAgreement',
                'searchBlurb',
                'listingCategories',
            ],
            properties: {
                extensions: {
                    type: 'array',
                    description: 'The extensions that tableau listings can have, including what subtypes the listing can be.',
                    items: schemas['listing/extensions/tableau/listings/Listing/extension'].get(),
                },
                supportedIndustries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: {
                        type: 'string',
                        enum: [
                            'Horizontal Product',
                            'Agriculture & Mining',
                            'Automotive',
                            'Communications',
                            'Consumer Goods',
                            'Education',
                            'Energy',
                            'Engineering, Construction, & Real Estate',
                            'Financial Services',
                            'Government',
                            'Healthcare & Life Sciences',
                            'High Tech',
                            'Manufacturing',
                            'Media & Entertainment',
                            'Professional Services',
                            'Public Sector',
                            'Retail',
                            'Travel, Transportation, and Hospitality',
                            'Nonprofit',
                        ],
                    },
                    uniqueItems: true,
                    description: 'The Supported Induestries that the app is built for.',
                    sensitivityLevel: 'internal',
                },
                targetUserPersona: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: schemas['listing/TargetUserPersona'].get(),
                    description: 'The target user persona that the app is built for.',
                    uniqueItems: true,
                    sensitivityLevel: 'internal',
                },
                businessApproval: {
                    type: 'string',
                    default: 'In Progress',
                    enum: ['Approved', 'Rejected', 'Submitted', 'In Progress', 'Approved Pending Compliance'],
                    description: '(Business_Approval__c)',
                    sensitivityLevel: 'confidential',
                },
                listingCategories: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255 },
                    uniqueItems: true,
                    minItems: 0,
                    description: 'New field to hold the categories.',
                    sensitivityLevel: 'public',
                },
                creditorIdentifier: {
                    type: 'string',
                    maxLength: 255,
                    description: 'A Single Euro Payments Area Creditor Identifier or SEPA Creditor Id is a standardized and unchanging identification number that serves to unequivocally identify a creditor across Europe. (CreditorIdentifier__c)',
                    sensitivityLevel: 'confidential',
                },
                delistedDate: {
                    type: 'string',
                    description: 'The date when the listing was delisted (DelistedDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                delistedReason: {
                    type: 'string',
                    enum: [
                        'Partner went out of business',
                        'Partner bought out',
                        'Application had technical issues',
                        'Product failed to gain traction',
                        'Unhappy with partnership',
                        'Temp delisting',
                        'App had not been updated',
                        'No owner to maintain App',
                        'App had low installs',
                        'Not Lightning Ready',
                        'Security non-compliance',
                    ],
                    description: 'Reason for delisting. (DelistedReason__c)',
                    sensitivityLevel: 'confidential',
                },
                productsRequired: {
                    type: 'array',
                    items: schemas['listing/SalesforceRequiredProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 4,
                    description: '(Required_Cloud__c)',
                    sensitivityLevel: 'public',
                },
                productsSupported: {
                    type: 'array',
                    items: schemas['listing/SalesforceSupportedProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 0,
                    maxItems: 3,
                    description: '(New field) This is supplimentary information that may add more context to the relevant input.',
                    sensitivityLevel: 'public',
                },
                highlights: {
                    type: 'array',
                    maxItems: 9,
                    default: [],
                    items: { type: 'string', maxLength: 255, minLength: 1 },
                    uniqueItems: false,
                    minItems: 1,
                    description: 'New field to hold the highlights.',
                    sensitivityLevel: 'public',
                },
                industries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    description: "Indicates which industries categories this Listing belongs to. (CategorizedListing__r.ListingCategory__r.CategoryType__r.Name == 'Industries')",
                    items: { type: 'string' },
                    sensitivityLevel: 'public',
                },
                isPledge1Percent: {
                    type: 'boolean',
                    default: false,
                    description: '(isPledge1Percent__c)',
                    sensitivityLevel: 'public',
                },
                isLightningAppBuilder: {
                    type: 'boolean',
                    default: false,
                    description: 'Lightning App Builder',
                    sensitivityLevel: 'public',
                },
                isDiverseOwnedBusiness: {
                    type: 'boolean',
                    default: false,
                    description: 'Diverse-owned Business',
                    sensitivityLevel: 'public',
                },
                diverseOwnedBusinessURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Diverse-owned Business URL or Cert',
                    sensitivityLevel: 'public',
                },
                isAccessibleSolution: {
                    type: 'boolean',
                    default: false,
                    description: 'Accessible Solution',
                    sensitivityLevel: 'public',
                },
                accessibleSolutionURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Accessible Solution URL or Cert',
                    sensitivityLevel: 'public',
                },
                languages: {
                    type: 'array',
                    default: [],
                    items: schemas['listing/Languages'].get(),
                    uniqueItems: true,
                    minItems: 1,
                    description: 'Describes the set of languages that this App supports. (Languages__c)',
                    sensitivityLevel: 'public',
                },
                learnMoreURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Specify the URL where the customer can contact the publisher to learn more about installing/buying the app. (LearnMoreURL__c)',
                    sensitivityLevel: 'public',
                },
                longDescription: {
                    type: 'string',
                    maxLength: 1200,
                    description: 'The long description of the AppListing show on the App Detail page. (LongDescription__c)',
                    sensitivityLevel: 'public',
                },
                marketplace: {
                    type: 'string',
                    maxLength: 22,
                    enum: ['English', 'AppExchange_Japanese'],
                    description: 'The Marketplace on which this Listing can be publicly viewed. These values correspond to the Marketplace name, not SFID - they are converted to (Marketplace__c) IDs during Mulesoft sync.',
                    sensitivityLevel: 'internal',
                },
                public: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether this Listing is publicly viewable on the Marketplace. (Public__c)',
                    sensitivityLevel: 'internal',
                },
                publishedDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The date when this Listing was publicly published on the Marketplace. (PublishedDate__c)',
                    sensitivityLevel: 'internal',
                },
                searchBlurb: {
                    type: 'string',
                    default: '',
                    maxLength: 75,
                    description: 'Search Blurb to display on the search results page. (SearchBlurb__c)',
                    sensitivityLevel: 'public',
                },
                status: {
                    type: 'string',
                    enum: [
                        'New',
                        'In Review',
                        'Approved',
                        'Inactive',
                        'InActiveRevPlaceHolder',
                        'Delisted',
                        'Open',
                        'Filled',
                        'Completed',
                        'Canceled',
                    ],
                    default: 'New',
                    description: 'Indicates what stage in the review process the Listing is in for the Marketplace. (Status__c)',
                    sensitivityLevel: 'confidential',
                },
                systemRequirements: {
                    type: 'string',
                    default: '',
                    maxLength: 255,
                    description: "Specify any additional system requirements that your app may have. For example, supported browsers, operating systems, or hardware. If your app does not have any additional system requirements, select 'No Additional System Requirements'. (SystemRequirements__c)",
                    sensitivityLevel: 'public',
                },
                licenseAgreement: {
                    type: 'string',
                    default: '',
                    maxLength: 32000,
                    description: 'T&C, The license agreement for the app.(LicenseAgreement__c)',
                    sensitivityLevel: 'public',
                },
                selfAttestation: {
                    type: 'boolean',
                    description: 'Indicates if self attestation has been accepted',
                    default: false,
                    sensitivityLevel: 'confidential',
                },
                selfAttestationDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the self attestation',
                    format: 'date-time',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensions: [],
                listingCategories: [],
                productsRequired: [],
                productsSupported: [],
                highlights: [],
                languages: [],
                searchBlurb: '',
                status: 'New',
                systemRequirements: '',
                licenseAgreement: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/tableau/listings/Listing/extension': {
        get: () => ({
            $id: 'listing/extensions/tableau/listings/Listing/extension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Tableau_Extension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: ['listing/extensions/tableau/listings/Listing/extensions/AcceleratorListing'],
                },
                data: {
                    anyOf: [schemas['listing/extensions/tableau/listings/Listing/extensions/AcceleratorListing'].get()],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/tableau/listings/Listing/extensions/AcceleratorListing',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/tableau/listings/Listing/extensions/AcceleratorListing': {
        get: () => ({
            $id: 'listing/extensions/tableau/listings/Listing/extensions/AcceleratorListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Tableau_AcceleratorListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the accelerator solution stream',
                    sensitivityLevel: 'public',
                },
                provisionFlow: { type: 'string', default: '', enum: ['External'], sensitivityLevel: 'public' },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'External' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/consultant/listings/Listing': {
        get: () => ({
            $id: 'listing/extensions/consultant/listings/Listing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Consultant_Listing',
            type: 'object',
            required: ['status', 'languages', 'highlights', 'learnMoreURL'],
            properties: {
                plugins: {
                    type: 'array',
                    description: 'The plugins that the consultant listing can have',
                    items: schemas['listing/extensions/consultant/listings/Listing/plugin'].get(),
                },
                geographicRegion: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', enum: ['AF', 'AO', 'CA', 'EA', 'EE', 'GL', 'IS', 'NA', 'SA', 'WE'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: 'Geographic Regions that a consulting partner company works in.(Geographic_Region__c)',
                    sensitivityLevel: 'public',
                },
                consultingHeaderBackgroundColor: {
                    type: 'string',
                    maxLength: 7,
                    description: 'This is the consulting header background color that is shown in the consulting listing detail page. Start hexadecimal color value with #. (Consulting_Header_Background_Color__c)',
                    sensitivityLevel: 'public',
                },
                consultingHeaderApplyDarkColor: {
                    type: 'boolean',
                    description: 'Indicates if the header text color that is shown in the consulting listing detail page must be dark or light. True = dark, False = light (Consulting_Header_Apply_Dark_Color__c)',
                    sensitivityLevel: 'public',
                },
                customerSatisfactionRating: {
                    type: 'number',
                    description: 'The CSAT score for this consultant',
                    sensitivityLevel: 'public',
                },
                headerLogo: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Header Logo URI',
                    sensitivityLevel: 'public',
                },
                deleteReason: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The reason the publisher specified when deleting this Listing. (DeleteReason__c)',
                    sensitivityLevel: 'confidential',
                },
                delistedDate: {
                    type: 'string',
                    description: 'The date when the listing was delisted (DelistedDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                delistedReason: {
                    type: 'string',
                    enum: [
                        'Partner went out of business',
                        'Partner bought out',
                        'Application had technical issues',
                        'Product failed to gain traction',
                        'Unhappy with partnership',
                        'Temp delisting',
                        'App had not been updated',
                        'No owner to maintain App',
                        'App had low installs',
                        'Not Lightning Ready',
                        'Security non-compliance',
                    ],
                    description: 'Reason for delisting. (DelistedReason__c)',
                    sensitivityLevel: 'confidential',
                },
                isLightningAccredited: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningAccredited__c)',
                    sensitivityLevel: 'public',
                },
                listingCategories: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255 },
                    uniqueItems: true,
                    minItems: 0,
                    description: 'New field to hold the categories.',
                    sensitivityLevel: 'public',
                },
                highlights: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255, minLength: 1 },
                    uniqueItems: false,
                    minItems: 1,
                    maxItems: 3,
                    description: 'New field to hold the highlights.',
                    sensitivityLevel: 'public',
                },
                isPledge1Percent: {
                    type: 'boolean',
                    default: false,
                    description: '(isPledge1Percent__c)',
                    sensitivityLevel: 'public',
                },
                isDiverseOwnedBusiness: {
                    type: 'boolean',
                    default: false,
                    description: 'Diverse-owned Business',
                    sensitivityLevel: 'public',
                },
                diverseOwnedBusinessURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Diverse-owned Business URL or Cert',
                    sensitivityLevel: 'public',
                },
                languages: {
                    type: 'array',
                    default: [],
                    items: schemas['listing/Languages'].get(),
                    uniqueItems: true,
                    minItems: 1,
                    description: 'Describes the set of languages that this App supports. (Languages__c)',
                    sensitivityLevel: 'public',
                },
                learnMoreURL: {
                    type: 'string',
                    format: 'oaf-url',
                    minLength: 1,
                    maxLength: 255,
                    description: 'Specify the URL where the customer can contact the publisher to learn more about installing/buying the app. (LearnMoreURL__c)',
                    sensitivityLevel: 'public',
                },
                listingUrl: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Listing site url',
                    sensitivityLevel: 'public',
                },
                marketplace: {
                    type: 'string',
                    maxLength: 22,
                    enum: ['English', 'AppExchange_Japanese'],
                    description: 'The Marketplace on which this Listing can be publicly viewed. These values correspond to the Marketplace name, not SFID - they are converted to (Marketplace__c) IDs during Mulesoft sync.',
                    sensitivityLevel: 'internal',
                },
                numberOfProjects: {
                    type: 'integer',
                    description: 'The number of projects completed by this consultant',
                    sensitivityLevel: 'public',
                },
                recordType: {
                    type: 'string',
                    enum: ['App', 'BoltTemplate', 'Bot', 'Component', 'Content', 'Data', 'Flow', 'Service', 'Template'],
                    description: 'The type of listing (RecordTypeId)',
                    sensitivityLevel: 'internal',
                },
                searchBlurb: {
                    type: 'string',
                    default: '',
                    maxLength: 75,
                    description: 'Search Blurb to display on the search results page. (SearchBlurb__c)',
                    sensitivityLevel: 'public',
                },
                status: {
                    type: 'string',
                    enum: [
                        'New',
                        'In Review',
                        'Approved',
                        'Inactive',
                        'InActiveRevPlaceHolder',
                        'Delisted',
                        'Open',
                        'Filled',
                        'Completed',
                        'Canceled',
                    ],
                    default: 'New',
                    description: 'Indicates what stage in the review process the Listing is in for the Marketplace. (Status__c)',
                    sensitivityLevel: 'internal',
                },
                totalNumberOfExperts: {
                    type: 'integer',
                    description: 'Number of experts the consultant employs',
                    sensitivityLevel: 'internal',
                },
                publishedDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The date when this Listing was publicly published on the Marketplace. (PublishedDate__c)',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { highlights: [], languages: [], learnMoreURL: '', status: 'New' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/consultant/listings/Listing/plugin': {
        get: () => ({
            $id: 'listing/extensions/consultant/listings/Listing/plugin',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Consultant_Plugin',
            type: 'object',
            required: ['pluginType', 'data'],
            properties: {
                pluginType: {
                    type: 'string',
                    enum: ['listing/extensions/consultant/listings/Listing/plugins/PartnerLocations'],
                },
                data: {
                    anyOf: [schemas['listing/extensions/consultant/listings/Listing/plugins/PartnerLocations'].get()],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { pluginType: 'listing/extensions/consultant/listings/Listing/plugins/PartnerLocations' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/consultant/listings/Listing/plugins/PartnerLocations': {
        get: () => ({
            $id: 'listing/extensions/consultant/listings/Listing/plugins/PartnerLocations',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'PartnerLocations',
            type: 'object',
            required: ['items'],
            properties: {
                items: {
                    type: 'array',
                    items: {
                        required: ['id'],
                        properties: {
                            id: {
                                type: 'string',
                                maxLength: 18,
                                description: 'The external identifier for the partner location on Tz (Id)',
                                sensitivityLevel: 'confidential',
                            },
                            name: { type: 'string', maxLength: 80, description: '(Name)', sensitivityLevel: 'public' },
                            active: {
                                type: 'boolean',
                                default: true,
                                description: 'Indicates if this partner location will be shown to users. (Active__c)',
                                sensitivityLevel: 'internal',
                            },
                            location: {
                                type: 'string',
                                maxLength: 80,
                                description: 'Text representing Country Code or Country Code - State Code (e.g. US-AL, UY, etc) (Location__c)',
                                sensitivityLevel: 'public',
                            },
                            partnerAccountId: {
                                type: 'string',
                                maxLength: 18,
                                description: 'Partner account id in org62 (PartnerAccountID__c)',
                                sensitivityLevel: 'confidential',
                            },
                            valid: {
                                type: 'boolean',
                                default: true,
                                description: 'For US and Canada expected is <country_code,state_code> and for others <country_code> (Valid__c)',
                                sensitivityLevel: 'internal',
                            },
                            isInOrg62: {
                                type: 'boolean',
                                default: true,
                                description: 'Indicates if the partner locations is on org62. (isInOrg62__c)',
                                sensitivityLevel: 'confidential',
                            },
                            isInCertOrg: {
                                type: 'boolean',
                                default: true,
                                description: 'Indicates if the partner locations is on CertOrg. (isInCertOrg__c)',
                                sensitivityLevel: 'confidential',
                            },
                        },
                        additionalProperties: false,
                    },
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { items: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/listings/Listing': {
        get: () => ({
            $id: 'listing/extensions/marketing-cloud/listings/Listing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_Listing',
            type: 'object',
            required: [
                'status',
                'extensions',
                'systemRequirements',
                'productsRequired',
                'productsSupported',
                'languages',
                'highlights',
                'licenseAgreement',
                'searchBlurb',
                'listingCategories',
            ],
            properties: {
                extensions: {
                    type: 'array',
                    description: 'The extensions that force listings can have, including what subtypes the listing can be.',
                    items: schemas['listing/extensions/marketing-cloud/listings/Listing/extension'].get(),
                },
                account: schemas['listing/extensions/marketing-cloud/Account'].get(),
                appType: {
                    type: 'string',
                    default: '',
                    description: 'The App Type of a listing',
                    enum: [
                        'Package/Platform/App',
                        'API/Salesforce Platform API',
                        'API/Marketing Cloud API',
                        'Package/Quip',
                        'Package/B2C Commerce Cloud',
                        'API/B2C Commerce API',
                        'Package/Platform/Bolt',
                        'Package/Platform/Flow',
                        'Package/Platform/Component',
                        'Package/Platform/Data',
                    ],
                    sensitivityLevel: 'internal',
                },
                supportedIndustries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: {
                        type: 'string',
                        enum: [
                            'Horizontal Product',
                            'Agriculture & Mining',
                            'Automotive',
                            'Communications',
                            'Consumer Goods',
                            'Education',
                            'Energy',
                            'Engineering, Construction, & Real Estate',
                            'Financial Services',
                            'Government',
                            'Healthcare & Life Sciences',
                            'High Tech',
                            'Manufacturing',
                            'Media & Entertainment',
                            'Professional Services',
                            'Public Sector',
                            'Retail',
                            'Travel, Transportation, and Hospitality',
                            'Nonprofit',
                        ],
                    },
                    uniqueItems: true,
                    description: 'The Supported Induestries that the app is built for.',
                    sensitivityLevel: 'internal',
                },
                targetUserPersona: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: schemas['listing/TargetUserPersona'].get(),
                    description: 'The target user persona that the app is built for.',
                    uniqueItems: true,
                    sensitivityLevel: 'internal',
                },
                acceptedCheckoutAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the checkout agreement terms (AcceptedCheckoutAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the free agreement terms (AcceptedFreeAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAppsAgreement: {
                    type: 'boolean',
                    description: 'Salesforce agreement that the publisher has to accept when a listing is free (AcceptedFreeAppsAgreement__c)',
                    sensitivityLevel: 'confidential',
                },
                acceptedPaidAppsAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the paid agreement terms (AcceptedPaidAppsAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                achApplicationFee: {
                    type: 'string',
                    description: 'Indicates the % to charge on listings purchased with an ACH payment type (AchApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                allowACHPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts ACH as Payment Method during the checkout flow. (AllowACHPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowCCPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts Credit Cards as Payment Method during the checkout flow. (AllowCCPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowSEPAPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts SEPA as Payment Method during the checkout flow. (AllowSEPAPayment__c)',
                    sensitivityLevel: 'public',
                },
                approvedDate: {
                    type: 'string',
                    description: 'This field has the date that the contract was approved. Populated via a callout from the TE org. (Approved_Date__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                businessApproval: {
                    type: 'string',
                    default: 'In Progress',
                    enum: ['Approved', 'Rejected', 'Submitted', 'In Progress', 'Approved Pending Compliance'],
                    description: '(Business_Approval__c)',
                    sensitivityLevel: 'confidential',
                },
                businessRejectionComment: {
                    type: 'string',
                    maxLength: 2000,
                    description: "The reason this listing's Business Questionnaire was rejected. This is used in the email sent to the partner, combined with the Compliance Rejection Comment, informing them that their submission was rejected. (Business_Rejection_Comment__c)",
                    sensitivityLevel: 'confidential',
                },
                businessQuestionnaireSubmittedOn: {
                    type: 'string',
                    description: '(Business_Questionnaire_Submitted_on__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                categories: {
                    type: 'string',
                    enum: ['Cloud Apps', 'Customization', 'Desktop Apps', 'Integration', 'Mobile Apps', 'Websites'],
                    description: '(Categories__c)',
                    sensitivityLevel: 'public',
                },
                listingCategories: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255 },
                    uniqueItems: true,
                    minItems: 0,
                    description: 'New field to hold the categories.',
                    sensitivityLevel: 'public',
                },
                categoriesToFeeds: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'Categories to feed Feeds. (CategoriestoFeeds__c)',
                    sensitivityLevel: 'public',
                },
                checkoutEnabledDate: {
                    type: 'string',
                    description: 'The date when the listing was associated with a Recurly plan or when it was changed form a External to a Recurly plan. (CheckoutEnabledDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                collectPaymentBeforeInstall: {
                    type: 'boolean',
                    description: '(CollectPaymentBeforeInstall__c)',
                    sensitivityLevel: 'internal',
                },
                contractStatus: {
                    type: 'string',
                    enum: ['Incomplete', 'In Progress', 'Approved'],
                    description: 'Contract status set via a callout from the TE org. (Contract_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                contractType: {
                    type: 'string',
                    enum: ['Connector', 'Freemium', 'ISVforce clickthrough', 'ISVforce non-standard', 'OEM', 'VAR'],
                    description: 'Contract type set via a callout from the TE org. (Contract_Type__c)',
                    sensitivityLevel: 'confidential',
                },
                createdByOrgID: {
                    type: 'string',
                    description: 'The Org ID of the user who created the listing (CreatedByOrgID__C)',
                    sensitivityLevel: 'confidential',
                },
                creditorIdentifier: {
                    type: 'string',
                    maxLength: 255,
                    description: 'A Single Euro Payments Area Creditor Identifier or SEPA Creditor Id is a standardized and unchanging identification number that serves to unequivocally identify a creditor across Europe. (CreditorIdentifier__c)',
                    sensitivityLevel: 'confidential',
                },
                curatedListing1: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_1__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing2: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_2__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing3: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_3__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing4: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_4__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing5: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_5__c)",
                    sensitivityLevel: 'public',
                },
                deleteReason: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The reason the publisher specified when deleting this Listing. (DeleteReason__c)',
                    sensitivityLevel: 'confidential',
                },
                delistedDate: {
                    type: 'string',
                    description: 'The date when the listing was delisted (DelistedDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                delistedReason: {
                    type: 'string',
                    enum: [
                        'Partner went out of business',
                        'Partner bought out',
                        'Application had technical issues',
                        'Product failed to gain traction',
                        'Unhappy with partnership',
                        'Temp delisting',
                        'App had not been updated',
                        'No owner to maintain App',
                        'App had low installs',
                        'Not Lightning Ready',
                        'Security non-compliance',
                    ],
                    description: 'Reason for delisting. (DelistedReason__c)',
                    sensitivityLevel: 'confidential',
                },
                devices: {
                    type: 'array',
                    items: { type: 'string', enum: ['Phone', 'Tablet', 'Desktop'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(Devices__c)',
                    sensitivityLevel: 'public',
                },
                directoryEntryID: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The ID of the legacy directory entry record from which this object was migrated. (DirectoryEntryID__c)',
                    sensitivityLevel: 'confidential',
                },
                displayHover: {
                    type: 'boolean',
                    default: true,
                    description: 'Indicates if the tile should display the hover or not (DisplayHover__c)',
                    sensitivityLevel: 'internal',
                },
                editions: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', enum: ['PE', 'EE', 'UE', 'DE', 'PP', 'FE', 'ES'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: "Select one or more Salesforce editions with which your app is compatible (Note: 'PP','FE','ES' are deprecated). If your app uses Salesforce APIs, it cannot run on Group or Professional editions. If your app uses any standard Salesforce objects, it cannot run on Force.com edition. (Editions__c)",
                    sensitivityLevel: 'public',
                },
                productsRequired: {
                    type: 'array',
                    items: schemas['listing/SalesforceRequiredProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 4,
                    description: '(Required_Cloud__c)',
                    sensitivityLevel: 'public',
                },
                productsSupported: {
                    type: 'array',
                    items: schemas['listing/SalesforceSupportedProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 0,
                    maxItems: 3,
                    description: '(New field) This is supplimentary information that may add more context to the relevant input.',
                    sensitivityLevel: 'public',
                },
                highlights: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255, minLength: 1 },
                    uniqueItems: false,
                    minItems: 1,
                    maxItems: 9,
                    description: 'New field to hold the highlights.',
                    sensitivityLevel: 'public',
                },
                featured: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if this listing is returned when users filter for featured apps in the search results. (Featured__c)',
                    sensitivityLevel: 'public',
                },
                filledDateTime: { type: 'string', format: 'date-time', sensitivityLevel: 'confidential' },
                industries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    description: "Indicates which industries categories this Listing belongs to. (CategorizedListing__r.ListingCategory__r.CategoryType__r.Name == 'Industries')",
                    items: { type: 'string' },
                    sensitivityLevel: 'public',
                },
                isFreemium: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is initially free but payment is required for additional users, features, or usage. (Freemium__c)',
                    sensitivityLevel: 'public',
                },
                isLightningComponent: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningComponent__c)',
                    sensitivityLevel: 'public',
                },
                isLightningReady: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningReady__c)',
                    sensitivityLevel: 'public',
                },
                isSalesProgram: {
                    type: 'boolean',
                    default: false,
                    description: 'Sales Program',
                    sensitivityLevel: 'public',
                },
                isMarketingCloud: {
                    type: 'boolean',
                    default: false,
                    description: '(isMarketingCloud__c)',
                    sensitivityLevel: 'public',
                },
                isMultiCurrency: {
                    type: 'boolean',
                    default: false,
                    description: '(isMulti_currency__c)',
                    sensitivityLevel: 'public',
                },
                isPersonAccounts: {
                    type: 'boolean',
                    default: false,
                    description: '(isPersonAccounts__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforce1Mobile: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforce1Mobile__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforceShield: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforceShield__c)',
                    sensitivityLevel: 'public',
                },
                isPledge1Percent: {
                    type: 'boolean',
                    default: false,
                    description: '(isPledge1Percent__c)',
                    sensitivityLevel: 'public',
                },
                isLightningAppBuilder: {
                    type: 'boolean',
                    default: false,
                    description: 'Lightning App Builder',
                    sensitivityLevel: 'public',
                },
                isFedrampCertified: {
                    type: 'boolean',
                    default: false,
                    description: 'FedRAMP Certified',
                    sensitivityLevel: 'public',
                },
                isHIPAACompliant: {
                    type: 'boolean',
                    default: false,
                    description: 'HIPAA Compliant',
                    sensitivityLevel: 'public',
                },
                isMinorityOwned: {
                    type: 'boolean',
                    default: false,
                    description: 'Minority Owned',
                    sensitivityLevel: 'public',
                },
                isDiverseOwnedBusiness: {
                    type: 'boolean',
                    default: false,
                    description: 'Diverse-owned Business',
                    sensitivityLevel: 'public',
                },
                diverseOwnedBusinessURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Diverse-owned Business URL or Cert',
                    sensitivityLevel: 'public',
                },
                isAccessibleSolution: {
                    type: 'boolean',
                    default: false,
                    description: 'Accessible Solution',
                    sensitivityLevel: 'public',
                },
                accessibleSolutionURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Accessible Solution URL or Cert',
                    sensitivityLevel: 'public',
                },
                languages: {
                    type: 'array',
                    default: [],
                    items: schemas['listing/Languages'].get(),
                    uniqueItems: true,
                    minItems: 1,
                    description: 'Describes the set of languages that this App supports. (Languages__c)',
                    sensitivityLevel: 'public',
                },
                lastStatusChangeDateTime: {
                    type: 'string',
                    format: 'date-time',
                    description: 'The date when the status of the job last changed. (LastStatusChangeDateTime__c)',
                    sensitivityLevel: 'confidential',
                },
                learnMoreURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Specify the URL where the customer can contact the publisher to learn more about installing/buying the app. (LearnMoreURL__c)',
                    sensitivityLevel: 'public',
                },
                longDescription: {
                    type: 'string',
                    maxLength: 1200,
                    description: 'The long description of the AppListing show on the App Detail page. (LongDescription__c)',
                    sensitivityLevel: 'public',
                },
                marketplace: {
                    type: 'string',
                    maxLength: 22,
                    enum: ['English', 'AppExchange_Japanese'],
                    description: 'The Marketplace on which this Listing can be publicly viewed. These values correspond to the Marketplace name, not SFID - they are converted to (Marketplace__c) IDs during Mulesoft sync.',
                    sensitivityLevel: 'internal',
                },
                orderInSetup: {
                    type: 'number',
                    maximum: 99,
                    description: "The place this App has in the Featured Apps Carousel in Org's Setup. i.e : 1 for first, 2 for second, etc.",
                    sensitivityLevel: 'internal',
                },
                org62ApplicationId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Application Record ID on ORG62 (Org62ApplicationId__c)',
                    sensitivityLevel: 'confidential',
                },
                priceDetails: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The detailed pricing information for this App. (PriceDetails__c)',
                    sensitivityLevel: 'public',
                },
                isFree: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if the App on this Listing is free for everyone. (PriceFree__c)',
                    sensitivityLevel: 'public',
                },
                priceNonProfitDiscount: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the app is available to nonprofits for a discount or free. (PriceNonProfitDiscount__c)',
                    sensitivityLevel: 'public',
                },
                pricingRestrictions: {
                    type: 'string',
                    maxLength: 255,
                    description: 'provide by CX (PricingRestrictions__c)',
                    sensitivityLevel: 'internal',
                },
                programmingLanguages: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: [
                            'AandV',
                            'Csharp',
                            'HTMLCSSJavaScript',
                            'Java',
                            'NodeJs',
                            'ObjectiveC',
                            'Perl',
                            'PHP',
                            'Python',
                            'Ruby',
                            'SQLPostgres',
                        ],
                    },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(programmingLanguages__c)',
                    sensitivityLevel: 'public',
                },
                public: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether this Listing is publicly viewable on the Marketplace. (Public__c)',
                    sensitivityLevel: 'internal',
                },
                publishedDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The date when this Listing was publicly published on the Marketplace. (PublishedDate__c)',
                    sensitivityLevel: 'internal',
                },
                publishLocation: {
                    type: 'string',
                    enum: [
                        'AppExchange',
                        'French Partner Finder',
                        'German Partner Finder',
                        'Italian Partner Finder',
                        'Japanese Partner Finder',
                        'Korean Partner Finder',
                        'Portuguese Partner Finder',
                        'Dutch Partner Finder',
                        'Spanish Partner Finder',
                        'Swedish Partner Finder',
                        'Chinese Partner Finder',
                        'Traditional Chinese Partner Finder',
                    ],
                    description: 'Partner finder feed. (PublishLocation__c)',
                    sensitivityLevel: 'internal',
                },
                recordType: {
                    type: 'string',
                    enum: ['App', 'BoltTemplate', 'Bot', 'Component', 'Content', 'Data', 'Flow', 'Service', 'Template'],
                    description: 'The type of listing (RecordTypeId)',
                    sensitivityLevel: 'internal',
                },
                requiresPaidService: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is free but requires a paid subscription to an external service. (RequiresPaidService__c)',
                    sensitivityLevel: 'public',
                },
                searchBlurb: {
                    type: 'string',
                    default: '',
                    maxLength: 75,
                    description: 'Search Blurb to display on the search results page. (SearchBlurb__c)',
                    sensitivityLevel: 'public',
                },
                sepaApplicationFee: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100,
                    description: 'Indicates the % to charge on listings purchased with a SEPA payment type. (SepaApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: [
                        'New',
                        'In Review',
                        'Approved',
                        'Inactive',
                        'InActiveRevPlaceHolder',
                        'Delisted',
                        'Open',
                        'Filled',
                        'Completed',
                        'Canceled',
                    ],
                    default: 'New',
                    description: 'Indicates what stage in the review process the Listing is in for the Marketplace. (Status__c)',
                    sensitivityLevel: 'confidential',
                },
                submissionStatus: {
                    type: 'string',
                    enum: [
                        'Not Ready for Submission / Incomplete',
                        'Ready for Submission',
                        'Submitted - Pending Review',
                        'Approved',
                        'Rejected',
                    ],
                    description: 'Indicates the submission status from the TE org. (Submission_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                systemRequirements: {
                    type: 'string',
                    default: '',
                    maxLength: 255,
                    description: "Specify any additional system requirements that your app may have. For example, supported browsers, operating systems, or hardware. If your app does not have any additional system requirements, select 'No Additional System Requirements'. (SystemRequirements__c)",
                    sensitivityLevel: 'public',
                },
                securityReviewStatus: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Status of the Security Review associated with this Listing. SecReview id in(SecurityReview__c)',
                    sensitivityLevel: 'internal',
                },
                salesEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    maxLength: 255,
                    description: 'The email address for contacting the Publisher sales team. (SalesEmail__c)',
                    sensitivityLevel: 'internal',
                },
                salesPhone: {
                    type: 'string',
                    maxLength: 40,
                    description: 'The phone number for contacting the Publisher sales team. (SalesPhone__c)',
                    sensitivityLevel: 'internal',
                },
                salesWebsite: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The website URL for learning more about buying this App from the Publisher. (SalesWebsite__c)',
                    sensitivityLevel: 'internal',
                },
                licenseAgreement: {
                    type: 'string',
                    default: '',
                    maxLength: 32000,
                    description: 'T&C, The license agreement for the app.(LicenseAgreement__c)',
                    sensitivityLevel: 'public',
                },
                installationAgreement: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'T&C, installation agreement for the app.(Marketplace__r.InstallationAgreement__c)',
                    sensitivityLevel: 'public',
                },
                listingUrl: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Listing site url',
                    sensitivityLevel: 'public',
                },
                selfAttestation: {
                    type: 'boolean',
                    description: 'Indicates if self attestation has been accepted',
                    default: false,
                    sensitivityLevel: 'confidential',
                },
                selfAttestationDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the self attestation',
                    format: 'date-time',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensions: [],
                listingCategories: [],
                productsRequired: [],
                productsSupported: [],
                highlights: [],
                languages: [],
                searchBlurb: '',
                status: 'New',
                systemRequirements: '',
                licenseAgreement: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/Account': {
        get: () => ({
            sensitivityLevel: 'internal',
            $id: 'listing/extensions/marketing-cloud/Account',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_Account',
            type: 'object',
            properties: {
                name: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name of the account (Name)',
                    sensitivityLevel: 'internal',
                },
                id: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The external identifier for the account on Tz (Id)',
                    sensitivityLevel: 'internal',
                },
                accountNumber: {
                    type: 'string',
                    maxLength: 40,
                    description: '(AccountNumber)',
                    sensitivityLevel: 'confidential',
                },
                site: {
                    type: 'string',
                    maxLength: 80,
                    description: '(AccountNumber)',
                    sensitivityLevel: 'confidential',
                },
                annualRevenue: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(AnnualRevenue)',
                    sensitivityLevel: 'confidential',
                },
                numberOfEmployees: {
                    type: 'integer',
                    maxLength: 8,
                    description: 'Total number of employees at the company. (NumberOfEmployees)',
                    sensitivityLevel: 'internal',
                },
                fax: { type: 'string', maxLength: 15, description: '(Fax)', sensitivityLevel: 'public' },
                phone: { type: 'string', maxLength: 15, description: '(Phone)', sensitivityLevel: 'public' },
                rating: {
                    type: 'string',
                    enum: ['Hot', 'Warm', 'Cold'],
                    description: '(Rating)',
                    sensitivityLevel: 'public',
                },
                website: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: '(Website)',
                    sensitivityLevel: 'public',
                },
                active: {
                    type: 'string',
                    enum: ['No', 'Yes'],
                    description: 'Active__c)',
                    sensitivityLevel: 'internal',
                },
                customerPriority: {
                    type: 'string',
                    enum: ['High', 'Low', 'Medium'],
                    description: '(CustomerPriority__c)',
                    sensitivityLevel: 'internal',
                },
                customerSatisfactionRating: {
                    type: 'number',
                    maxLength: 18,
                    description: '(Customer_Satisfaction_Rating__c)',
                    sensitivityLevel: 'internal',
                },
                developerPrefix: {
                    type: 'string',
                    maxLength: 4,
                    description: '4 character prefix to uniqify custom objects created by this developer (Developer_Prefix__c)',
                    sensitivityLevel: 'confidential',
                },
                isDupeAccount: {
                    type: 'boolean',
                    default: false,
                    description: '(Is_Dupe_Account__c)',
                    sensitivityLevel: 'internal',
                },
                isOldMCAccount: {
                    type: 'boolean',
                    default: false,
                    description: 'Checked if the Account was created before 2016-03-11 and is a Marketing Cloud Identity Account, otherwise, this field should be unchecked (Is_Old_MC_Account__c)',
                    sensitivityLevel: 'internal',
                },
                patchDevOrg: {
                    type: 'boolean',
                    default: false,
                    description: '(patchDevOrg__c)',
                    sensitivityLevel: 'internal',
                },
                ISVPartnerTier: {
                    type: 'string',
                    maxLength: 100,
                    description: '(ISVPartnerTier__c)',
                    sensitivityLevel: 'internal',
                },
                marketingCloudId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Marketing Cloud account Id (Marketing_Cloud_Id__c)',
                    sensitivityLevel: 'confidential',
                },
                masterPartnerAccount: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Master Partner Account Id of Partner Summary record in Org62 (Master_Partner_Account__c)',
                    sensitivityLevel: 'confidential',
                },
                nonProfitAccount: {
                    type: 'boolean',
                    default: false,
                    description: '(Non_Profit_Account__c)',
                    sensitivityLevel: 'internal',
                },
                numberofExperts: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(Number_of_Experts__c)',
                    sensitivityLevel: 'internal',
                },
                numberofLocations: {
                    type: 'integer',
                    maxLength: 3,
                    description: '(NumberofLocations__c)',
                    sensitivityLevel: 'internal',
                },
                numberofProjects: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(Number_of_Projects__c)',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                org62PartnerSummaryId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Id of Partner Summary record in Org62 (Org61ParnerSummaryId__c)',
                    sensitivityLevel: 'confidential',
                },
                orgCustomDomain: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce custom domain value if my domains enabled for the org (OrgCustomDomain__c)',
                    sensitivityLevel: 'confidential',
                },
                orgDomain: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce instance domain name where the account resides (OrgDomain__c)',
                    sensitivityLevel: 'confidential',
                },
                orgEdition: {
                    type: 'string',
                    maxLength: 32,
                    description: '(orgEdition__c)',
                    sensitivityLevel: 'confidential',
                },
                orgId: { type: 'string', maxLength: 18, description: '(orgId__c)', sensitivityLevel: 'confidential' },
                orgInstance: {
                    type: 'string',
                    maxLength: 8,
                    description: '(orgInstance__c)',
                    sensitivityLevel: 'confidential',
                },
                orgReleaseVersion: {
                    type: 'string',
                    maxLength: 20,
                    description: 'The Salesforce release version the org is on. (OrgReleaseVersion__c)',
                    sensitivityLevel: 'confidential',
                },
                orgStatus: {
                    type: 'string',
                    maxLength: 32,
                    description: '(orgStatus__c)',
                    sensitivityLevel: 'confidential',
                },
                partnerAccessRevoked: {
                    type: 'boolean',
                    default: false,
                    description: '(PartnerAccessRevoked__c)',
                    sensitivityLevel: 'internal',
                },
                partnerAccountId: {
                    type: 'string',
                    maxLength: 100,
                    description: '(PartnerAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                partnerCertificationGoal: {
                    type: 'integer',
                    maxLength: 18,
                    description: 'Partner Certification Goal represents a goal of the total number of certifications that the partner will have at the end of the fiscal year.',
                    sensitivityLevel: 'confidential',
                },
                partnerSupportLevel: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Indicates the Support Level for the Partner Account (PartnerSupportLevel__c)',
                    sensitivityLevel: 'internal',
                },
                partnerType: {
                    type: 'string',
                    enum: ['SI', 'ISV'],
                    description: '(Partner_Type__c)',
                    sensitivityLevel: 'internal',
                },
                pledge1Member: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the partner has pledged 1% to charity (Pledge_1_Member__c)',
                    sensitivityLevel: 'internal',
                },
                prodAccountID: {
                    type: 'string',
                    maxLength: 100,
                    description: '(PartnerAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                sfdcOrgId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'to match up for entitlements export (SFDC_OrgId__c)',
                    sensitivityLevel: 'confidential',
                },
                siPartnerTier: {
                    type: 'string',
                    maxLength: 100,
                    description: '(SIPartnerTier__c)',
                    sensitivityLevel: 'internal',
                },
                sla: {
                    type: 'string',
                    enum: ['Gold', 'Silver', 'Platinum', 'Bronze'],
                    description: 'null (SLA__c)',
                    sensitivityLevel: 'internal',
                },
                slaExpirationDate: {
                    type: 'string',
                    format: 'date',
                    description: '(SLAExpirationDate__c)',
                    sensitivityLevel: 'internal',
                },
                slaSerialNumber: {
                    type: 'string',
                    maxLength: 10,
                    description: '(SLASerialNumber__c)',
                    sensitivityLevel: 'confidential',
                },
                bfontcolorredSupportLevel: {
                    type: 'string',
                    enum: ['Silver', 'Platinum', 'Gold'],
                    description: '(bfontcolorredSupportLevel__c)',
                    sensitivityLevel: 'internal',
                },
                syncedwith62org: {
                    type: 'boolean',
                    default: false,
                    description: '(Synced_with_62_org__c)',
                    sensitivityLevel: 'internal',
                },
                diverseLeadership: {
                    type: 'boolean',
                    default: false,
                    description: 'At least 30% of this company’s executive leadership team belongs to one or more of the following groups: persons with disabilities, women, veterans, minorities (U.S. Only), or LGBTQ. (Diverse_Leadership__c)',
                    sensitivityLevel: 'confidential',
                },
                publicDiverseLeadership: {
                    type: 'boolean',
                    default: false,
                    description: 'Controls whether this identifier is displayed externally - ex: on AppExchange listings (Diverse_Leadership_Is_Public__c)',
                    sensitivityLevel: 'internal',
                },
                sustainableDevelopmentGoals: {
                    type: 'boolean',
                    default: false,
                    description: "This company has committed to one or more of the United Nation's Sustainable Development Goals, which focus on creating a better and more sustainable future for all. (Sustainable_Development_Goals__c)",
                    sensitivityLevel: 'confidential',
                },
                publicSustainableDevelopmentGoals: {
                    type: 'boolean',
                    default: false,
                    description: 'Controls whether this identifier is displayed externally - ex: on AppExchange listings (Sustainable_Development_Goals_Is_Public__c)',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/listings/Listing/extension': {
        get: () => ({
            $id: 'listing/extensions/marketing-cloud/listings/Listing/extension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_Extension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: [
                        'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing',
                        'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing',
                    ],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing'].get(),
                        schemas['listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing': {
        get: () => ({
            $id: 'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_APIListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                provisionFlow: { type: 'string', enum: ['Representative', 'External'], sensitivityLevel: 'public' },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
                extensions: {
                    type: 'array',
                    description: 'The extensions that marketing cloud API Listings can have',
                    items: schemas['listing/extensions/marketing-cloud/listings/Listing/extensions/APIListingExtension'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListingExtension': {
        get: () => ({
            $id: 'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListingExtension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_APIListingExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: ['listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing/TestDrive'],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing/TestDrive'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing/TestDrive',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing/TestDrive': {
        get: () => ({
            $id: 'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing/TestDrive',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_APITestDrive',
            type: 'object',
            required: ['testDriveOrgID', 'testDrivePassword', 'testDriveUserName'],
            properties: {
                enableTestDrive: {
                    type: 'boolean',
                    default: false,
                    description: 'Does the listing have a test drive?',
                    sensitivityLevel: 'internal',
                },
                testDriveCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                testDriveOrgID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveOrgID__c)',
                    sensitivityLevel: 'internal',
                },
                testDrivePassword: {
                    type: 'string',
                    maxLength: 50,
                    description: '(TestDrivePassword__c)',
                    sensitivityLevel: 'confidential',
                },
                testDriveUserName: {
                    type: 'string',
                    maxLength: 80,
                    description: '(TestDriveUserName__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { testDriveOrgID: '', testDrivePassword: '', testDriveUserName: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing': {
        get: () => ({
            $id: 'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_PackageListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                gitHubRepositoryURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'GitHub/Repository URL for Component type of Listing (GitHub_Repository_URL__c)',
                    sensitivityLevel: 'public',
                },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
                provisionFlow: {
                    type: 'string',
                    default: '',
                    enum: ['Representative', 'External', 'Package'],
                    sensitivityLevel: 'public',
                },
                extensions: {
                    type: 'array',
                    description: 'The extensions that force Package Listings can have',
                    items: schemas['listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListingExtension'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListingExtension': {
        get: () => ({
            $id: 'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListingExtension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_PackageListingExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: ['listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing/TestDrive'],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing/TestDrive'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing/TestDrive',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing/TestDrive': {
        get: () => ({
            $id: 'listing/extensions/marketing-cloud/listings/Listing/extensions/PackageListing/TestDrive',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'MarketingCloud_PackageTestDrive',
            type: 'object',
            required: ['testDriveOrgID', 'testDrivePassword', 'testDriveUserName'],
            properties: {
                enableTestDrive: {
                    type: 'boolean',
                    default: false,
                    description: 'Does the listing have a test drive?',
                    sensitivityLevel: 'internal',
                },
                testDriveCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                testDriveOrgID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveOrgID__c)',
                    sensitivityLevel: 'internal',
                },
                testDrivePassword: {
                    type: 'string',
                    maxLength: 50,
                    description: '(TestDrivePassword__c)',
                    sensitivityLevel: 'confidential',
                },
                testDriveUserName: {
                    type: 'string',
                    maxLength: 80,
                    description: '(TestDriveUserName__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { testDriveOrgID: '', testDrivePassword: '', testDriveUserName: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/listings/Listing': {
        get: () => ({
            $id: 'listing/extensions/quip/listings/Listing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_Listing',
            type: 'object',
            required: [
                'status',
                'extensions',
                'systemRequirements',
                'productsRequired',
                'productsSupported',
                'languages',
                'highlights',
                'licenseAgreement',
                'searchBlurb',
                'listingCategories',
            ],
            properties: {
                extensions: {
                    type: 'array',
                    description: 'The extensions that force listings can have, including what subtypes the listing can be.',
                    items: schemas['listing/extensions/quip/listings/Listing/extension'].get(),
                },
                account: schemas['listing/extensions/quip/Account'].get(),
                appType: {
                    type: 'string',
                    default: '',
                    description: 'The App Type of a listing',
                    enum: [
                        'Package/Platform/App',
                        'API/Salesforce Platform API',
                        'API/Marketing Cloud API',
                        'Package/Quip',
                        'Package/B2C Commerce Cloud',
                        'API/B2C Commerce API',
                        'Package/Platform/Bolt',
                        'Package/Platform/Flow',
                        'Package/Platform/Component',
                        'Package/Platform/Data',
                    ],
                    sensitivityLevel: 'internal',
                },
                supportedIndustries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: {
                        type: 'string',
                        enum: [
                            'Horizontal Product',
                            'Agriculture & Mining',
                            'Automotive',
                            'Communications',
                            'Consumer Goods',
                            'Education',
                            'Energy',
                            'Engineering, Construction, & Real Estate',
                            'Financial Services',
                            'Government',
                            'Healthcare & Life Sciences',
                            'High Tech',
                            'Manufacturing',
                            'Media & Entertainment',
                            'Professional Services',
                            'Public Sector',
                            'Retail',
                            'Travel, Transportation, and Hospitality',
                            'Nonprofit',
                        ],
                    },
                    uniqueItems: true,
                    description: 'The Supported Induestries that the app is built for.',
                    sensitivityLevel: 'internal',
                },
                targetUserPersona: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: schemas['listing/TargetUserPersona'].get(),
                    description: 'The target user persona that the app is built for.',
                    uniqueItems: true,
                    sensitivityLevel: 'internal',
                },
                acceptedCheckoutAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the checkout agreement terms (AcceptedCheckoutAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the free agreement terms (AcceptedFreeAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAppsAgreement: {
                    type: 'boolean',
                    description: 'Salesforce agreement that the publisher has to accept when a listing is free (AcceptedFreeAppsAgreement__c)',
                    sensitivityLevel: 'confidential',
                },
                acceptedPaidAppsAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the paid agreement terms (AcceptedPaidAppsAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                achApplicationFee: {
                    type: 'string',
                    description: 'Indicates the % to charge on listings purchased with an ACH payment type (AchApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                allowACHPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts ACH as Payment Method during the checkout flow. (AllowACHPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowCCPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts Credit Cards as Payment Method during the checkout flow. (AllowCCPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowSEPAPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts SEPA as Payment Method during the checkout flow. (AllowSEPAPayment__c)',
                    sensitivityLevel: 'public',
                },
                approvedDate: {
                    type: 'string',
                    description: 'This field has the date that the contract was approved. Populated via a callout from the TE org. (Approved_Date__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                businessApproval: {
                    type: 'string',
                    default: 'In Progress',
                    enum: ['Approved', 'Rejected', 'Submitted', 'In Progress', 'Approved Pending Compliance'],
                    description: '(Business_Approval__c)',
                    sensitivityLevel: 'confidential',
                },
                businessRejectionComment: {
                    type: 'string',
                    maxLength: 2000,
                    description: "The reason this listing's Business Questionnaire was rejected. This is used in the email sent to the partner, combined with the Compliance Rejection Comment, informing them that their submission was rejected. (Business_Rejection_Comment__c)",
                    sensitivityLevel: 'confidential',
                },
                businessQuestionnaireSubmittedOn: {
                    type: 'string',
                    description: '(Business_Questionnaire_Submitted_on__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                categories: {
                    type: 'string',
                    enum: ['Cloud Apps', 'Customization', 'Desktop Apps', 'Integration', 'Mobile Apps', 'Websites'],
                    description: '(Categories__c)',
                    sensitivityLevel: 'public',
                },
                listingCategories: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255 },
                    uniqueItems: true,
                    minItems: 0,
                    description: 'New field to hold the categories.',
                    sensitivityLevel: 'public',
                },
                categoriesToFeeds: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'Categories to feed Feeds. (CategoriestoFeeds__c)',
                    sensitivityLevel: 'public',
                },
                checkoutEnabledDate: {
                    type: 'string',
                    description: 'The date when the listing was associated with a Recurly plan or when it was changed form a External to a Recurly plan. (CheckoutEnabledDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                collectPaymentBeforeInstall: {
                    type: 'boolean',
                    description: '(CollectPaymentBeforeInstall__c)',
                    sensitivityLevel: 'internal',
                },
                contractStatus: {
                    type: 'string',
                    enum: ['Incomplete', 'In Progress', 'Approved'],
                    description: 'Contract status set via a callout from the TE org. (Contract_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                contractType: {
                    type: 'string',
                    enum: ['Connector', 'Freemium', 'ISVforce clickthrough', 'ISVforce non-standard', 'OEM', 'VAR'],
                    description: 'Contract type set via a callout from the TE org. (Contract_Type__c)',
                    sensitivityLevel: 'confidential',
                },
                createdByOrgID: {
                    type: 'string',
                    description: 'The Org ID of the user who created the listing (CreatedByOrgID__C)',
                    sensitivityLevel: 'confidential',
                },
                creditorIdentifier: {
                    type: 'string',
                    maxLength: 255,
                    description: 'A Single Euro Payments Area Creditor Identifier or SEPA Creditor Id is a standardized and unchanging identification number that serves to unequivocally identify a creditor across Europe. (CreditorIdentifier__c)',
                    sensitivityLevel: 'confidential',
                },
                curatedListing1: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_1__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing2: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_2__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing3: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_3__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing4: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_4__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing5: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_5__c)",
                    sensitivityLevel: 'public',
                },
                deleteReason: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The reason the publisher specified when deleting this Listing. (DeleteReason__c)',
                    sensitivityLevel: 'confidential',
                },
                delistedDate: {
                    type: 'string',
                    description: 'The date when the listing was delisted (DelistedDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                delistedReason: {
                    type: 'string',
                    enum: [
                        'Partner went out of business',
                        'Partner bought out',
                        'Application had technical issues',
                        'Product failed to gain traction',
                        'Unhappy with partnership',
                        'Temp delisting',
                        'App had not been updated',
                        'No owner to maintain App',
                        'App had low installs',
                        'Not Lightning Ready',
                        'Security non-compliance',
                    ],
                    description: 'Reason for delisting. (DelistedReason__c)',
                    sensitivityLevel: 'confidential',
                },
                devices: {
                    type: 'array',
                    items: { type: 'string', enum: ['Phone', 'Tablet', 'Desktop'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(Devices__c)',
                    sensitivityLevel: 'public',
                },
                directoryEntryID: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The ID of the legacy directory entry record from which this object was migrated. (DirectoryEntryID__c)',
                    sensitivityLevel: 'confidential',
                },
                displayHover: {
                    type: 'boolean',
                    default: true,
                    description: 'Indicates if the tile should display the hover or not (DisplayHover__c)',
                    sensitivityLevel: 'internal',
                },
                editions: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', enum: ['PE', 'EE', 'UE', 'DE', 'PP', 'FE', 'ES'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: "Select one or more Salesforce editions with which your app is compatible (Note: 'PP','FE','ES' are deprecated). If your app uses Salesforce APIs, it cannot run on Group or Professional editions. If your app uses any standard Salesforce objects, it cannot run on Force.com edition. (Editions__c)",
                    sensitivityLevel: 'public',
                },
                productsRequired: {
                    type: 'array',
                    items: schemas['listing/SalesforceRequiredProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 4,
                    description: '(Required_Cloud__c)',
                    sensitivityLevel: 'public',
                },
                productsSupported: {
                    type: 'array',
                    maxItems: 3,
                    items: schemas['listing/SalesforceSupportedProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 0,
                    description: '(New field) This is supplimentary information that may add more context to the relevant input.',
                    sensitivityLevel: 'public',
                },
                highlights: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255, minLength: 1 },
                    uniqueItems: false,
                    minItems: 1,
                    maxItems: 9,
                    description: 'New field to hold the highlights.',
                    sensitivityLevel: 'public',
                },
                featured: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if this listing is returned when users filter for featured apps in the search results. (Featured__c)',
                    sensitivityLevel: 'public',
                },
                filledDateTime: { type: 'string', format: 'date-time', sensitivityLevel: 'confidential' },
                industries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    description: "Indicates which industries categories this Listing belongs to. (CategorizedListing__r.ListingCategory__r.CategoryType__r.Name == 'Industries')",
                    items: { type: 'string' },
                    sensitivityLevel: 'public',
                },
                isFreemium: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is initially free but payment is required for additional users, features, or usage. (Freemium__c)',
                    sensitivityLevel: 'public',
                },
                isLightningComponent: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningComponent__c)',
                    sensitivityLevel: 'public',
                },
                isSalesProgram: {
                    type: 'boolean',
                    default: false,
                    description: 'Sales Program',
                    sensitivityLevel: 'public',
                },
                isLightningReady: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningReady__c)',
                    sensitivityLevel: 'public',
                },
                isMarketingCloud: {
                    type: 'boolean',
                    default: false,
                    description: '(isMarketingCloud__c)',
                    sensitivityLevel: 'public',
                },
                isMultiCurrency: {
                    type: 'boolean',
                    default: false,
                    description: '(isMulti_currency__c)',
                    sensitivityLevel: 'public',
                },
                isPersonAccounts: {
                    type: 'boolean',
                    default: false,
                    description: '(isPersonAccounts__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforce1Mobile: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforce1Mobile__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforceShield: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforceShield__c)',
                    sensitivityLevel: 'public',
                },
                isPledge1Percent: {
                    type: 'boolean',
                    default: false,
                    description: '(isPledge1Percent__c)',
                    sensitivityLevel: 'public',
                },
                isLightningAppBuilder: {
                    type: 'boolean',
                    default: false,
                    description: 'Lightning App Builder',
                    sensitivityLevel: 'public',
                },
                isFedrampCertified: {
                    type: 'boolean',
                    default: false,
                    description: 'FedRAMP Certified',
                    sensitivityLevel: 'public',
                },
                isHIPAACompliant: {
                    type: 'boolean',
                    default: false,
                    description: 'HIPAA Compliant',
                    sensitivityLevel: 'public',
                },
                isMinorityOwned: {
                    type: 'boolean',
                    default: false,
                    description: 'Minority Owned',
                    sensitivityLevel: 'public',
                },
                isDiverseOwnedBusiness: {
                    type: 'boolean',
                    default: false,
                    description: 'Diverse-owned Business',
                    sensitivityLevel: 'public',
                },
                diverseOwnedBusinessURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Diverse-owned Business URL or Cert',
                    sensitivityLevel: 'public',
                },
                isAccessibleSolution: {
                    type: 'boolean',
                    default: false,
                    description: 'Accessible Solution',
                    sensitivityLevel: 'public',
                },
                accessibleSolutionURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Accessible Solution URL or Cert',
                    sensitivityLevel: 'public',
                },
                languages: {
                    type: 'array',
                    default: [],
                    items: schemas['listing/Languages'].get(),
                    uniqueItems: true,
                    minItems: 1,
                    description: 'Describes the set of languages that this App supports. (Languages__c)',
                    sensitivityLevel: 'public',
                },
                lastStatusChangeDateTime: {
                    type: 'string',
                    format: 'date-time',
                    description: 'The date when the status of the job last changed. (LastStatusChangeDateTime__c)',
                    sensitivityLevel: 'confidential',
                },
                learnMoreURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Specify the URL where the customer can contact the publisher to learn more about installing/buying the app. (LearnMoreURL__c)',
                    sensitivityLevel: 'public',
                },
                longDescription: {
                    type: 'string',
                    maxLength: 1200,
                    description: 'The long description of the AppListing show on the App Detail page. (LongDescription__c)',
                    sensitivityLevel: 'public',
                },
                marketplace: {
                    type: 'string',
                    maxLength: 22,
                    enum: ['English', 'AppExchange_Japanese'],
                    description: 'The Marketplace on which this Listing can be publicly viewed. These values correspond to the Marketplace name, not SFID - they are converted to (Marketplace__c) IDs during Mulesoft sync.',
                    sensitivityLevel: 'internal',
                },
                orderInSetup: {
                    type: 'number',
                    maximum: 99,
                    description: "The place this App has in the Featured Apps Carousel in Org's Setup. i.e : 1 for first, 2 for second, etc.",
                    sensitivityLevel: 'internal',
                },
                org62ApplicationId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Application Record ID on ORG62 (Org62ApplicationId__c)',
                    sensitivityLevel: 'confidential',
                },
                priceDetails: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The detailed pricing information for this App. (PriceDetails__c)',
                    sensitivityLevel: 'public',
                },
                isFree: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if the App on this Listing is free for everyone. (PriceFree__c)',
                    sensitivityLevel: 'public',
                },
                priceNonProfitDiscount: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the app is available to nonprofits for a discount or free. (PriceNonProfitDiscount__c)',
                    sensitivityLevel: 'public',
                },
                pricingRestrictions: {
                    type: 'string',
                    maxLength: 255,
                    description: 'provide by CX (PricingRestrictions__c)',
                    sensitivityLevel: 'internal',
                },
                programmingLanguages: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: [
                            'AandV',
                            'Csharp',
                            'HTMLCSSJavaScript',
                            'Java',
                            'NodeJs',
                            'ObjectiveC',
                            'Perl',
                            'PHP',
                            'Python',
                            'Ruby',
                            'SQLPostgres',
                        ],
                    },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(programmingLanguages__c)',
                    sensitivityLevel: 'public',
                },
                public: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether this Listing is publicly viewable on the Marketplace. (Public__c)',
                    sensitivityLevel: 'internal',
                },
                publishedDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The date when this Listing was publicly published on the Marketplace. (PublishedDate__c)',
                    sensitivityLevel: 'internal',
                },
                publishLocation: {
                    type: 'string',
                    enum: [
                        'AppExchange',
                        'French Partner Finder',
                        'German Partner Finder',
                        'Italian Partner Finder',
                        'Japanese Partner Finder',
                        'Korean Partner Finder',
                        'Portuguese Partner Finder',
                        'Dutch Partner Finder',
                        'Spanish Partner Finder',
                        'Swedish Partner Finder',
                        'Chinese Partner Finder',
                        'Traditional Chinese Partner Finder',
                    ],
                    description: 'Partner finder feed. (PublishLocation__c)',
                    sensitivityLevel: 'internal',
                },
                recordType: {
                    type: 'string',
                    enum: ['App', 'BoltTemplate', 'Bot', 'Component', 'Content', 'Data', 'Flow', 'Service', 'Template'],
                    description: 'The type of listing (RecordTypeId)',
                    sensitivityLevel: 'internal',
                },
                requiresPaidService: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is free but requires a paid subscription to an external service. (RequiresPaidService__c)',
                    sensitivityLevel: 'public',
                },
                searchBlurb: {
                    type: 'string',
                    default: '',
                    maxLength: 75,
                    description: 'Search Blurb to display on the search results page. (SearchBlurb__c)',
                    sensitivityLevel: 'public',
                },
                sepaApplicationFee: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100,
                    description: 'Indicates the % to charge on listings purchased with a SEPA payment type. (SepaApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: [
                        'New',
                        'In Review',
                        'Approved',
                        'Inactive',
                        'InActiveRevPlaceHolder',
                        'Delisted',
                        'Open',
                        'Filled',
                        'Completed',
                        'Canceled',
                    ],
                    default: 'New',
                    description: 'Indicates what stage in the review process the Listing is in for the Marketplace. (Status__c)',
                    sensitivityLevel: 'confidential',
                },
                submissionStatus: {
                    type: 'string',
                    enum: [
                        'Not Ready for Submission / Incomplete',
                        'Ready for Submission',
                        'Submitted - Pending Review',
                        'Approved',
                        'Rejected',
                    ],
                    description: 'Indicates the submission status from the TE org. (Submission_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                systemRequirements: {
                    type: 'string',
                    default: '',
                    maxLength: 255,
                    description: "Specify any additional system requirements that your app may have. For example, supported browsers, operating systems, or hardware. If your app does not have any additional system requirements, select 'No Additional System Requirements'. (SystemRequirements__c)",
                    sensitivityLevel: 'public',
                },
                securityReviewStatus: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Status of the Security Review associated with this Listing. SecReview id in(SecurityReview__c)',
                    sensitivityLevel: 'internal',
                },
                salesEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    maxLength: 255,
                    description: 'The email address for contacting the Publisher sales team. (SalesEmail__c)',
                    sensitivityLevel: 'internal',
                },
                salesPhone: {
                    type: 'string',
                    maxLength: 40,
                    description: 'The phone number for contacting the Publisher sales team. (SalesPhone__c)',
                    sensitivityLevel: 'internal',
                },
                salesWebsite: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The website URL for learning more about buying this App from the Publisher. (SalesWebsite__c)',
                    sensitivityLevel: 'internal',
                },
                licenseAgreement: {
                    type: 'string',
                    default: '',
                    maxLength: 32000,
                    description: 'T&C, The license agreement for the app.(LicenseAgreement__c)',
                    sensitivityLevel: 'public',
                },
                installationAgreement: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'T&C, installation agreement for the app.(Marketplace__r.InstallationAgreement__c)',
                    sensitivityLevel: 'public',
                },
                listingUrl: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Listing site url',
                    sensitivityLevel: 'public',
                },
                selfAttestation: {
                    type: 'boolean',
                    description: 'Indicates if self attestation has been accepted',
                    default: false,
                    sensitivityLevel: 'confidential',
                },
                selfAttestationDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the self attestation',
                    format: 'date-time',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensions: [],
                listingCategories: [],
                productsRequired: [],
                productsSupported: [],
                highlights: [],
                languages: [],
                searchBlurb: '',
                status: 'New',
                systemRequirements: '',
                licenseAgreement: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/Account': {
        get: () => ({
            sensitivityLevel: 'internal',
            $id: 'listing/extensions/quip/Account',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_Account',
            type: 'object',
            properties: {
                name: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name of the account (Name)',
                    sensitivityLevel: 'internal',
                },
                id: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The external identifier for the account on Tz (Id)',
                    sensitivityLevel: 'internal',
                },
                accountNumber: {
                    type: 'string',
                    maxLength: 40,
                    description: '(AccountNumber)',
                    sensitivityLevel: 'confidential',
                },
                site: {
                    type: 'string',
                    maxLength: 80,
                    description: '(AccountNumber)',
                    sensitivityLevel: 'confidential',
                },
                annualRevenue: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(AnnualRevenue)',
                    sensitivityLevel: 'confidential',
                },
                numberOfEmployees: {
                    type: 'integer',
                    maxLength: 8,
                    description: 'Total number of employees at the company. (NumberOfEmployees)',
                    sensitivityLevel: 'internal',
                },
                fax: { type: 'string', maxLength: 15, description: '(Fax)', sensitivityLevel: 'public' },
                phone: { type: 'string', maxLength: 15, description: '(Phone)', sensitivityLevel: 'public' },
                rating: {
                    type: 'string',
                    enum: ['Hot', 'Warm', 'Cold'],
                    description: '(Rating)',
                    sensitivityLevel: 'public',
                },
                website: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: '(Website)',
                    sensitivityLevel: 'public',
                },
                active: {
                    type: 'string',
                    enum: ['No', 'Yes'],
                    description: 'Active__c)',
                    sensitivityLevel: 'internal',
                },
                customerPriority: {
                    type: 'string',
                    enum: ['High', 'Low', 'Medium'],
                    description: '(CustomerPriority__c)',
                    sensitivityLevel: 'internal',
                },
                customerSatisfactionRating: {
                    type: 'number',
                    maxLength: 18,
                    description: '(Customer_Satisfaction_Rating__c)',
                    sensitivityLevel: 'internal',
                },
                developerPrefix: {
                    type: 'string',
                    maxLength: 4,
                    description: '4 character prefix to uniqify custom objects created by this developer (Developer_Prefix__c)',
                    sensitivityLevel: 'confidential',
                },
                isDupeAccount: {
                    type: 'boolean',
                    default: false,
                    description: '(Is_Dupe_Account__c)',
                    sensitivityLevel: 'internal',
                },
                isOldMCAccount: {
                    type: 'boolean',
                    default: false,
                    description: 'Checked if the Account was created before 2016-03-11 and is a Marketing Cloud Identity Account, otherwise, this field should be unchecked (Is_Old_MC_Account__c)',
                    sensitivityLevel: 'internal',
                },
                patchDevOrg: {
                    type: 'boolean',
                    default: false,
                    description: '(patchDevOrg__c)',
                    sensitivityLevel: 'internal',
                },
                ISVPartnerTier: {
                    type: 'string',
                    maxLength: 100,
                    description: '(ISVPartnerTier__c)',
                    sensitivityLevel: 'internal',
                },
                marketingCloudId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Marketing Cloud account Id (Marketing_Cloud_Id__c)',
                    sensitivityLevel: 'confidential',
                },
                masterPartnerAccount: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Master Partner Account Id of Partner Summary record in Org62 (Master_Partner_Account__c)',
                    sensitivityLevel: 'confidential',
                },
                nonProfitAccount: {
                    type: 'boolean',
                    default: false,
                    description: '(Non_Profit_Account__c)',
                    sensitivityLevel: 'internal',
                },
                numberofExperts: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(Number_of_Experts__c)',
                    sensitivityLevel: 'internal',
                },
                numberofLocations: {
                    type: 'integer',
                    maxLength: 3,
                    description: '(NumberofLocations__c)',
                    sensitivityLevel: 'internal',
                },
                numberofProjects: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(Number_of_Projects__c)',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                org62PartnerSummaryId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Id of Partner Summary record in Org62 (Org61ParnerSummaryId__c)',
                    sensitivityLevel: 'confidential',
                },
                orgCustomDomain: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce custom domain value if my domains enabled for the org (OrgCustomDomain__c)',
                    sensitivityLevel: 'confidential',
                },
                orgDomain: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce instance domain name where the account resides (OrgDomain__c)',
                    sensitivityLevel: 'confidential',
                },
                orgEdition: {
                    type: 'string',
                    maxLength: 32,
                    description: '(orgEdition__c)',
                    sensitivityLevel: 'confidential',
                },
                orgId: { type: 'string', maxLength: 18, description: '(orgId__c)', sensitivityLevel: 'confidential' },
                orgInstance: {
                    type: 'string',
                    maxLength: 8,
                    description: '(orgInstance__c)',
                    sensitivityLevel: 'confidential',
                },
                orgReleaseVersion: {
                    type: 'string',
                    maxLength: 20,
                    description: 'The Salesforce release version the org is on. (OrgReleaseVersion__c)',
                    sensitivityLevel: 'confidential',
                },
                orgStatus: {
                    type: 'string',
                    maxLength: 32,
                    description: '(orgStatus__c)',
                    sensitivityLevel: 'confidential',
                },
                partnerAccessRevoked: {
                    type: 'boolean',
                    default: false,
                    description: '(PartnerAccessRevoked__c)',
                    sensitivityLevel: 'internal',
                },
                partnerAccountId: {
                    type: 'string',
                    maxLength: 100,
                    description: '(PartnerAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                partnerCertificationGoal: {
                    type: 'integer',
                    maxLength: 18,
                    description: 'Partner Certification Goal represents a goal of the total number of certifications that the partner will have at the end of the fiscal year.',
                    sensitivityLevel: 'confidential',
                },
                partnerSupportLevel: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Indicates the Support Level for the Partner Account (PartnerSupportLevel__c)',
                    sensitivityLevel: 'internal',
                },
                partnerType: {
                    type: 'string',
                    enum: ['SI', 'ISV'],
                    description: '(Partner_Type__c)',
                    sensitivityLevel: 'internal',
                },
                pledge1Member: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the partner has pledged 1% to charity (Pledge_1_Member__c)',
                    sensitivityLevel: 'internal',
                },
                prodAccountID: {
                    type: 'string',
                    maxLength: 100,
                    description: '(PartnerAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                sfdcOrgId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'to match up for entitlements export (SFDC_OrgId__c)',
                    sensitivityLevel: 'confidential',
                },
                siPartnerTier: {
                    type: 'string',
                    maxLength: 100,
                    description: '(SIPartnerTier__c)',
                    sensitivityLevel: 'internal',
                },
                sla: {
                    type: 'string',
                    enum: ['Gold', 'Silver', 'Platinum', 'Bronze'],
                    description: 'null (SLA__c)',
                    sensitivityLevel: 'internal',
                },
                slaExpirationDate: {
                    type: 'string',
                    format: 'date',
                    description: '(SLAExpirationDate__c)',
                    sensitivityLevel: 'internal',
                },
                slaSerialNumber: {
                    type: 'string',
                    maxLength: 10,
                    description: '(SLASerialNumber__c)',
                    sensitivityLevel: 'confidential',
                },
                bfontcolorredSupportLevel: {
                    type: 'string',
                    enum: ['Silver', 'Platinum', 'Gold'],
                    description: '(bfontcolorredSupportLevel__c)',
                    sensitivityLevel: 'internal',
                },
                syncedwith62org: {
                    type: 'boolean',
                    default: false,
                    description: '(Synced_with_62_org__c)',
                    sensitivityLevel: 'internal',
                },
                diverseLeadership: {
                    type: 'boolean',
                    default: false,
                    description: 'At least 30% of this company’s executive leadership team belongs to one or more of the following groups: persons with disabilities, women, veterans, minorities (U.S. Only), or LGBTQ. (Diverse_Leadership__c)',
                    sensitivityLevel: 'confidential',
                },
                publicDiverseLeadership: {
                    type: 'boolean',
                    default: false,
                    description: 'Controls whether this identifier is displayed externally - ex: on AppExchange listings (Diverse_Leadership_Is_Public__c)',
                    sensitivityLevel: 'internal',
                },
                sustainableDevelopmentGoals: {
                    type: 'boolean',
                    default: false,
                    description: "This company has committed to one or more of the United Nation's Sustainable Development Goals, which focus on creating a better and more sustainable future for all. (Sustainable_Development_Goals__c)",
                    sensitivityLevel: 'confidential',
                },
                publicSustainableDevelopmentGoals: {
                    type: 'boolean',
                    default: false,
                    description: 'Controls whether this identifier is displayed externally - ex: on AppExchange listings (Sustainable_Development_Goals_Is_Public__c)',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/listings/Listing/extension': {
        get: () => ({
            $id: 'listing/extensions/quip/listings/Listing/extension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_Extension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: [
                        'listing/extensions/quip/listings/Listing/extensions/PackageListing',
                        'listing/extensions/quip/listings/Listing/extensions/APIListing',
                    ],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/quip/listings/Listing/extensions/PackageListing'].get(),
                        schemas['listing/extensions/quip/listings/Listing/extensions/APIListing'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { extensionType: 'listing/extensions/quip/listings/Listing/extensions/PackageListing' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/listings/Listing/extensions/APIListing': {
        get: () => ({
            $id: 'listing/extensions/quip/listings/Listing/extensions/APIListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_APIListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                provisionFlow: { type: 'string', enum: ['Representative', 'External'], sensitivityLevel: 'public' },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
                extensions: {
                    type: 'array',
                    description: 'The extensions that quip API Listings can have',
                    items: schemas['listing/extensions/quip/listings/Listing/extensions/APIListingExtension'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/listings/Listing/extensions/APIListingExtension': {
        get: () => ({
            $id: 'listing/extensions/quip/listings/Listing/extensions/APIListingExtension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_APIListingExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: ['listing/extensions/quip/listings/Listing/extensions/APIListing/TestDrive'],
                },
                data: {
                    anyOf: [schemas['listing/extensions/quip/listings/Listing/extensions/APIListing/TestDrive'].get()],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/quip/listings/Listing/extensions/APIListing/TestDrive',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/listings/Listing/extensions/APIListing/TestDrive': {
        get: () => ({
            $id: 'listing/extensions/quip/listings/Listing/extensions/APIListing/TestDrive',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_APITestDrive',
            type: 'object',
            required: ['testDriveOrgID', 'testDrivePassword', 'testDriveUserName'],
            properties: {
                enableTestDrive: {
                    type: 'boolean',
                    default: false,
                    description: 'Does the listing have a test drive?',
                    sensitivityLevel: 'internal',
                },
                testDriveCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                testDriveOrgID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveOrgID__c)',
                    sensitivityLevel: 'internal',
                },
                testDrivePassword: {
                    type: 'string',
                    maxLength: 50,
                    description: '(TestDrivePassword__c)',
                    sensitivityLevel: 'confidential',
                },
                testDriveUserName: {
                    type: 'string',
                    maxLength: 80,
                    description: '(TestDriveUserName__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { testDriveOrgID: '', testDrivePassword: '', testDriveUserName: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/listings/Listing/extensions/PackageListing': {
        get: () => ({
            $id: 'listing/extensions/quip/listings/Listing/extensions/PackageListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_PackageListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                gitHubRepositoryURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'GitHub/Repository URL for Component type of Listing (GitHub_Repository_URL__c)',
                    sensitivityLevel: 'public',
                },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
                provisionFlow: {
                    type: 'string',
                    default: '',
                    enum: ['Representative', 'External', 'Package'],
                    sensitivityLevel: 'public',
                },
                extensions: {
                    type: 'array',
                    description: 'The extensions that force Package Listings can have',
                    items: schemas['listing/extensions/quip/listings/Listing/extensions/PackageListingExtension'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/listings/Listing/extensions/PackageListingExtension': {
        get: () => ({
            $id: 'listing/extensions/quip/listings/Listing/extensions/PackageListingExtension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_PackageListingExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: ['listing/extensions/quip/listings/Listing/extensions/PackageListing/TestDrive'],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/quip/listings/Listing/extensions/PackageListing/TestDrive'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/quip/listings/Listing/extensions/PackageListing/TestDrive',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/quip/listings/Listing/extensions/PackageListing/TestDrive': {
        get: () => ({
            $id: 'listing/extensions/quip/listings/Listing/extensions/PackageListing/TestDrive',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Quip_PackageTestDrive',
            type: 'object',
            required: ['enableTestDrive', 'testDriveOrgID', 'testDrivePassword', 'testDriveUserName'],
            properties: {
                enableTestDrive: {
                    type: 'boolean',
                    description: 'Does the listing have a test drive?',
                    sensitivityLevel: 'internal',
                },
                testDriveCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                testDriveOrgID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveOrgID__c)',
                    sensitivityLevel: 'internal',
                },
                testDrivePassword: {
                    type: 'string',
                    maxLength: 50,
                    description: '(TestDrivePassword__c)',
                    sensitivityLevel: 'confidential',
                },
                testDriveUserName: {
                    type: 'string',
                    maxLength: 80,
                    description: '(TestDriveUserName__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                enableTestDrive: false,
                testDriveOrgID: '',
                testDrivePassword: '',
                testDriveUserName: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/b2c/listings/Listing': {
        get: () => ({
            $id: 'listing/extensions/b2c/listings/Listing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_Listing',
            type: 'object',
            required: [
                'status',
                'extensions',
                'systemRequirements',
                'productsRequired',
                'productsSupported',
                'languages',
                'highlights',
                'licenseAgreement',
                'searchBlurb',
                'listingCategories',
            ],
            properties: {
                extensions: {
                    type: 'array',
                    description: 'The extensions that force listings can have, including what subtypes the listing can be.',
                    items: schemas['listing/extensions/b2c/listings/Listing/extension'].get(),
                },
                account: schemas['listing/extensions/b2c/Account'].get(),
                appType: {
                    type: 'string',
                    default: '',
                    description: 'The App Type of a listing',
                    enum: [
                        'Package/Platform/App',
                        'API/Salesforce Platform API',
                        'API/Marketing Cloud API',
                        'Package/Quip',
                        'Package/B2C Commerce Cloud',
                        'API/B2C Commerce API',
                        'Package/Platform/Bolt',
                        'Package/Platform/Flow',
                        'Package/Platform/Component',
                        'Package/Platform/Data',
                    ],
                    sensitivityLevel: 'internal',
                },
                supportedIndustries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: {
                        type: 'string',
                        enum: [
                            'Horizontal Product',
                            'Agriculture & Mining',
                            'Automotive',
                            'Communications',
                            'Consumer Goods',
                            'Education',
                            'Energy',
                            'Engineering, Construction, & Real Estate',
                            'Financial Services',
                            'Government',
                            'Healthcare & Life Sciences',
                            'High Tech',
                            'Manufacturing',
                            'Media & Entertainment',
                            'Professional Services',
                            'Public Sector',
                            'Retail',
                            'Travel, Transportation, and Hospitality',
                            'Nonprofit',
                        ],
                    },
                    uniqueItems: true,
                    description: 'The Supported Induestries that the app is built for.',
                    sensitivityLevel: 'internal',
                },
                targetUserPersona: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: schemas['listing/TargetUserPersona'].get(),
                    description: 'The target user persona that the app is built for.',
                    uniqueItems: true,
                    sensitivityLevel: 'internal',
                },
                acceptedCheckoutAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the checkout agreement terms (AcceptedCheckoutAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the free agreement terms (AcceptedFreeAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAppsAgreement: {
                    type: 'boolean',
                    description: 'Salesforce agreement that the publisher has to accept when a listing is free (AcceptedFreeAppsAgreement__c)',
                    sensitivityLevel: 'confidential',
                },
                acceptedPaidAppsAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the paid agreement terms (AcceptedPaidAppsAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                achApplicationFee: {
                    type: 'string',
                    description: 'Indicates the % to charge on listings purchased with an ACH payment type (AchApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                allowACHPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts ACH as Payment Method during the checkout flow. (AllowACHPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowCCPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts Credit Cards as Payment Method during the checkout flow. (AllowCCPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowSEPAPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts SEPA as Payment Method during the checkout flow. (AllowSEPAPayment__c)',
                    sensitivityLevel: 'public',
                },
                approvedDate: {
                    type: 'string',
                    description: 'This field has the date that the contract was approved. Populated via a callout from the TE org. (Approved_Date__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                businessApproval: {
                    type: 'string',
                    default: 'In Progress',
                    enum: ['Approved', 'Rejected', 'Submitted', 'In Progress', 'Approved Pending Compliance'],
                    description: '(Business_Approval__c)',
                    sensitivityLevel: 'confidential',
                },
                businessRejectionComment: {
                    type: 'string',
                    maxLength: 2000,
                    description: "The reason this listing's Business Questionnaire was rejected. This is used in the email sent to the partner, combined with the Compliance Rejection Comment, informing them that their submission was rejected. (Business_Rejection_Comment__c)",
                    sensitivityLevel: 'confidential',
                },
                businessQuestionnaireSubmittedOn: {
                    type: 'string',
                    description: '(Business_Questionnaire_Submitted_on__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                categories: {
                    type: 'string',
                    enum: ['Cloud Apps', 'Customization', 'Desktop Apps', 'Integration', 'Mobile Apps', 'Websites'],
                    description: '(Categories__c)',
                    sensitivityLevel: 'public',
                },
                listingCategories: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255 },
                    uniqueItems: true,
                    minItems: 0,
                    description: 'New field to hold the categories.',
                    sensitivityLevel: 'public',
                },
                categoriesToFeeds: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'Categories to feed Feeds. (CategoriestoFeeds__c)',
                    sensitivityLevel: 'public',
                },
                checkoutEnabledDate: {
                    type: 'string',
                    description: 'The date when the listing was associated with a Recurly plan or when it was changed form a External to a Recurly plan. (CheckoutEnabledDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                collectPaymentBeforeInstall: {
                    type: 'boolean',
                    description: '(CollectPaymentBeforeInstall__c)',
                    sensitivityLevel: 'internal',
                },
                contractStatus: {
                    type: 'string',
                    enum: ['Incomplete', 'In Progress', 'Approved'],
                    description: 'Contract status set via a callout from the TE org. (Contract_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                contractType: {
                    type: 'string',
                    enum: ['Connector', 'Freemium', 'ISVforce clickthrough', 'ISVforce non-standard', 'OEM', 'VAR'],
                    description: 'Contract type set via a callout from the TE org. (Contract_Type__c)',
                    sensitivityLevel: 'confidential',
                },
                createdByOrgID: {
                    type: 'string',
                    description: 'The Org ID of the user who created the listing (CreatedByOrgID__C)',
                    sensitivityLevel: 'confidential',
                },
                creditorIdentifier: {
                    type: 'string',
                    maxLength: 255,
                    description: 'A Single Euro Payments Area Creditor Identifier or SEPA Creditor Id is a standardized and unchanging identification number that serves to unequivocally identify a creditor across Europe. (CreditorIdentifier__c)',
                    sensitivityLevel: 'confidential',
                },
                curatedListing1: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_1__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing2: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_2__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing3: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_3__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing4: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_4__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing5: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_5__c)",
                    sensitivityLevel: 'public',
                },
                deleteReason: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The reason the publisher specified when deleting this Listing. (DeleteReason__c)',
                    sensitivityLevel: 'confidential',
                },
                delistedDate: {
                    type: 'string',
                    description: 'The date when the listing was delisted (DelistedDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                delistedReason: {
                    type: 'string',
                    enum: [
                        'Partner went out of business',
                        'Partner bought out',
                        'Application had technical issues',
                        'Product failed to gain traction',
                        'Unhappy with partnership',
                        'Temp delisting',
                        'App had not been updated',
                        'No owner to maintain App',
                        'App had low installs',
                        'Not Lightning Ready',
                        'Security non-compliance',
                    ],
                    description: 'Reason for delisting. (DelistedReason__c)',
                    sensitivityLevel: 'confidential',
                },
                devices: {
                    type: 'array',
                    items: { type: 'string', enum: ['Phone', 'Tablet', 'Desktop'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(Devices__c)',
                    sensitivityLevel: 'public',
                },
                directoryEntryID: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The ID of the legacy directory entry record from which this object was migrated. (DirectoryEntryID__c)',
                    sensitivityLevel: 'confidential',
                },
                displayHover: {
                    type: 'boolean',
                    default: true,
                    description: 'Indicates if the tile should display the hover or not (DisplayHover__c)',
                    sensitivityLevel: 'internal',
                },
                editions: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', enum: ['PE', 'EE', 'UE', 'DE', 'PP', 'FE', 'ES'] },
                    uniqueItems: true,
                    description: "Select one or more Salesforce editions with which your app is compatible (Note: 'PP','FE','ES' are deprecated). If your app uses Salesforce APIs, it cannot run on Group or Professional editions. If your app uses any standard Salesforce objects, it cannot run on Force.com edition. (Editions__c)",
                    sensitivityLevel: 'public',
                },
                productsRequired: {
                    type: 'array',
                    items: schemas['listing/SalesforceRequiredProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 4,
                    description: '(Required_Cloud__c)',
                    sensitivityLevel: 'public',
                },
                productsSupported: {
                    type: 'array',
                    items: schemas['listing/SalesforceSupportedProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 0,
                    maxItems: 3,
                    description: '(New field) This is supplimentary information that may add more context to the relevant input.',
                    sensitivityLevel: 'public',
                },
                highlights: {
                    type: 'array',
                    maxItems: 9,
                    default: [],
                    items: { type: 'string', maxLength: 255, minLength: 1 },
                    uniqueItems: false,
                    minItems: 1,
                    description: 'New field to hold the highlights.',
                    sensitivityLevel: 'public',
                },
                featured: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if this listing is returned when users filter for featured apps in the search results. (Featured__c)',
                    sensitivityLevel: 'public',
                },
                filledDateTime: { type: 'string', format: 'date-time', sensitivityLevel: 'confidential' },
                industries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    description: "Indicates which industries categories this Listing belongs to. (CategorizedListing__r.ListingCategory__r.CategoryType__r.Name == 'Industries')",
                    items: { type: 'string' },
                    sensitivityLevel: 'public',
                },
                isLightningComponent: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningComponent__c)',
                    sensitivityLevel: 'public',
                },
                isSalesProgram: {
                    type: 'boolean',
                    default: false,
                    description: 'Sales Program',
                    sensitivityLevel: 'public',
                },
                isLightningReady: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningReady__c)',
                    sensitivityLevel: 'public',
                },
                isMultiCurrency: {
                    type: 'boolean',
                    default: false,
                    description: '(isMulti_currency__c)',
                    sensitivityLevel: 'public',
                },
                isPersonAccounts: {
                    type: 'boolean',
                    default: false,
                    description: '(isPersonAccounts__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforce1Mobile: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforce1Mobile__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforceShield: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforceShield__c)',
                    sensitivityLevel: 'public',
                },
                isPledge1Percent: {
                    type: 'boolean',
                    default: false,
                    description: '(isPledge1Percent__c)',
                    sensitivityLevel: 'public',
                },
                isFreemium: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is initially free but payment is required for additional users, features, or usage. (Freemium__c)',
                    sensitivityLevel: 'public',
                },
                isMarketingCloud: {
                    type: 'boolean',
                    default: false,
                    description: '(isMarketingCloud__c)',
                    sensitivityLevel: 'public',
                },
                isLightningAppBuilder: {
                    type: 'boolean',
                    default: false,
                    description: 'Lightning App Builder',
                    sensitivityLevel: 'public',
                },
                isFedrampCertified: {
                    type: 'boolean',
                    default: false,
                    description: 'FedRAMP Certified',
                    sensitivityLevel: 'public',
                },
                isHIPAACompliant: {
                    type: 'boolean',
                    default: false,
                    description: 'HIPAA Compliant',
                    sensitivityLevel: 'public',
                },
                isMinorityOwned: {
                    type: 'boolean',
                    default: false,
                    description: 'Minority Owned',
                    sensitivityLevel: 'public',
                },
                isDiverseOwnedBusiness: {
                    type: 'boolean',
                    default: false,
                    description: 'Diverse-owned Business',
                    sensitivityLevel: 'public',
                },
                diverseOwnedBusinessURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Diverse-owned Business URL or Cert',
                    sensitivityLevel: 'public',
                },
                isAccessibleSolution: {
                    type: 'boolean',
                    default: false,
                    description: 'Accessible Solution',
                    sensitivityLevel: 'public',
                },
                accessibleSolutionURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Accessible Solution URL or Cert',
                    sensitivityLevel: 'public',
                },
                languages: {
                    type: 'array',
                    default: [],
                    items: schemas['listing/Languages'].get(),
                    uniqueItems: true,
                    minItems: 1,
                    description: 'Describes the set of languages that this App supports. (Languages__c)',
                    sensitivityLevel: 'public',
                },
                lastStatusChangeDateTime: {
                    type: 'string',
                    format: 'date-time',
                    description: 'The date when the status of the job last changed. (LastStatusChangeDateTime__c)',
                    sensitivityLevel: 'confidential',
                },
                learnMoreURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Specify the URL where the customer can contact the publisher to learn more about installing/buying the app. (LearnMoreURL__c)',
                    sensitivityLevel: 'public',
                },
                longDescription: {
                    type: 'string',
                    maxLength: 1200,
                    description: 'The long description of the AppListing show on the App Detail page. (LongDescription__c)',
                    sensitivityLevel: 'public',
                },
                marketplace: {
                    type: 'string',
                    maxLength: 22,
                    enum: ['English', 'AppExchange_Japanese'],
                    description: 'The Marketplace on which this Listing can be publicly viewed. These values correspond to the Marketplace name, not SFID - they are converted to (Marketplace__c) IDs during Mulesoft sync.',
                    sensitivityLevel: 'internal',
                },
                orderInSetup: {
                    type: 'number',
                    maximum: 99,
                    description: "The place this App has in the Featured Apps Carousel in Org's Setup. i.e : 1 for first, 2 for second, etc.",
                    sensitivityLevel: 'internal',
                },
                org62ApplicationId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Application Record ID on ORG62 (Org62ApplicationId__c)',
                    sensitivityLevel: 'confidential',
                },
                priceDetails: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The detailed pricing information for this App. (PriceDetails__c)',
                    sensitivityLevel: 'public',
                },
                isFree: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if the App on this Listing is free for everyone. (PriceFree__c)',
                    sensitivityLevel: 'public',
                },
                priceNonProfitDiscount: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the app is available to nonprofits for a discount or free. (PriceNonProfitDiscount__c)',
                    sensitivityLevel: 'public',
                },
                pricingRestrictions: {
                    type: 'string',
                    maxLength: 255,
                    description: 'provide by CX (PricingRestrictions__c)',
                    sensitivityLevel: 'internal',
                },
                programmingLanguages: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: [
                            'AandV',
                            'Csharp',
                            'HTMLCSSJavaScript',
                            'Java',
                            'NodeJs',
                            'ObjectiveC',
                            'Perl',
                            'PHP',
                            'Python',
                            'Ruby',
                            'SQLPostgres',
                        ],
                    },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(programmingLanguages__c)',
                    sensitivityLevel: 'public',
                },
                public: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether this Listing is publicly viewable on the Marketplace. (Public__c)',
                    sensitivityLevel: 'internal',
                },
                publishedDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The date when this Listing was publicly published on the Marketplace. (PublishedDate__c)',
                    sensitivityLevel: 'internal',
                },
                publishLocation: {
                    type: 'string',
                    enum: [
                        'AppExchange',
                        'French Partner Finder',
                        'German Partner Finder',
                        'Italian Partner Finder',
                        'Japanese Partner Finder',
                        'Korean Partner Finder',
                        'Portuguese Partner Finder',
                        'Dutch Partner Finder',
                        'Spanish Partner Finder',
                        'Swedish Partner Finder',
                        'Chinese Partner Finder',
                        'Traditional Chinese Partner Finder',
                    ],
                    description: 'Partner finder feed. (PublishLocation__c)',
                    sensitivityLevel: 'internal',
                },
                recordType: {
                    type: 'string',
                    enum: ['App', 'BoltTemplate', 'Bot', 'Component', 'Content', 'Data', 'Flow', 'Service', 'Template'],
                    description: 'The type of listing (RecordTypeId)',
                    sensitivityLevel: 'internal',
                },
                requiresPaidService: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is free but requires a paid subscription to an external service. (RequiresPaidService__c)',
                    sensitivityLevel: 'public',
                },
                searchBlurb: {
                    type: 'string',
                    default: '',
                    maxLength: 75,
                    description: 'Search Blurb to display on the search results page. (SearchBlurb__c)',
                    sensitivityLevel: 'public',
                },
                sepaApplicationFee: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100,
                    description: 'Indicates the % to charge on listings purchased with a SEPA payment type. (SepaApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: [
                        'New',
                        'In Review',
                        'Approved',
                        'Inactive',
                        'InActiveRevPlaceHolder',
                        'Delisted',
                        'Open',
                        'Filled',
                        'Completed',
                        'Canceled',
                    ],
                    default: 'New',
                    description: 'Indicates what stage in the review process the Listing is in for the Marketplace. (Status__c)',
                    sensitivityLevel: 'confidential',
                },
                submissionStatus: {
                    type: 'string',
                    enum: [
                        'Not Ready for Submission / Incomplete',
                        'Ready for Submission',
                        'Submitted - Pending Review',
                        'Approved',
                        'Rejected',
                    ],
                    description: 'Indicates the submission status from the TE org. (Submission_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                systemRequirements: {
                    type: 'string',
                    default: '',
                    maxLength: 255,
                    description: "Specify any additional system requirements that your app may have. For example, supported browsers, operating systems, or hardware. If your app does not have any additional system requirements, select 'No Additional System Requirements'. (SystemRequirements__c)",
                    sensitivityLevel: 'public',
                },
                securityReviewStatus: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Status of the Security Review associated with this Listing. SecReview id in(SecurityReview__c)',
                    sensitivityLevel: 'internal',
                },
                salesEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    maxLength: 255,
                    description: 'The email address for contacting the Publisher sales team. (SalesEmail__c)',
                    sensitivityLevel: 'internal',
                },
                salesPhone: {
                    type: 'string',
                    maxLength: 40,
                    description: 'The phone number for contacting the Publisher sales team. (SalesPhone__c)',
                    sensitivityLevel: 'internal',
                },
                salesWebsite: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The website URL for learning more about buying this App from the Publisher. (SalesWebsite__c)',
                    sensitivityLevel: 'internal',
                },
                licenseAgreement: {
                    type: 'string',
                    default: '',
                    maxLength: 32000,
                    description: 'T&C, The license agreement for the app.(LicenseAgreement__c)',
                    sensitivityLevel: 'public',
                },
                installationAgreement: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'T&C, installation agreement for the app.(Marketplace__r.InstallationAgreement__c)',
                    sensitivityLevel: 'public',
                },
                listingUrl: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Listing site url',
                    sensitivityLevel: 'public',
                },
                selfAttestation: {
                    type: 'boolean',
                    description: 'Indicates if self attestation has been accepted',
                    default: false,
                    sensitivityLevel: 'confidential',
                },
                selfAttestationDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the self attestation',
                    format: 'date-time',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensions: [],
                listingCategories: [],
                productsRequired: [],
                productsSupported: [],
                highlights: [],
                languages: [],
                searchBlurb: '',
                status: 'New',
                systemRequirements: '',
                licenseAgreement: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/b2c/Account': {
        get: () => ({
            sensitivityLevel: 'internal',
            $id: 'listing/extensions/b2c/Account',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_Account',
            type: 'object',
            properties: {
                name: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name of the account (Name)',
                    sensitivityLevel: 'internal',
                },
                id: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The external identifier for the account on Tz (Id)',
                    sensitivityLevel: 'internal',
                },
                accountNumber: {
                    type: 'string',
                    maxLength: 40,
                    description: '(AccountNumber)',
                    sensitivityLevel: 'confidential',
                },
                site: {
                    type: 'string',
                    maxLength: 80,
                    description: '(AccountNumber)',
                    sensitivityLevel: 'confidential',
                },
                annualRevenue: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(AnnualRevenue)',
                    sensitivityLevel: 'confidential',
                },
                numberOfEmployees: {
                    type: 'integer',
                    maxLength: 8,
                    description: 'Total number of employees at the company. (NumberOfEmployees)',
                    sensitivityLevel: 'internal',
                },
                fax: { type: 'string', maxLength: 15, description: '(Fax)', sensitivityLevel: 'public' },
                phone: { type: 'string', maxLength: 15, description: '(Phone)', sensitivityLevel: 'public' },
                rating: {
                    type: 'string',
                    enum: ['Hot', 'Warm', 'Cold'],
                    description: '(Rating)',
                    sensitivityLevel: 'public',
                },
                website: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: '(Website)',
                    sensitivityLevel: 'public',
                },
                active: {
                    type: 'string',
                    enum: ['No', 'Yes'],
                    description: 'Active__c)',
                    sensitivityLevel: 'internal',
                },
                customerPriority: {
                    type: 'string',
                    enum: ['High', 'Low', 'Medium'],
                    description: '(CustomerPriority__c)',
                    sensitivityLevel: 'internal',
                },
                customerSatisfactionRating: {
                    type: 'number',
                    maxLength: 18,
                    description: '(Customer_Satisfaction_Rating__c)',
                    sensitivityLevel: 'internal',
                },
                developerPrefix: {
                    type: 'string',
                    maxLength: 4,
                    description: '4 character prefix to uniqify custom objects created by this developer (Developer_Prefix__c)',
                    sensitivityLevel: 'confidential',
                },
                isDupeAccount: {
                    type: 'boolean',
                    default: false,
                    description: '(Is_Dupe_Account__c)',
                    sensitivityLevel: 'internal',
                },
                isOldMCAccount: {
                    type: 'boolean',
                    default: false,
                    description: 'Checked if the Account was created before 2016-03-11 and is a Marketing Cloud Identity Account, otherwise, this field should be unchecked (Is_Old_MC_Account__c)',
                    sensitivityLevel: 'internal',
                },
                patchDevOrg: {
                    type: 'boolean',
                    default: false,
                    description: '(patchDevOrg__c)',
                    sensitivityLevel: 'internal',
                },
                ISVPartnerTier: {
                    type: 'string',
                    maxLength: 100,
                    description: '(ISVPartnerTier__c)',
                    sensitivityLevel: 'internal',
                },
                marketingCloudId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Marketing Cloud account Id (Marketing_Cloud_Id__c)',
                    sensitivityLevel: 'confidential',
                },
                masterPartnerAccount: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Master Partner Account Id of Partner Summary record in Org62 (Master_Partner_Account__c)',
                    sensitivityLevel: 'confidential',
                },
                nonProfitAccount: {
                    type: 'boolean',
                    default: false,
                    description: '(Non_Profit_Account__c)',
                    sensitivityLevel: 'internal',
                },
                numberofExperts: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(Number_of_Experts__c)',
                    sensitivityLevel: 'internal',
                },
                numberofLocations: {
                    type: 'integer',
                    maxLength: 3,
                    description: '(NumberofLocations__c)',
                    sensitivityLevel: 'internal',
                },
                numberofProjects: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(Number_of_Projects__c)',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                org62PartnerSummaryId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Id of Partner Summary record in Org62 (Org61ParnerSummaryId__c)',
                    sensitivityLevel: 'confidential',
                },
                orgCustomDomain: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce custom domain value if my domains enabled for the org (OrgCustomDomain__c)',
                    sensitivityLevel: 'confidential',
                },
                orgDomain: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce instance domain name where the account resides (OrgDomain__c)',
                    sensitivityLevel: 'confidential',
                },
                orgEdition: {
                    type: 'string',
                    maxLength: 32,
                    description: '(orgEdition__c)',
                    sensitivityLevel: 'confidential',
                },
                orgId: { type: 'string', maxLength: 18, description: '(orgId__c)', sensitivityLevel: 'confidential' },
                orgInstance: {
                    type: 'string',
                    maxLength: 8,
                    description: '(orgInstance__c)',
                    sensitivityLevel: 'confidential',
                },
                orgReleaseVersion: {
                    type: 'string',
                    maxLength: 20,
                    description: 'The Salesforce release version the org is on. (OrgReleaseVersion__c)',
                    sensitivityLevel: 'confidential',
                },
                orgStatus: {
                    type: 'string',
                    maxLength: 32,
                    description: '(orgStatus__c)',
                    sensitivityLevel: 'confidential',
                },
                partnerAccessRevoked: {
                    type: 'boolean',
                    default: false,
                    description: '(PartnerAccessRevoked__c)',
                    sensitivityLevel: 'internal',
                },
                partnerAccountId: {
                    type: 'string',
                    maxLength: 100,
                    description: '(PartnerAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                partnerCertificationGoal: {
                    type: 'integer',
                    maxLength: 18,
                    description: 'Partner Certification Goal represents a goal of the total number of certifications that the partner will have at the end of the fiscal year.',
                    sensitivityLevel: 'confidential',
                },
                partnerSupportLevel: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Indicates the Support Level for the Partner Account (PartnerSupportLevel__c)',
                    sensitivityLevel: 'internal',
                },
                partnerType: {
                    type: 'string',
                    enum: ['SI', 'ISV'],
                    description: '(Partner_Type__c)',
                    sensitivityLevel: 'internal',
                },
                pledge1Member: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the partner has pledged 1% to charity (Pledge_1_Member__c)',
                    sensitivityLevel: 'internal',
                },
                prodAccountID: {
                    type: 'string',
                    maxLength: 100,
                    description: '(PartnerAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                sfdcOrgId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'to match up for entitlements export (SFDC_OrgId__c)',
                    sensitivityLevel: 'confidential',
                },
                siPartnerTier: {
                    type: 'string',
                    maxLength: 100,
                    description: '(SIPartnerTier__c)',
                    sensitivityLevel: 'internal',
                },
                sla: {
                    type: 'string',
                    enum: ['Gold', 'Silver', 'Platinum', 'Bronze'],
                    description: 'null (SLA__c)',
                    sensitivityLevel: 'internal',
                },
                slaExpirationDate: {
                    type: 'string',
                    format: 'date',
                    description: '(SLAExpirationDate__c)',
                    sensitivityLevel: 'internal',
                },
                slaSerialNumber: {
                    type: 'string',
                    maxLength: 10,
                    description: '(SLASerialNumber__c)',
                    sensitivityLevel: 'confidential',
                },
                bfontcolorredSupportLevel: {
                    type: 'string',
                    enum: ['Silver', 'Platinum', 'Gold'],
                    description: '(bfontcolorredSupportLevel__c)',
                    sensitivityLevel: 'internal',
                },
                syncedwith62org: {
                    type: 'boolean',
                    default: false,
                    description: '(Synced_with_62_org__c)',
                    sensitivityLevel: 'internal',
                },
                diverseLeadership: {
                    type: 'boolean',
                    default: false,
                    description: 'At least 30% of this company’s executive leadership team belongs to one or more of the following groups: persons with disabilities, women, veterans, minorities (U.S. Only), or LGBTQ. (Diverse_Leadership__c)',
                    sensitivityLevel: 'confidential',
                },
                publicDiverseLeadership: {
                    type: 'boolean',
                    default: false,
                    description: 'Controls whether this identifier is displayed externally - ex: on AppExchange listings (Diverse_Leadership_Is_Public__c)',
                    sensitivityLevel: 'internal',
                },
                sustainableDevelopmentGoals: {
                    type: 'boolean',
                    default: false,
                    description: "This company has committed to one or more of the United Nation's Sustainable Development Goals, which focus on creating a better and more sustainable future for all. (Sustainable_Development_Goals__c)",
                    sensitivityLevel: 'confidential',
                },
                publicSustainableDevelopmentGoals: {
                    type: 'boolean',
                    default: false,
                    description: 'Controls whether this identifier is displayed externally - ex: on AppExchange listings (Sustainable_Development_Goals_Is_Public__c)',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/b2c/listings/Listing/extension': {
        get: () => ({
            $id: 'listing/extensions/b2c/listings/Listing/extension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_Extension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: [
                        'listing/extensions/b2c/listings/Listing/extensions/PackageListing',
                        'listing/extensions/b2c/listings/Listing/extensions/APIListing',
                    ],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/b2c/listings/Listing/extensions/PackageListing'].get(),
                        schemas['listing/extensions/b2c/listings/Listing/extensions/APIListing'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { extensionType: 'listing/extensions/b2c/listings/Listing/extensions/PackageListing' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/b2c/listings/Listing/extensions/APIListing': {
        get: () => ({
            $id: 'listing/extensions/b2c/listings/Listing/extensions/APIListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_APIListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                provisionFlow: { type: 'string', enum: ['Representative', 'External'], sensitivityLevel: 'public' },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/b2c/listings/Listing/extensions/PackageListing': {
        get: () => ({
            $id: 'listing/extensions/b2c/listings/Listing/extensions/PackageListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_PackageListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                gitHubRepositoryURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'GitHub/Repository URL for Component type of Listing (GitHub_Repository_URL__c)',
                    sensitivityLevel: 'public',
                },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
                provisionFlow: {
                    type: 'string',
                    default: '',
                    enum: ['Representative', 'External', 'Package'],
                    sensitivityLevel: 'public',
                },
                extensions: {
                    type: 'array',
                    description: 'The extensions that force Package Listings can have',
                    items: schemas['listing/extensions/b2c/listings/Listing/extensions/PackageListingExtension'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/b2c/listings/Listing/extensions/PackageListingExtension': {
        get: () => ({
            $id: 'listing/extensions/b2c/listings/Listing/extensions/PackageListingExtension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_PackageListingExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: ['listing/extensions/b2c/listings/Listing/extensions/PackageListing/TestDrive'],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/b2c/listings/Listing/extensions/PackageListing/TestDrive'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/b2c/listings/Listing/extensions/PackageListing/TestDrive',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/b2c/listings/Listing/extensions/PackageListing/TestDrive': {
        get: () => ({
            $id: 'listing/extensions/b2c/listings/Listing/extensions/PackageListing/TestDrive',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'B2C_TestDrive',
            type: 'object',
            required: ['testDriveOrgID', 'testDrivePassword', 'testDriveUserName'],
            properties: {
                testDriveCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                testDriveOrgID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveOrgID__c)',
                    sensitivityLevel: 'internal',
                },
                testDrivePassword: {
                    type: 'string',
                    maxLength: 50,
                    description: '(TestDrivePassword__c)',
                    sensitivityLevel: 'confidential',
                },
                testDriveUserName: {
                    type: 'string',
                    maxLength: 80,
                    description: '(TestDriveUserName__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { testDriveOrgID: '', testDrivePassword: '', testDriveUserName: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_Listing',
            type: 'object',
            required: [
                'status',
                'extensions',
                'systemRequirements',
                'productsRequired',
                'productsSupported',
                'languages',
                'highlights',
                'licenseAgreement',
                'searchBlurb',
                'listingCategories',
            ],
            properties: {
                extensions: {
                    type: 'array',
                    description: 'The extensions that force listings can have, including what subtypes the listing can be.',
                    items: schemas['listing/extensions/force/listings/Listing/extension'].get(),
                },
                account: schemas['listing/extensions/force/Account'].get(),
                appType: {
                    type: 'string',
                    default: '',
                    description: 'The App Type of a listing',
                    enum: [
                        'Package/Platform/App',
                        'API/Salesforce Platform API',
                        'API/Marketing Cloud API',
                        'Package/Quip',
                        'Package/B2C Commerce Cloud',
                        'API/B2C Commerce API',
                        'Package/Platform/Bolt',
                        'Package/Platform/Flow',
                        'Package/Platform/Component',
                        'Package/Platform/Data',
                    ],
                    sensitivityLevel: 'internal',
                },
                supportedIndustries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: {
                        type: 'string',
                        enum: [
                            'Horizontal Product',
                            'Agriculture & Mining',
                            'Automotive',
                            'Communications',
                            'Consumer Goods',
                            'Education',
                            'Energy',
                            'Engineering, Construction, & Real Estate',
                            'Financial Services',
                            'Government',
                            'Healthcare & Life Sciences',
                            'High Tech',
                            'Manufacturing',
                            'Media & Entertainment',
                            'Professional Services',
                            'Public Sector',
                            'Retail',
                            'Travel, Transportation, and Hospitality',
                            'Nonprofit',
                        ],
                    },
                    uniqueItems: true,
                    description: 'The Supported Induestries that the app is built for.',
                    sensitivityLevel: 'internal',
                },
                targetUserPersona: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    items: schemas['listing/TargetUserPersona'].get(),
                    description: 'The target user persona that the app is built for.',
                    uniqueItems: true,
                    sensitivityLevel: 'internal',
                },
                acceptedCheckoutAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the checkout agreement terms (AcceptedCheckoutAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the free agreement terms (AcceptedFreeAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                acceptedFreeAppsAgreement: {
                    type: 'boolean',
                    description: 'Salesforce agreement that the publisher has to accept when a listing is free (AcceptedFreeAppsAgreement__c)',
                    sensitivityLevel: 'confidential',
                },
                acceptedPaidAppsAgreementDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the paid agreement terms (AcceptedPaidAppsAgreementDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                achApplicationFee: {
                    type: 'string',
                    description: 'Indicates the % to charge on listings purchased with an ACH payment type (AchApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                allowACHPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts ACH as Payment Method during the checkout flow. (AllowACHPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowCCPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts Credit Cards as Payment Method during the checkout flow. (AllowCCPayment__c)',
                    sensitivityLevel: 'public',
                },
                allowSEPAPayment: {
                    type: 'boolean',
                    description: 'Field indicating whether the Listing accepts SEPA as Payment Method during the checkout flow. (AllowSEPAPayment__c)',
                    sensitivityLevel: 'public',
                },
                approvedDate: {
                    type: 'string',
                    description: 'This field has the date that the contract was approved. Populated via a callout from the TE org. (Approved_Date__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                businessApproval: {
                    type: 'string',
                    default: 'In Progress',
                    enum: ['Approved', 'Rejected', 'Submitted', 'In Progress', 'Approved Pending Compliance'],
                    description: '(Business_Approval__c)',
                    sensitivityLevel: 'confidential',
                },
                businessRejectionComment: {
                    type: 'string',
                    maxLength: 2000,
                    description: "The reason this listing's Business Questionnaire was rejected. This is used in the email sent to the partner, combined with the Compliance Rejection Comment, informing them that their submission was rejected. (Business_Rejection_Comment__c)",
                    sensitivityLevel: 'confidential',
                },
                businessQuestionnaireSubmittedOn: {
                    type: 'string',
                    description: '(Business_Questionnaire_Submitted_on__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                categories: {
                    type: 'string',
                    enum: ['Cloud Apps', 'Customization', 'Desktop Apps', 'Integration', 'Mobile Apps', 'Websites'],
                    description: '(Categories__c)',
                    sensitivityLevel: 'public',
                },
                listingCategories: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', maxLength: 255 },
                    uniqueItems: true,
                    minItems: 0,
                    description: 'New field to hold the categories.',
                    sensitivityLevel: 'public',
                },
                categoriesToFeeds: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'Categories to feed Feeds. (CategoriestoFeeds__c)',
                    sensitivityLevel: 'public',
                },
                checkoutEnabledDate: {
                    type: 'string',
                    description: 'The date when the listing was associated with a Recurly plan or when it was changed form a External to a Recurly plan. (CheckoutEnabledDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                collectPaymentBeforeInstall: {
                    type: 'boolean',
                    description: '(CollectPaymentBeforeInstall__c)',
                    sensitivityLevel: 'internal',
                },
                contractStatus: {
                    type: 'string',
                    enum: ['Incomplete', 'In Progress', 'Approved'],
                    description: 'Contract status set via a callout from the TE org. (Contract_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                contractType: {
                    type: 'string',
                    enum: ['Connector', 'Freemium', 'ISVforce clickthrough', 'ISVforce non-standard', 'OEM', 'VAR'],
                    description: 'Contract type set via a callout from the TE org. (Contract_Type__c)',
                    sensitivityLevel: 'confidential',
                },
                createdByOrgID: {
                    type: 'string',
                    description: 'The Org ID of the user who created the listing (CreatedByOrgID__C)',
                    sensitivityLevel: 'confidential',
                },
                creditorIdentifier: {
                    type: 'string',
                    maxLength: 255,
                    description: 'A Single Euro Payments Area Creditor Identifier or SEPA Creditor Id is a standardized and unchanging identification number that serves to unequivocally identify a creditor across Europe. (CreditorIdentifier__c)',
                    sensitivityLevel: 'confidential',
                },
                curatedListing1: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_1__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing2: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_2__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing3: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_3__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing4: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_4__c)",
                    sensitivityLevel: 'public',
                },
                curatedListing5: {
                    type: 'string',
                    description: "Allows to manually select the first Listing for the 'Customers Also Installed' section on the listing. (Curated_Listing_5__c)",
                    sensitivityLevel: 'public',
                },
                deleteReason: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The reason the publisher specified when deleting this Listing. (DeleteReason__c)',
                    sensitivityLevel: 'confidential',
                },
                delistedDate: {
                    type: 'string',
                    description: 'The date when the listing was delisted (DelistedDate__c)',
                    format: 'date',
                    sensitivityLevel: 'confidential',
                },
                delistedReason: {
                    type: 'string',
                    enum: [
                        'Partner went out of business',
                        'Partner bought out',
                        'Application had technical issues',
                        'Product failed to gain traction',
                        'Unhappy with partnership',
                        'Temp delisting',
                        'App had not been updated',
                        'No owner to maintain App',
                        'App had low installs',
                        'Not Lightning Ready',
                        'Security non-compliance',
                    ],
                    description: 'Reason for delisting. (DelistedReason__c)',
                    sensitivityLevel: 'confidential',
                },
                devices: {
                    type: 'array',
                    items: { type: 'string', enum: ['Phone', 'Tablet', 'Desktop'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(Devices__c)',
                    sensitivityLevel: 'public',
                },
                directoryEntryID: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The ID of the legacy directory entry record from which this object was migrated. (DirectoryEntryID__c)',
                    sensitivityLevel: 'confidential',
                },
                displayHover: {
                    type: 'boolean',
                    default: true,
                    description: 'Indicates if the tile should display the hover or not (DisplayHover__c)',
                    sensitivityLevel: 'internal',
                },
                editions: {
                    type: 'array',
                    default: [],
                    items: { type: 'string', enum: ['PE', 'EE', 'UE', 'DE', 'PP', 'FE', 'ES'] },
                    uniqueItems: true,
                    minItems: 0,
                    description: "Select one or more Salesforce editions with which your app is compatible (Note: 'PP','FE','ES' are deprecated). If your app uses Salesforce APIs, it cannot run on Group or Professional editions. If your app uses any standard Salesforce objects, it cannot run on Force.com edition. (Editions__c)",
                    sensitivityLevel: 'public',
                },
                productsRequired: {
                    type: 'array',
                    items: schemas['listing/SalesforceRequiredProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 4,
                    description: '(Required_Cloud__c)',
                    sensitivityLevel: 'public',
                },
                productsSupported: {
                    type: 'array',
                    items: schemas['listing/SalesforceSupportedProducts'].get(),
                    default: [],
                    uniqueItems: true,
                    minItems: 0,
                    maxItems: 3,
                    description: '(New field) This is supplimentary information that may add more context to the relevant input.',
                    sensitivityLevel: 'public',
                },
                highlights: {
                    type: 'array',
                    maxItems: 9,
                    default: [],
                    items: { type: 'string', maxLength: 255, minLength: 1 },
                    uniqueItems: false,
                    minItems: 1,
                    description: 'New field to hold the highlights.',
                    sensitivityLevel: 'public',
                },
                featured: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if this listing is returned when users filter for featured apps in the search results. (Featured__c)',
                    sensitivityLevel: 'public',
                },
                filledDateTime: { type: 'string', format: 'date-time', sensitivityLevel: 'confidential' },
                industries: {
                    type: 'array',
                    maxItems: 3,
                    default: [],
                    description: "Indicates which industries categories this Listing belongs to. (CategorizedListing__r.ListingCategory__r.CategoryType__r.Name == 'Industries')",
                    items: { type: 'string' },
                    sensitivityLevel: 'public',
                },
                isFreemium: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is initially free but payment is required for additional users, features, or usage. (Freemium__c)',
                    sensitivityLevel: 'public',
                },
                isLightningComponent: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningComponent__c)',
                    sensitivityLevel: 'public',
                },
                isEinsteinAgent: {
                    type: 'boolean',
                    default: false,
                    description: 'Einstein Copilot',
                    sensitivityLevel: 'public',
                },
                isSalesProgram: {
                    type: 'boolean',
                    default: false,
                    description: 'Sales Program',
                    sensitivityLevel: 'public',
                },
                isLightningReady: {
                    type: 'boolean',
                    default: false,
                    description: '(isLightningReady__c)',
                    sensitivityLevel: 'public',
                },
                isMarketingCloud: {
                    type: 'boolean',
                    default: false,
                    description: '(isMarketingCloud__c)',
                    sensitivityLevel: 'public',
                },
                isMultiCurrency: {
                    type: 'boolean',
                    default: false,
                    description: '(isMulti_currency__c)',
                    sensitivityLevel: 'public',
                },
                isPersonAccounts: {
                    type: 'boolean',
                    default: false,
                    description: '(isPersonAccounts__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforce1Mobile: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforce1Mobile__c)',
                    sensitivityLevel: 'public',
                },
                isSalesforceShield: {
                    type: 'boolean',
                    default: false,
                    description: '(isSalesforceShield__c)',
                    sensitivityLevel: 'public',
                },
                isPledge1Percent: {
                    type: 'boolean',
                    default: false,
                    description: '(isPledge1Percent__c)',
                    sensitivityLevel: 'public',
                },
                isLightningAppBuilder: {
                    type: 'boolean',
                    default: false,
                    description: 'Lightning App Builder',
                    sensitivityLevel: 'public',
                },
                isFedrampCertified: {
                    type: 'boolean',
                    default: false,
                    description: 'FedRAMP Certified',
                    sensitivityLevel: 'public',
                },
                isHIPAACompliant: {
                    type: 'boolean',
                    default: false,
                    description: 'HIPAA Compliant',
                    sensitivityLevel: 'public',
                },
                isMinorityOwned: {
                    type: 'boolean',
                    default: false,
                    description: 'Minority Owned',
                    sensitivityLevel: 'public',
                },
                isDiverseOwnedBusiness: {
                    type: 'boolean',
                    default: false,
                    description: 'Diverse-owned Business',
                    sensitivityLevel: 'public',
                },
                diverseOwnedBusinessURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Diverse-owned Business URL or Cert',
                    sensitivityLevel: 'public',
                },
                isAccessibleSolution: {
                    type: 'boolean',
                    default: false,
                    description: 'Accessible Solution',
                    sensitivityLevel: 'public',
                },
                accessibleSolutionURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 250,
                    description: 'Accessible Solution URL or Cert',
                    sensitivityLevel: 'public',
                },
                languages: {
                    type: 'array',
                    default: [],
                    items: schemas['listing/Languages'].get(),
                    uniqueItems: true,
                    minItems: 1,
                    description: 'Describes the set of languages that this App supports. (Languages__c)',
                    sensitivityLevel: 'public',
                },
                lastStatusChangeDateTime: {
                    type: 'string',
                    format: 'date-time',
                    description: 'The date when the status of the job last changed. (LastStatusChangeDateTime__c)',
                    sensitivityLevel: 'confidential',
                },
                learnMoreURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Specify the URL where the customer can contact the publisher to learn more about installing/buying the app. (LearnMoreURL__c)',
                    sensitivityLevel: 'public',
                },
                longDescription: {
                    type: 'string',
                    maxLength: 1200,
                    description: 'The long description of the AppListing show on the App Detail page. (LongDescription__c)',
                    sensitivityLevel: 'public',
                },
                marketplace: {
                    type: 'string',
                    maxLength: 22,
                    enum: ['English', 'AppExchange_Japanese'],
                    description: 'The Marketplace on which this Listing can be publicly viewed. These values correspond to the Marketplace name, not SFID - they are converted to (Marketplace__c) IDs during Mulesoft sync.',
                    sensitivityLevel: 'internal',
                },
                orderInSetup: {
                    type: 'number',
                    maximum: 99,
                    description: "The place this App has in the Featured Apps Carousel in Org's Setup. i.e : 1 for first, 2 for second, etc.",
                    sensitivityLevel: 'internal',
                },
                org62ApplicationId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Application Record ID on ORG62 (Org62ApplicationId__c)',
                    sensitivityLevel: 'confidential',
                },
                priceDetails: {
                    type: 'string',
                    maxLength: 255,
                    description: 'The detailed pricing information for this App. (PriceDetails__c)',
                    sensitivityLevel: 'public',
                },
                isFree: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if the App on this Listing is free for everyone. (PriceFree__c)',
                    sensitivityLevel: 'public',
                },
                priceNonProfitDiscount: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the app is available to nonprofits for a discount or free. (PriceNonProfitDiscount__c)',
                    sensitivityLevel: 'public',
                },
                pricingRestrictions: {
                    type: 'string',
                    maxLength: 255,
                    description: 'provide by CX (PricingRestrictions__c)',
                    sensitivityLevel: 'internal',
                },
                programmingLanguages: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: [
                            'AandV',
                            'Csharp',
                            'HTMLCSSJavaScript',
                            'Java',
                            'NodeJs',
                            'ObjectiveC',
                            'Perl',
                            'PHP',
                            'Python',
                            'Ruby',
                            'SQLPostgres',
                        ],
                    },
                    uniqueItems: true,
                    minItems: 0,
                    description: '(programmingLanguages__c)',
                    sensitivityLevel: 'public',
                },
                public: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether this Listing is publicly viewable on the Marketplace. (Public__c)',
                    sensitivityLevel: 'internal',
                },
                publishedDate: {
                    type: 'string',
                    format: 'date',
                    description: 'The date when this Listing was publicly published on the Marketplace. (PublishedDate__c)',
                    sensitivityLevel: 'internal',
                },
                publishLocation: {
                    type: 'string',
                    enum: [
                        'AppExchange',
                        'French Partner Finder',
                        'German Partner Finder',
                        'Italian Partner Finder',
                        'Japanese Partner Finder',
                        'Korean Partner Finder',
                        'Portuguese Partner Finder',
                        'Dutch Partner Finder',
                        'Spanish Partner Finder',
                        'Swedish Partner Finder',
                        'Chinese Partner Finder',
                        'Traditional Chinese Partner Finder',
                    ],
                    description: 'Partner finder feed. (PublishLocation__c)',
                    sensitivityLevel: 'internal',
                },
                recordType: {
                    type: 'string',
                    enum: ['App', 'BoltTemplate', 'Bot', 'Component', 'Content', 'Data', 'Flow', 'Service', 'Template'],
                    description: 'The type of listing (RecordTypeId)',
                    sensitivityLevel: 'internal',
                },
                requiresPaidService: {
                    type: 'boolean',
                    default: false,
                    description: 'This app is free but requires a paid subscription to an external service. (RequiresPaidService__c)',
                    sensitivityLevel: 'public',
                },
                searchBlurb: {
                    type: 'string',
                    default: '',
                    maxLength: 75,
                    description: 'Search Blurb to display on the search results page. (SearchBlurb__c)',
                    sensitivityLevel: 'public',
                },
                sepaApplicationFee: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100,
                    description: 'Indicates the % to charge on listings purchased with a SEPA payment type. (SepaApplicationFee__c)',
                    sensitivityLevel: 'internal',
                },
                status: {
                    type: 'string',
                    enum: [
                        'New',
                        'In Review',
                        'Approved',
                        'Inactive',
                        'InActiveRevPlaceHolder',
                        'Delisted',
                        'Open',
                        'Filled',
                        'Completed',
                        'Canceled',
                    ],
                    default: 'New',
                    description: 'Indicates what stage in the review process the Listing is in for the Marketplace. (Status__c)',
                    sensitivityLevel: 'confidential',
                },
                submissionStatus: {
                    type: 'string',
                    enum: [
                        'Not Ready for Submission / Incomplete',
                        'Ready for Submission',
                        'Submitted - Pending Review',
                        'Approved',
                        'Rejected',
                    ],
                    description: 'Indicates the submission status from the TE org. (Submission_Status__c)',
                    sensitivityLevel: 'confidential',
                },
                systemRequirements: {
                    type: 'string',
                    default: '',
                    maxLength: 255,
                    description: "Specify any additional system requirements that your app may have. For example, supported browsers, operating systems, or hardware. If your app does not have any additional system requirements, select 'No Additional System Requirements'. (SystemRequirements__c)",
                    sensitivityLevel: 'public',
                },
                securityReviewStatus: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Status of the Security Review associated with this Listing. SecReview id in(SecurityReview__c)',
                    sensitivityLevel: 'internal',
                },
                salesEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    maxLength: 255,
                    description: 'The email address for contacting the Publisher sales team. (SalesEmail__c)',
                    sensitivityLevel: 'internal',
                },
                salesPhone: {
                    type: 'string',
                    maxLength: 40,
                    description: 'The phone number for contacting the Publisher sales team. (SalesPhone__c)',
                    sensitivityLevel: 'internal',
                },
                salesWebsite: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The website URL for learning more about buying this App from the Publisher. (SalesWebsite__c)',
                    sensitivityLevel: 'internal',
                },
                licenseAgreement: {
                    type: 'string',
                    default: '',
                    maxLength: 32000,
                    description: 'T&C, The license agreement for the app.(LicenseAgreement__c)',
                    sensitivityLevel: 'public',
                },
                installationAgreement: {
                    type: 'string',
                    maxLength: 32000,
                    description: 'T&C, installation agreement for the app.(Marketplace__r.InstallationAgreement__c)',
                    sensitivityLevel: 'public',
                },
                listingUrl: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Listing site url',
                    sensitivityLevel: 'public',
                },
                selfAttestation: {
                    type: 'boolean',
                    description: 'Indicates if self attestation has been accepted',
                    default: false,
                    sensitivityLevel: 'confidential',
                },
                selfAttestationDate: {
                    type: 'string',
                    description: 'The date where the user has accepted the self attestation',
                    format: 'date-time',
                    sensitivityLevel: 'confidential',
                },
                listingsRequired: {
                    type: 'array',
                    description: 'Allows to select required listings',
                    default: [],
                    items: { type: 'string', minLength: 36 },
                    uniqueItems: true,
                    minItems: 0,
                    maxItems: 1,
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensions: [],
                listingCategories: [],
                productsRequired: [],
                productsSupported: [],
                highlights: [],
                languages: [],
                searchBlurb: '',
                status: 'New',
                systemRequirements: '',
                licenseAgreement: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/Languages': {
        get: () => ({
            $id: 'listing/Languages',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Languages',
            type: 'string',
            enum: [
                'ar',
                'nl',
                'en',
                'fi',
                'fr',
                'de',
                'da',
                'it',
                'ja',
                'ko',
                'pt',
                'ru',
                'zh_CN',
                'es',
                'sv',
                'th',
                'zh_TW',
            ],
        }),
        new: (override) => {
            const original = 'ar';
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/SalesforceSupportedProducts': {
        get: () => ({
            $id: 'listing/SalesforceSupportedProducts',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Salesforce_Supported_Products',
            type: 'string',
            $comment: 'In new schema version, we should change CDP to Data Cloud and Tableau CRM to CRMA. This implies doing a migration file for existing listings. See W-13536440',
            enum: [
                'None',
                'Sales Cloud',
                'Service Cloud',
                'Marketing Cloud',
                'Pardot',
                'Marketing Cloud Growth',
                'Marketing Cloud Advanced',
                'B2B Commerce Cloud',
                'B2C Commerce Cloud',
                'Commerce Cloud Order Management',
                'Revenue Cloud',
                'CDP',
                'Work.com',
                'Platform Cloud',
                'Experience Cloud',
                'Financial Services Cloud',
                'Health Cloud',
                'Government Cloud',
                'Net Zero Cloud',
                'Tableau CRM',
                'Datorama',
                'Quip',
                'Customer Data Platform',
                'Revenue Cloud Subscription Management',
                'Revenue Cloud CPQ',
                'Revenue Cloud Billing',
                'Salesforce Web3',
                'Tableau',
                'Tableau Server',
                'Tableau Cloud',
                'Data Cloud for Tableau',
                'Manufacturing Cloud',
                'Nonprofit Cloud',
                'D2C Commerce',
                'Hyperforce',
                'Education Cloud',
                'Einstein 1',
                'Consumer Goods Cloud',
            ],
        }),
        new: (override) => {
            const original = 'None';
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/SalesforceRequiredProducts': {
        get: () => ({
            $id: 'listing/SalesforceRequiredProducts',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Salesforce_Required_Products',
            type: 'string',
            $comment: 'In new schema version, we should change CDP to Data Cloud and Tableau CRM to CRMA. This implies doing a migration file for existing listings. See W-13536440',
            enum: [
                'None',
                'Sales Cloud',
                'Service Cloud',
                'Marketing Cloud',
                'Pardot',
                'Marketing Cloud Growth',
                'Marketing Cloud Advanced',
                'B2B Commerce Cloud',
                'B2C Commerce Cloud',
                'Commerce Cloud Order Management',
                'Revenue Cloud',
                'CDP',
                'Work.com',
                'Platform Cloud',
                'Experience Cloud',
                'Financial Services Cloud',
                'Health Cloud',
                'Government Cloud',
                'Net Zero Cloud',
                'Tableau CRM',
                'Datorama',
                'Quip',
                'Customer Data Platform',
                'Revenue Cloud Subscription Management',
                'Revenue Cloud CPQ',
                'Revenue Cloud Billing',
                'Salesforce Web3',
                'Tableau',
                'Manufacturing Cloud',
                'Nonprofit Cloud',
                'D2C Commerce',
                'Einstein 1',
                'Consumer Goods Cloud',
            ],
        }),
        new: (override) => {
            const original = 'None';
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/TargetUserPersona': {
        get: () => ({
            $id: 'listing/TargetUserPersona',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Target_User_Persona',
            type: 'string',
            enum: [
                'Admin',
                'Architect',
                'Business Operations Manager',
                'Business User',
                'Consultant',
                'Data Analyst',
                'Data Professional',
                'Designer',
                'Developer',
                'Educator',
                'Executive',
                'Marketer',
                'Sales',
                'Service Agent / Supervisor',
                'Student',
                'Other',
            ],
        }),
        new: (override) => {
            const original = 'Admin';
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/Account': {
        get: () => ({
            sensitivityLevel: 'internal',
            $id: 'listing/extensions/force/Account',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_Account',
            type: 'object',
            properties: {
                name: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Name of the account (Name)',
                    sensitivityLevel: 'internal',
                },
                id: {
                    type: 'string',
                    maxLength: 18,
                    description: 'The external identifier for the account on Tz (Id)',
                    sensitivityLevel: 'internal',
                },
                accountNumber: {
                    type: 'string',
                    maxLength: 40,
                    description: '(AccountNumber)',
                    sensitivityLevel: 'confidential',
                },
                site: {
                    type: 'string',
                    maxLength: 80,
                    description: '(AccountNumber)',
                    sensitivityLevel: 'confidential',
                },
                annualRevenue: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(AnnualRevenue)',
                    sensitivityLevel: 'confidential',
                },
                numberOfEmployees: {
                    type: 'integer',
                    maxLength: 8,
                    description: 'Total number of employees at the company. (NumberOfEmployees)',
                    sensitivityLevel: 'internal',
                },
                fax: { type: 'string', maxLength: 15, description: '(Fax)', sensitivityLevel: 'public' },
                phone: { type: 'string', maxLength: 15, description: '(Phone)', sensitivityLevel: 'public' },
                rating: {
                    type: 'string',
                    enum: ['Hot', 'Warm', 'Cold'],
                    description: '(Rating)',
                    sensitivityLevel: 'public',
                },
                website: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: '(Website)',
                    sensitivityLevel: 'public',
                },
                active: {
                    type: 'string',
                    enum: ['No', 'Yes'],
                    description: 'Active__c)',
                    sensitivityLevel: 'internal',
                },
                customerPriority: {
                    type: 'string',
                    enum: ['High', 'Low', 'Medium'],
                    description: '(CustomerPriority__c)',
                    sensitivityLevel: 'internal',
                },
                customerSatisfactionRating: {
                    type: 'number',
                    maxLength: 18,
                    description: '(Customer_Satisfaction_Rating__c)',
                    sensitivityLevel: 'internal',
                },
                developerPrefix: {
                    type: 'string',
                    maxLength: 4,
                    description: '4 character prefix to uniqify custom objects created by this developer (Developer_Prefix__c)',
                    sensitivityLevel: 'confidential',
                },
                isDupeAccount: {
                    type: 'boolean',
                    default: false,
                    description: '(Is_Dupe_Account__c)',
                    sensitivityLevel: 'internal',
                },
                isOldMCAccount: {
                    type: 'boolean',
                    default: false,
                    description: 'Checked if the Account was created before 2016-03-11 and is a Marketing Cloud Identity Account, otherwise, this field should be unchecked (Is_Old_MC_Account__c)',
                    sensitivityLevel: 'internal',
                },
                patchDevOrg: {
                    type: 'boolean',
                    default: false,
                    description: '(patchDevOrg__c)',
                    sensitivityLevel: 'internal',
                },
                ISVPartnerTier: {
                    type: 'string',
                    maxLength: 100,
                    description: '(ISVPartnerTier__c)',
                    sensitivityLevel: 'internal',
                },
                marketingCloudId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Marketing Cloud account Id (Marketing_Cloud_Id__c)',
                    sensitivityLevel: 'confidential',
                },
                masterPartnerAccount: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Master Partner Account Id of Partner Summary record in Org62 (Master_Partner_Account__c)',
                    sensitivityLevel: 'confidential',
                },
                nonProfitAccount: {
                    type: 'boolean',
                    default: false,
                    description: '(Non_Profit_Account__c)',
                    sensitivityLevel: 'internal',
                },
                numberofExperts: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(Number_of_Experts__c)',
                    sensitivityLevel: 'internal',
                },
                numberofLocations: {
                    type: 'integer',
                    maxLength: 3,
                    description: '(NumberofLocations__c)',
                    sensitivityLevel: 'internal',
                },
                numberofProjects: {
                    type: 'integer',
                    maxLength: 18,
                    description: '(Number_of_Projects__c)',
                    sensitivityLevel: 'internal',
                },
                org62AccountId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'AccountId in Org62 (Org62AccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                org62PartnerSummaryId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Id of Partner Summary record in Org62 (Org61ParnerSummaryId__c)',
                    sensitivityLevel: 'confidential',
                },
                orgCustomDomain: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce custom domain value if my domains enabled for the org (OrgCustomDomain__c)',
                    sensitivityLevel: 'confidential',
                },
                orgDomain: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Salesforce instance domain name where the account resides (OrgDomain__c)',
                    sensitivityLevel: 'confidential',
                },
                orgEdition: {
                    type: 'string',
                    maxLength: 32,
                    description: '(orgEdition__c)',
                    sensitivityLevel: 'confidential',
                },
                orgId: { type: 'string', maxLength: 18, description: '(orgId__c)', sensitivityLevel: 'confidential' },
                orgInstance: {
                    type: 'string',
                    maxLength: 8,
                    description: '(orgInstance__c)',
                    sensitivityLevel: 'confidential',
                },
                orgReleaseVersion: {
                    type: 'string',
                    maxLength: 20,
                    description: 'The Salesforce release version the org is on. (OrgReleaseVersion__c)',
                    sensitivityLevel: 'confidential',
                },
                orgStatus: {
                    type: 'string',
                    maxLength: 32,
                    description: '(orgStatus__c)',
                    sensitivityLevel: 'confidential',
                },
                partnerAccessRevoked: {
                    type: 'boolean',
                    default: false,
                    description: '(PartnerAccessRevoked__c)',
                    sensitivityLevel: 'internal',
                },
                partnerAccountId: {
                    type: 'string',
                    maxLength: 100,
                    description: '(PartnerAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                partnerCertificationGoal: {
                    type: 'integer',
                    maxLength: 18,
                    description: 'Partner Certification Goal represents a goal of the total number of certifications that the partner will have at the end of the fiscal year.',
                    sensitivityLevel: 'confidential',
                },
                partnerSupportLevel: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Indicates the Support Level for the Partner Account (PartnerSupportLevel__c)',
                    sensitivityLevel: 'internal',
                },
                partnerType: {
                    type: 'string',
                    enum: ['SI', 'ISV'],
                    description: '(Partner_Type__c)',
                    sensitivityLevel: 'internal',
                },
                pledge1Member: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates whether the partner has pledged 1% to charity (Pledge_1_Member__c)',
                    sensitivityLevel: 'internal',
                },
                prodAccountID: {
                    type: 'string',
                    maxLength: 100,
                    description: '(PartnerAccountId__c)',
                    sensitivityLevel: 'confidential',
                },
                sfdcOrgId: {
                    type: 'string',
                    maxLength: 18,
                    description: 'to match up for entitlements export (SFDC_OrgId__c)',
                    sensitivityLevel: 'confidential',
                },
                siPartnerTier: {
                    type: 'string',
                    maxLength: 100,
                    description: '(SIPartnerTier__c)',
                    sensitivityLevel: 'internal',
                },
                sla: {
                    type: 'string',
                    enum: ['Gold', 'Silver', 'Platinum', 'Bronze'],
                    description: 'null (SLA__c)',
                    sensitivityLevel: 'internal',
                },
                slaExpirationDate: {
                    type: 'string',
                    format: 'date',
                    description: '(SLAExpirationDate__c)',
                    sensitivityLevel: 'internal',
                },
                slaSerialNumber: {
                    type: 'string',
                    maxLength: 10,
                    description: '(SLASerialNumber__c)',
                    sensitivityLevel: 'confidential',
                },
                bfontcolorredSupportLevel: {
                    type: 'string',
                    enum: ['Silver', 'Platinum', 'Gold'],
                    description: '(bfontcolorredSupportLevel__c)',
                    sensitivityLevel: 'internal',
                },
                syncedwith62org: {
                    type: 'boolean',
                    default: false,
                    description: '(Synced_with_62_org__c)',
                    sensitivityLevel: 'internal',
                },
                diverseLeadership: {
                    type: 'boolean',
                    default: false,
                    description: 'At least 30% of this company’s executive leadership team belongs to one or more of the following groups: persons with disabilities, women, veterans, minorities (U.S. Only), or LGBTQ. (Diverse_Leadership__c)',
                    sensitivityLevel: 'confidential',
                },
                publicDiverseLeadership: {
                    type: 'boolean',
                    default: false,
                    description: 'Controls whether this identifier is displayed externally - ex: on AppExchange listings (Diverse_Leadership_Is_Public__c)',
                    sensitivityLevel: 'internal',
                },
                sustainableDevelopmentGoals: {
                    type: 'boolean',
                    default: false,
                    description: "This company has committed to one or more of the United Nation's Sustainable Development Goals, which focus on creating a better and more sustainable future for all. (Sustainable_Development_Goals__c)",
                    sensitivityLevel: 'confidential',
                },
                publicSustainableDevelopmentGoals: {
                    type: 'boolean',
                    default: false,
                    description: 'Controls whether this identifier is displayed externally - ex: on AppExchange listings (Sustainable_Development_Goals_Is_Public__c)',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extension': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_Extension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: [
                        'listing/extensions/force/listings/Listing/extensions/PackageListing',
                        'listing/extensions/force/listings/Listing/extensions/APIListing',
                        'listing/extensions/force/listings/Listing/extensions/ContentListing',
                        'listing/extensions/force/listings/Listing/extensions/CopilotListing',
                    ],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/force/listings/Listing/extensions/PackageListing'].get(),
                        schemas['listing/extensions/force/listings/Listing/extensions/APIListing'].get(),
                        schemas['listing/extensions/force/listings/Listing/extensions/ContentListing'].get(),
                        schemas['listing/extensions/force/listings/Listing/extensions/CopilotListing'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { extensionType: 'listing/extensions/force/listings/Listing/extensions/PackageListing' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extensions/CopilotListing': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extensions/CopilotListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_CopilotListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                gitHubRepositoryURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'GitHub/Repository URL for Component type of Listing (GitHub_Repository_URL__c)',
                    sensitivityLevel: 'public',
                },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
                provisionFlow: {
                    type: 'string',
                    default: '',
                    enum: ['Representative', 'External', 'Package'],
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extensions/ContentListing': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extensions/ContentListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_ContentListing',
            type: 'object',
            required: ['contentType'],
            properties: {
                contentType: {
                    type: 'string',
                    default: 'Article External',
                    enum: [
                        'Article External',
                        'Article Internal',
                        'Audio',
                        'eBook',
                        'Game',
                        'Trailhead',
                        'Infographic',
                        'Social',
                        'Video',
                        'Webinar',
                        'Guide',
                    ],
                    description: 'Applicable to Content Listings. Represents the specific type of content that will be featured. (ContentType__c)',
                    sensitivityLevel: 'public',
                },
                audioVideoDuration: {
                    type: 'string',
                    maxLength: 8,
                    description: 'Only applicable for Audio and Video Content listings. This will be the length of this piece of content. (AudioVideoDuration__c)',
                    sensitivityLevel: 'public',
                },
                authorDescription: {
                    type: 'string',
                    maxLength: 100,
                    description: 'A line of description about the Author as in <Name> is <Role> at <CompanyName> (AuthorDescription__c)',
                    sensitivityLevel: 'public',
                },
                displayAuthor: {
                    type: 'boolean',
                    default: true,
                    description: 'Will toggle on or off the author section at the bottom of the content listing as well as in the header (DisplayAuthor__c)',
                    sensitivityLevel: 'public',
                },
                displayNameOnTile: {
                    type: 'boolean',
                    default: true,
                    description: 'Indicates whether or not the title is displayed on the tile (DisplayNameOnTile__c)',
                    sensitivityLevel: 'public',
                },
                redirectURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'URL for where the content listing tile will take the user to. This is applicable only for Content type of Internal Article (RedirectURL__c)',
                    sensitivityLevel: 'public',
                },
                tileWidth: {
                    type: 'string',
                    enum: ['1x', '2x'],
                    description: 'Indicates whether the content tile is of single width or double width (TileWidth__c)',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { contentType: 'Article External' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extensions/APIListing': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extensions/APIListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_APIListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                provisionFlow: { type: 'string', enum: ['Representative', 'External'], sensitivityLevel: 'public' },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
                extensions: {
                    type: 'array',
                    description: 'The extensions that force API Listings can have',
                    items: schemas['listing/extensions/force/listings/Listing/extensions/APIListingExtension'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extensions/APIListingExtension': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extensions/APIListingExtension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_APIListingExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: ['listing/extensions/force/listings/Listing/extensions/APIListing/TestDrive'],
                },
                data: {
                    anyOf: [schemas['listing/extensions/force/listings/Listing/extensions/APIListing/TestDrive'].get()],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/force/listings/Listing/extensions/APIListing/TestDrive',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extensions/APIListing/TestDrive': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extensions/APIListing/TestDrive',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_APITestDrive',
            type: 'object',
            required: ['testDriveOrgID', 'testDrivePassword', 'testDriveUserName'],
            properties: {
                enableTestDrive: {
                    type: 'boolean',
                    default: false,
                    description: 'Does the listing have a test drive?',
                    sensitivityLevel: 'internal',
                },
                testDriveCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                testDriveOrgID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveOrgID__c)',
                    sensitivityLevel: 'internal',
                },
                testDrivePassword: {
                    type: 'string',
                    maxLength: 50,
                    description: '(TestDrivePassword__c)',
                    sensitivityLevel: 'confidential',
                },
                testDriveUserName: {
                    type: 'string',
                    maxLength: 80,
                    description: '(TestDriveUserName__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { testDriveOrgID: '', testDrivePassword: '', testDriveUserName: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extensions/PackageListing': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extensions/PackageListing',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_PackageListing',
            type: 'object',
            required: ['provisionFlow'],
            properties: {
                gitHubRepositoryURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'GitHub/Repository URL for Component type of Listing (GitHub_Repository_URL__c)',
                    sensitivityLevel: 'public',
                },
                installUrl: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'Install Url for Package-> External and API InstallURL__c',
                    sensitivityLevel: 'public',
                },
                solutionId: {
                    type: 'string',
                    description: 'The solution id for the package version solution stream',
                    sensitivityLevel: 'public',
                },
                provisionFlow: {
                    type: 'string',
                    default: '',
                    enum: ['Representative', 'External', 'Package'],
                    sensitivityLevel: 'public',
                },
                extensions: {
                    type: 'array',
                    description: 'The extensions that force Package Listings can have',
                    items: schemas['listing/extensions/force/listings/Listing/extensions/PackageListingExtension'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { provisionFlow: 'Representative' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extensions/PackageListingExtension': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extensions/PackageListingExtension',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_PackageListingExtension',
            type: 'object',
            required: ['extensionType', 'data'],
            properties: {
                extensionType: {
                    type: 'string',
                    enum: ['listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive'],
                },
                data: {
                    anyOf: [
                        schemas['listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                extensionType: 'listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive': {
        get: () => ({
            $id: 'listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Force_PackageTestDrive',
            type: 'object',
            required: ['testDriveOrgID', 'testDrivePassword', 'testDriveUserName'],
            properties: {
                enableTestDrive: {
                    type: 'boolean',
                    default: false,
                    description: 'Does the listing have a test drive?',
                    sensitivityLevel: 'internal',
                },
                testDriveCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                testDriveOrgID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveOrgID__c)',
                    sensitivityLevel: 'internal',
                },
                testDrivePassword: {
                    type: 'string',
                    maxLength: 50,
                    description: '(TestDrivePassword__c)',
                    sensitivityLevel: 'confidential',
                },
                testDriveUserName: {
                    type: 'string',
                    maxLength: 80,
                    description: '(TestDriveUserName__c)',
                    sensitivityLevel: 'confidential',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { testDriveOrgID: '', testDrivePassword: '', testDriveUserName: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugin': {
        get: () => ({
            $id: 'listing/plugin',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ListingPlugin',
            type: 'object',
            required: ['pluginType', 'data'],
            properties: {
                pluginType: {
                    type: 'string',
                    enum: [
                        'listing/plugins/Carousel',
                        'listing/plugins/Content',
                        'listing/plugins/LogoSet',
                        'listing/plugins/SupportInformation',
                        'listing/plugins/Demo',
                        'listing/plugins/TrialTemplate',
                        'listing/plugins/LeadTrialInformation',
                    ],
                },
                data: {
                    anyOf: [
                        schemas['listing/plugins/Carousel'].get(),
                        schemas['listing/plugins/Content'].get(),
                        schemas['listing/plugins/LogoSet'].get(),
                        schemas['listing/plugins/SupportInformation'].get(),
                        schemas['listing/plugins/Demo'].get(),
                        schemas['listing/plugins/TrialTemplate'].get(),
                        schemas['listing/plugins/LeadTrialInformation'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { pluginType: 'listing/plugins/Carousel' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/LeadTrialInformation': {
        get: () => ({
            $id: 'listing/plugins/LeadTrialInformation',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'LeadTrialInformation',
            type: 'object',
            required: [],
            properties: {
                leadsOrgID: {
                    type: 'string',
                    format: 'org-id',
                    maxLength: 18,
                    description: '(LeadsOrgId__c)',
                    sensitivityLevel: 'internal',
                },
                learnMoreCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: 'Salesforce campaign Id where leads are sent to',
                    sensitivityLevel: 'internal',
                },
                enableDemoLeads: {
                    type: 'boolean',
                    default: false,
                    description: '(EnableDemoLeads__c)',
                    sensitivityLevel: 'internal',
                },
                demoCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(DemoCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                enableInstallLeads: {
                    type: 'boolean',
                    default: false,
                    description: '(EnableInstallLeads__c)',
                    sensitivityLevel: 'internal',
                },
                installCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(InstallCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                enableLearnMoreLeads: {
                    type: 'boolean',
                    default: false,
                    description: '(EnableLearnMoreLeads__c)',
                    sensitivityLevel: 'internal',
                },
                enableTestDriveLeads: {
                    type: 'boolean',
                    default: false,
                    description: '(EnableTestDriveLeads__c)',
                    sensitivityLevel: 'internal',
                },
                testDriveCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TestDriveCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
                enableTrialLeads: {
                    type: 'boolean',
                    default: false,
                    description: '(EnableTrialLeads__c)',
                    sensitivityLevel: 'internal',
                },
                trialCampaignID: {
                    type: 'string',
                    maxLength: 18,
                    description: '(TrialCampaignID__c)',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/TrialTemplate': {
        get: () => ({
            $id: 'listing/plugins/TrialTemplate',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'TrialTemplate',
            type: 'object',
            required: [],
            properties: {
                solutionId: {
                    type: 'string',
                    minLength: 1,
                    description: 'The stream id for the associated Trial Template Solution',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Demo': {
        get: () => ({
            $id: 'listing/plugins/Demo',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Demo',
            type: 'object',
            required: ['items'],
            properties: {
                items: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['listing/plugins/Demo/DemoVideo'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { items: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Demo/DemoVideo': {
        get: () => ({
            $id: 'listing/plugins/Demo/DemoVideo',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'DemoVideo',
            type: 'object',
            required: ['videoType', 'external_id'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier for the content on Tz (Content__c.Id)',
                    sensitivityLevel: 'internal',
                },
                attachmentId: {
                    type: 'string',
                    maxLength: 18,
                    description: "The 18 character record ID for the attachment associated with this content object that stores the actual content material (e.g. .pdf or .swf file) (AttachmentID__c), it's null if it's generated on oaf",
                    sensitivityLevel: 'internal',
                },
                companyId: {
                    type: 'string',
                    maxLength: 100,
                    description: 'Company Identifier for Brainshark videos (CompanyId__c)',
                    sensitivityLevel: 'internal',
                },
                mediaId: {
                    type: 'string',
                    maxLength: 255,
                    description: 'This field is used to hold the non-generic information related to content Object. For content type demo - it is used to store youtube video id (ExternalId__c)',
                    sensitivityLevel: 'internal',
                },
                videoType: {
                    type: 'string',
                    enum: ['YouTube', 'Vimeo', 'Brainshark', 'Wistia', 'Vidyard'],
                    description: 'The type of video content (VideoType__c)',
                    sensitivityLevel: 'internal',
                },
                url: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The URL where the resource is located. This exists for legacy purposes only and publishers will not be able to upload new URLs in the future. (LocationURL__c)',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { external_id: '', videoType: 'YouTube' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/SupportInformation': {
        get: () => ({
            $id: 'listing/plugins/SupportInformation',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'SupportInformation',
            type: 'object',
            required: ['businessEmail'],
            properties: {
                reviewsEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 0,
                    maxLength: 255,
                    description: 'The email address to use for review emails for this listing. (ReviewsEmail__r.Email)',
                    sensitivityLevel: 'confidential',
                },
                businessEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 1,
                    maxLength: 255,
                    description: 'The email to use for business marketing for this listing. (BusinessMarketingEmail__r.Email)',
                    sensitivityLevel: 'confidential',
                },
                technicalEmail: {
                    type: 'string',
                    format: 'oaf-email',
                    minLength: 0,
                    maxLength: 255,
                    description: 'The email to use for non-customer technical support for this listing. (TechnicalEmail__r.Email)',
                    sensitivityLevel: 'confidential',
                },
                support24x7: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if support is available for your app 24 hours a day, 7 days a week. (Support24x7__c)',
                    sensitivityLevel: 'public',
                },
                supportDetails: {
                    type: 'string',
                    maxLength: 255,
                    description: 'Detailed information on the support provided by the publisher for this Listing. (SupportDetails__c)',
                    sensitivityLevel: 'public',
                },
                supportEmailAddress: {
                    type: 'string',
                    format: 'oaf-email',
                    maxLength: 255,
                    description: 'The email address for contacting the Publisher support team. (SupportEmailAddress__c)',
                    sensitivityLevel: 'public',
                },
                supportEmailCost: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if email support costs something beyond the standard app fee. (SupportEmailCost__c)',
                    sensitivityLevel: 'public',
                },
                supportKnowledgeBaseCost: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if knowledge base support costs something beyond the standard app fee. (SupportKnowledgeBaseCost__c)',
                    sensitivityLevel: 'public',
                },
                supportKnowledgeBaseURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The URL where customers can read your knowledge base to get support for your app. (SupportKnowledgeBaseURL__c)',
                    sensitivityLevel: 'public',
                },
                supportNotProvided: {
                    type: 'boolean',
                    default: true,
                    description: 'Indicates that no support is provided for the app by the publisher. (SupportNotProvided__c)',
                    sensitivityLevel: 'public',
                },
                supportOnlineChatCost: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if online chat support costs something beyond the standard app fee. (SupportOnlineChatCost__c)',
                    sensitivityLevel: 'public',
                },
                supportOnlineChatURL: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The URL where customers can chat online with you to get support for your app. (SupportOnlineChatURL__c)',
                    sensitivityLevel: 'public',
                },
                supportPhoneCost: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if phone support costs something beyond the standard app fee. (SupportPhoneCost__c)',
                    sensitivityLevel: 'public',
                },
                supportPhoneNumber: {
                    type: 'string',
                    description: 'The phone number for contacting the Publisher sales team. (SupportPhoneNumber__c)',
                    sensitivityLevel: 'public',
                },
                supportPremiumAvailable: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if premium support consulting partners are available for your app. (SupportPremiumAvailable__c)',
                    sensitivityLevel: 'public',
                },
                supportSLA: {
                    type: 'boolean',
                    default: false,
                    description: 'Indicates if a consulting partner level agreement (SLA) exists for your app. (SupportSLA__c)',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { businessEmail: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/LogoSet': {
        get: () => ({
            $id: 'listing/plugins/LogoSet',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'LogoSet',
            type: 'object',
            required: ['items'],
            properties: {
                items: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['listing/plugins/LogoSet/LogoSetItem'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { items: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/LogoSet/LogoSetItem': {
        get: () => ({
            $id: 'listing/plugins/LogoSet/LogoSetItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'LogoSetItem',
            type: 'object',
            required: ['logoType', 'mediaId', 'external_id'],
            properties: {
                logoType: {
                    type: 'string',
                    enum: ['Logo', 'Medium Logo', 'Big Logo', 'High Res Logo', 'High Res Svg', 'Small Svg Icon'],
                    description: 'The type of logo',
                    sensitivityLevel: 'internal',
                },
                mediaId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'This field is used to hold information required to display the image. It can be a URL to a partner community file or a UUID of a file hosted by the image upload service.',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier for the image logo.',
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { logoType: 'Logo', mediaId: '', external_id: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Content': {
        get: () => ({
            $id: 'listing/plugins/Content',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Content',
            type: 'object',
            description: 'The contents tied to a listing',
            required: ['items'],
            properties: {
                items: {
                    type: 'array',
                    default: [],
                    minItems: 0,
                    items: schemas['listing/plugins/Content/ContentItem'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { items: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Content/ContentItem': {
        get: () => ({
            $id: 'listing/plugins/Content/ContentItem',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ContentItem',
            type: 'object',
            required: ['type', 'data', 'external_id'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier for the content on Tz (Content__c.Id)',
                    sensitivityLevel: 'internal',
                },
                type: {
                    type: 'string',
                    enum: ['File', 'Url'],
                    description: 'Indicates the type of this content',
                    sensitivityLevel: 'internal',
                },
                data: {
                    anyOf: [
                        schemas['listing/plugins/Content/Items/ContentFile'].get(),
                        schemas['listing/plugins/Content/Items/ContentUrl'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { external_id: '', type: 'File' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Content/Items/ContentUrl': {
        get: () => ({
            $id: 'listing/plugins/Content/Items/ContentUrl',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ContentUrl',
            type: 'object',
            required: ['url', 'title', 'type'],
            properties: {
                title: {
                    type: 'string',
                    maxLength: 100,
                    description: 'The title/caption of the content. Required for data sheets, customization guides, whitepapers, customer testimonials, case studies, and webinars. (Title__c)',
                    sensitivityLevel: 'public',
                },
                type: {
                    type: 'string',
                    enum: [
                        'Data Sheet',
                        'Customer Testimonial',
                        'Case Study',
                        'Whitepaper',
                        'Webinar',
                        'Customization Guide',
                        'Customer Stories',
                        'Promotion',
                    ],
                    description: 'Indicates the type of this content (Type__c)',
                    sensitivityLevel: 'internal',
                },
                url: {
                    type: 'string',
                    format: 'oaf-url',
                    maxLength: 255,
                    description: 'The URL where the resource is located. This exists for legacy purposes only and publishers will not be able to upload new URLs in the future. (LocationURL__c)',
                    sensitivityLevel: 'public',
                },
                position: {
                    type: 'integer',
                    description: 'Used to control the order/position of this content item in relation to other content items',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { title: '', type: 'Data Sheet', url: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Content/Items/ContentFile': {
        get: () => ({
            $id: 'listing/plugins/Content/Items/ContentFile',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ContentFile',
            type: 'object',
            required: ['mediaId', 'title', 'type', 'typeExtension', 'external_id'],
            properties: {
                external_id: {
                    type: 'string',
                    description: 'The external identifier for the image (on Tz is the AttachmentWrapper__c)',
                    sensitivityLevel: 'internal',
                },
                typeExtension: {
                    type: 'string',
                    enum: ['Pdf'],
                    description: 'Indicates the extension of the of file',
                    sensitivityLevel: 'public',
                },
                fileName: {
                    type: 'string',
                    maxLength: 64,
                    description: 'This is the file name of the media Id uploaded',
                    sensitivityLevel: 'public',
                },
                mediaId: {
                    type: 'string',
                    maxLength: 255,
                    description: 'This field is used to hold the non-generic information related to content Object. For content type demo - it is used to store youtube video id (ExternalId__c)',
                    sensitivityLevel: 'internal',
                },
                title: {
                    type: 'string',
                    maxLength: 100,
                    description: 'The title/caption of the content. Required for data sheets, customization guides, whitepapers, customer testimonials, case studies, and webinars. (Title__c)',
                    sensitivityLevel: 'public',
                },
                type: {
                    type: 'string',
                    enum: [
                        'Data Sheet',
                        'Customer Testimonial',
                        'Case Study',
                        'Whitepaper',
                        'Webinar',
                        'Customization Guide',
                        'Customer Stories',
                        'Promotion',
                    ],
                    description: 'Indicates the type of this content (Type__c)',
                    sensitivityLevel: 'internal',
                },
                position: {
                    type: 'integer',
                    description: 'Used to control the order/position of this content item in relation to other content items',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { external_id: '', typeExtension: 'Pdf', mediaId: '', title: '', type: 'Data Sheet' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Carousel': {
        get: () => ({
            $id: 'listing/plugins/Carousel',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Carousel',
            type: 'object',
            required: ['items'],
            properties: {
                items: {
                    type: 'array',
                    minLength: 1,
                    description: 'The contents of the carousel',
                    items: schemas['listing/plugins/Carousel/Item'].get(),
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { items: [] };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Carousel/Item': {
        get: () => ({
            $id: 'listing/plugins/Carousel/Item',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'CarouselItem',
            type: 'object',
            required: ['type', 'data', 'external_id'],
            properties: {
                type: {
                    type: 'string',
                    enum: ['Video', 'Image'],
                    description: 'The type of this media',
                    sensitivityLevel: 'internal',
                },
                external_id: { type: 'string', description: 'Content record Id', sensitivityLevel: 'internal' },
                data: {
                    anyOf: [
                        schemas['listing/plugins/Carousel/Items/Image'].get(),
                        schemas['listing/plugins/Carousel/Items/Video'].get(),
                    ],
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { type: 'Video', external_id: '' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Carousel/Items/Video': {
        get: () => ({
            $id: 'listing/plugins/Carousel/Items/Video',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'CarouselVideo',
            type: 'object',
            required: ['videoType', 'caption', 'position', 'mediaId'],
            properties: {
                videoType: {
                    type: 'string',
                    enum: ['YouTube', 'Vidyard', 'Vimeo', 'Wistia', 'Brainshark'],
                    description: 'The video type of this media',
                    sensitivityLevel: 'internal',
                },
                caption: {
                    type: 'string',
                    maxLength: 100,
                    description: 'The caption of the media in the carousel',
                    sensitivityLevel: 'public',
                },
                mediaId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: "This field is used to hold information required to display the media item. If this is an image, then it can be a URL to a partner community file or a UUID of a file hosted by the image upload service, if it's a video it should be the video ID.",
                    sensitivityLevel: 'internal',
                },
                position: {
                    type: 'integer',
                    description: 'Used to control the order/position of this content item in relation to other content items (Position__c)',
                    sensitivityLevel: 'public',
                },
                videoStart: {
                    type: 'integer',
                    maxLength: 5,
                    description: 'Used to control the start time (in seconds) of the video',
                    sensitivityLevel: 'public',
                },
                videoEnd: {
                    type: 'integer',
                    maxLength: 5,
                    description: 'Used to control the end time (in seconds) of the video',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { videoType: 'YouTube', caption: '', mediaId: '', position: 0 };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/plugins/Carousel/Items/Image': {
        get: () => ({
            $id: 'listing/plugins/Carousel/Items/Image',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'CarouselImage',
            type: 'object',
            required: ['caption', 'altText', 'position', 'mediaId', 'external_id'],
            properties: {
                caption: {
                    type: 'string',
                    maxLength: 100,
                    description: 'The caption of the media in the carousel',
                    sensitivityLevel: 'public',
                },
                altText: {
                    type: 'string',
                    maxLength: 100,
                    description: 'The alt text of the media in the carousel',
                    sensitivityLevel: 'public',
                },
                mediaId: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: "This field is used to hold information required to display the media item. If this is an image, then it can be a URL to a partner community file or a UUID of a file hosted by the image upload service, if it's a video it should be the video ID.",
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The external identifier for the image (on Tz is the AttachmentWrapper__c)',
                    sensitivityLevel: 'internal',
                },
                position: {
                    type: 'integer',
                    description: 'Used to control the order/position of this content item in relation to other content items (Position__c)',
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { caption: '', altText: '', mediaId: '', external_id: '', position: 0 };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'listing/ListingCategories': {
        get: () => ({
            description: 'New field to hold the listing categories.',
            sensitivityLevel: 'public',
            $id: 'listing/ListingCategories',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'Listing_Categories',
            type: 'object',
            properties: {
                sales: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The sales categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: [
                                    'contractManagement',
                                    'forecasting',
                                    'geolocation',
                                    'partnerManagement',
                                    'salesProductivity',
                                    'quotesAndOrders',
                                    'salesMethodologies',
                                    'leadAndOpportunityManagement',
                                    'salesIntelligence',
                                ],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                productivity: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The productivity categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: [
                                    'documentManagement',
                                    'projectManagement',
                                    'documentGeneration',
                                    'emailAndCalendarSync',
                                    'alerts',
                                    'processManagement',
                                    'timeAndDate',
                                ],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                customerService: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The customer service categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: [
                                    'agentProductivity',
                                    'fieldService',
                                    'telephony',
                                    'caseManagement',
                                    'routePlanning',
                                ],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                marketing: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The marketing categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: [
                                    'campaignManagement',
                                    'eventManagement',
                                    'marketingAutomation',
                                    'massEmailsAndMessaging',
                                    'websites',
                                    'accountBasedMarketing',
                                    'surveys',
                                    'marketingAndIntelligence',
                                    'feeds',
                                    'loyalty',
                                    'personalization',
                                    'socialChannels',
                                    'testingAndSegmentation',
                                ],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                itAndAdministration: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The IT & administration categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: [
                                    'adminAndDeveloperTools',
                                    'integration',
                                    'itManagement',
                                    'security',
                                    'informationManagement',
                                    'dataManagement',
                                    'dataBackupAndStorage',
                                    'dataMigration',
                                    'augmentedRealityAndVirtualReality',
                                    'contentDeliveryNetwork',
                                    'contentManagementSystem',
                                    'developerTools',
                                    'searchAndRecommendation',
                                    'auditAndCompliance',
                                    'translation',
                                ],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                analytics: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The analytics categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: [
                                    'dashboardsAndReports',
                                    'dataCleansing',
                                    'dataVisualization',
                                    'analyticsAndSiteMonitoring',
                                ],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                finance: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The finance categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: ['accounting', 'timeAndExpense', 'grantManagement', 'compensationManagement'],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                collaboration: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The collaboration categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: { type: 'string', enum: ['chatAndWebConferencing', 'conversationalCommerce'] },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                commerce: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The commerce categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: [
                                    'shippingFulfillmentAndLogistics',
                                    'paymentsProcessing',
                                    'liveCommerce',
                                    'marketplace',
                                    'pointOfSaleAndInStore',
                                    'productInformationManagement',
                                    'ratingsAndReviews',
                                    'subscriptions',
                                    'warrantyAndReturnsManagement',
                                    'eCommerce',
                                ],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
                enterpriseResourcePlanning: {
                    type: 'object',
                    required: ['isSelected', 'categories'],
                    properties: {
                        isSelected: { type: 'boolean', default: false },
                        categories: {
                            type: 'array',
                            description: 'The sales categories that a listing can have',
                            uniqueItems: true,
                            minItems: 0,
                            items: {
                                type: 'string',
                                enum: [
                                    'warehouseManagementSystem',
                                    'punchoutSystem',
                                    'orderAndInventoryManagement',
                                    'humanResources',
                                    'peopleManagement',
                                ],
                            },
                        },
                    },
                    sensitivityLevel: 'public',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {};
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'chat/BaseChat': {
        get: () => ({
            $id: 'chat/BaseChat',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'BaseChat',
            type: 'object',
            required: ['token', 'provider', 'listing'],
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    description: 'The oAF identifier of the Chat',
                    sensitivityLevel: 'internal',
                },
                external_id: {
                    type: 'string',
                    description: 'The identifier of the chat stream',
                    sensitivityLevel: 'internal',
                },
                listing: {
                    type: 'string',
                    description: 'UUID reference or External Id to the Listing stream associated to this Chat',
                    sensitivityLevel: 'internal',
                },
                token: {
                    type: 'string',
                    minLength: 1,
                    maxLength: 255,
                    description: 'Token granted by Chat Provider',
                    sensitivityLevel: 'internal',
                },
                active: {
                    type: 'boolean',
                    default: false,
                    description: 'Flag to indicate that chat is enabled for this listing.',
                    sensitivityLevel: 'internal',
                },
                provider: {
                    type: 'string',
                    default: '',
                    description: 'Name of the chat provider',
                    enum: ['Qualified'],
                    sensitivityLevel: 'internal',
                },
            },
            additionalProperties: false,
        }),
        new: (override) => {
            const original = { listing: '', token: '', provider: 'Qualified' };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/EventModel': {
        get: () => ({
            $id: 'dtos/EventModel',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'EventModel',
            description: 'EventModel schema',
            type: 'object',
            properties: {
                idempotency_id: { type: 'string' },
                public_id: {
                    type: ['string', 'null'],
                    description: 'Customer facing Id, in OAF native records this Id will be null.',
                },
                id: { type: 'string', description: 'Id of the record in OAF' },
                schema_version: { type: 'string', description: 'schema version for the record in OAF' },
                event_type: { type: 'string', description: 'Type of event for this topic' },
                type: {
                    type: 'string',
                    description: 'Type of record that triggered this event eg: Listing / Publisher / Solutions / ...etc',
                },
                stream_event: {
                    type: 'string',
                    enum: ['stream.change', 'stream.create'],
                    description: 'Stream event that triggered this event in the first place',
                },
                url: { type: 'string', description: "Endpoint to retrieve record's data" },
                timestamp: { type: 'string', description: 'Event timestamp', format: 'date' },
            },
            required: ['idempotency_id', 'id', 'event_type', 'type', 'stream_event', 'timestamp'],
            additionalProperties: false,
        }),
        new: (override) => {
            const original = {
                idempotency_id: '',
                id: '',
                event_type: '',
                type: '',
                stream_event: 'stream.change',
                timestamp: '',
            };
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/FeatureFlags': {
        get: () => ({
            $id: 'dtos/FeatureFlags',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'FeatureFlags',
            description: 'An enum consisting of all possible feature flags.',
            enum: ['partner_internal_endpoints', 'partner_rlmorg_endpoints'],
        }),
        new: (override) => {
            const original = 'partner_internal_endpoints';
            return (override != null ? merge(original, override) : original || {});
        },
    },
    'dtos/ErrorCodes': {
        get: () => ({
            $id: 'dtos/ErrorCodes',
            $schema: 'http://json-schema.org/draft-07/schema#',
            title: 'ErrorCodes',
            description: 'An enum of error codes used to look up localized text on clients.',
            enum: [
                'invalid_or_missing_id',
                'name_must_be_type_string',
                'name_cannot_be_empty',
                'post_to_tt_org',
                'org_already_connected',
                'invalid_or_missing_owner_relationship',
                'unable_to_create_stream',
                'id_provided_invalid_uuid',
                'stream_does_not_exist',
                'publisher_has_no_force_child',
                'publisher_force_has_no_connected_orgs_extension',
                'user_does_not_have_access_to_the_requested_resource',
                'not_found',
                'force_package_not_found',
                'bad_request',
                'invalid_projection',
                'vault_org_failed_to_store_credentials',
                'vault_org_failed_to_delete_credentials',
                'vault_org_failed_to_store_file',
                'vault_org_failed_to_delete_file',
                'projection_creation_timed_out',
                'invalid_schema_version',
                'invalid_pricing_plans',
                'invalid_pricing_model_type',
                'payment_type_not_allowed',
                'multiple_sr_payments',
                'sr_payment_stream_already_exists',
                'precondition_failed',
                'multiple_streams',
                'database',
                'vault_org_failed_to_publish_platform_event',
                'send_security_review_to_org62_failed',
                'failed_to_publish_platform_event',
                'lmo_already_set',
                'login_must_use_security_token',
                'invalid_login',
                'username_password_incorrect',
                'lma_not_installed_in_org',
                'rlm_org_product_creation_error',
                'rlm_org_attribute_creation_error',
                'rlm_org_attribute_deletion_error',
                'rlm_org_plan_attribute_error',
                'rlm_org_product_classification_creation_error',
                'rlm_org_pricing_plan_option_error',
                'rlm_org_failed_to_store_file',
                'rlm_org_failed_to_delete_file',
                'missing_package_version_id',
                'missing_test_drive',
                'invalid_listing_relation',
            ],
        }),
        new: (override) => {
            const original = 'invalid_or_missing_id';
            return (override != null ? merge(original, override) : original || {});
        },
    },
};
//# sourceMappingURL=oafv1_schema_registry.js.map